import React, { useEffect, useState, useRef, useMemo } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { makeStyles, Grid, Box } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "react-tippy";
import DeleteForeverIcon from "@material-ui/icons/DeleteForeverOutlined";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { Select } from "antd";

import {
  formatDateBySetting,
  convertValuesFM,
  getResponse,
  converDateFormatForPicker,
  calculateTotalDirectLabor,
  calculateRemainingForecastDirectLabor,
  calculateItemTotalDirectLabor,
  calculateRemainingForecastDirectLaborTotal,
  calculateItemTotalDirectLaborTotal,
  calculateRemainingForecastDirectLaborAdjustment,
  calculateItemTotalDirectLaborAdjustment,
  calculateTotalOtherDirectCost,
  calculateRemainingForecastOtherDirectCost,
  calculateRemainingForecastOtherDirectCostTotal,
  calculateItemTotalOtherDirectCost,
  calculateItemTotalDirectOtherDirectCost,
  calculateTotalMonthlyMargin,
  calculateNetProfit,
  calculateNetProfitPecentage,
  calculateTotalRemainingForecastMargin,
  calculateTotalMarginTotal,
  calculateNetProfitRemainingForecast,
  calculateNetProfitTotal,
  calculateNetProfitPecentageRemainingForecast,
  calculateNetProfitPecentageTotal,
  calculateDirectLaborMargin,
  calculateOtherDirectCostBurdenCost,
  calculateOtherDirectCostRevenue,
  calculateDirectLaborBurdenCost,
  calculateDirectLaborRevenue,
  calculateTotalRevenueForCLIN,
  calculateTotalContractFunded,
  calculateTotalEstCompletion,
  calculateMonthlyRevenueForCLIN,
  calculateMonthlyRevenue,
  calculateRemainingForecastRevenueForCLIN,
  calculateRemainingForecastRevenue,
  calculateFFPESTRevenueById,
  calculateFFPTotalESTRevenue,
  calculateFFPTotalESTRevenueByMonth,
  calculateFFPForecastRevenueById,
  calculateFFPTotalForecastRevenue,
  calculateNetProfitFFP,
  calculateNetProfitPecentageFFP,
  calculateNetProfitRemainingForecastFFP,
  calculateNetProfitTotalFFP,
  calculateNetProfitPecentageRemainingForecastFFP,
  calculateNetProfitPecentageTotalFFP,
  calculateRevenueAdjustementForMonth,
  calculateRevenueAdjustmentITD,
  calculateRevenueAdjustmentRemainingForecast,
  calculateRevenueAdjustmentTotal,
  calculateMonthlyRevenueForMargin,
  calculateMarginITDTotal,
  calculateITDMarginNetProfit,
  calculateNetProfitPecentageITD,
  convertToPlain,
  roundTwoDecimals,
  calculateCostRateLoaded,
  calculateTotalHours,
  calculateFFPITDNetProfit,
  calculateFFPITDNetProfitPercentage,
  getYearlyWorkingDays,
  getWeekdaysInMonth,
  calculateDirectLaborBurdenCostOT,
  calculateDirectLaborRevenueOT,
  calculateDirectLaborCostRateUnloaded,
  calculateEscalationIterationCount,
  parseLocalDate,
  getYearOnly,
  getMonthOnly,
  getDateOnly,
  calculateFFPTotalYTDRevenue,
} from "../../../shared-resources/utils";
import {
  costRateTypes,
  hourTypes,
  yesNoDdl,
} from "../../../shared-resources/dumpData";
import {
  detailedViewWidths,
  workingHoursPerDay,
} from "../../../shared-resources/constants";
import TableFilterSelect from "../../../common-components/TableFilterSelect";
import { PaginationData } from "../../../common-components/PaginationData";
import ConfirmationDialog from "../../../common-components/ConfirmationDialog";
import {
  deleteUnnamedResourceAPI,
  updateRevenueAPI,
  deleteODCAPI,
} from "../../../api/financial-management-api";
import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import CustomDatePicker from "../../../common-components/CustomDatePicker";

const excludedItemsForMonthly = [
  "ITD",
  "Remaining Forecast",
  "Total",
  "Other Year Actual",
  "Other Year Forecast",
];

const useStyles = makeStyles((theme) => ({
  headDataLabel: {
    height: "32px",
    textAlign: "center",
    alignContent: "center",
    fontWeight: 600,
    marginRight: "16px",
  },
  headDataTextBox: {
    height: "32px",
    fontWeight: 600,
    marginRight: "16px",
  },
  headDataValue: {
    height: "32px",
    textAlign: "center",
    alignContent: "center",
    width: "90px",
    border: "1px solid #6e6d6d",
    borderRadius: "5px",
    marginRight: "24px",
  },
  metaData: {
    width: "72px",
    textAlign: "center",
    alignContent: "center",
  },
  tableTitle: {
    width: "220px",
    height: "36px",
    padding: "0 0 0 12px",
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#000",
    borderRadius: "0 10px 0 0",
    display: "flex",
    alignItems: "center",
  },
  statusLabel: {
    fontSize: "13px",
    fontWeight: 600,
    marginRight: "6px",
  },
  highStatus: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    background: "#c6efce",
    marginRight: "16px",
  },
  mediumStatus: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    background: "#ffeb9c",
    marginRight: "16px",
  },
  lowStatus: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    background: "#ffc7ce",
    marginRight: "16px",
  },
  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
    float: "left",
    marginTop: "2px",
  },
  editIconDate: {
    color: "#0070D2",
    fontSize: "14px",
  },
  editText: {
    color: "#0070D2",
    marginLeft: "4px",
    fontWeight: 600,
    fontSize: "13px",
  },
  editBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "2px 8px",
    cursor: "pointer",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
  },
  saveBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginRight: "8px",
  },
  exceedsHours: {
    color: "red",
  },

  tooltipGrid: {
    background: "#4B5558",
    color: "#fff",
    width: "auto",
    padding: "4px 8px",
  },

  checkCircleIcon: {
    fontSize: "18px",
    color: "#075e07",
    cursor: "pointer",
  },
  cancelIcon: {
    fontSize: "18px",
    color: "red",
    cursor: "pointer",
  },
}));

const reimbursementItems = [
  { id: true, text: "Yes" },
  { id: false, text: "No" },
];

const billableItems = [
  { id: true, text: "Billable" },
  { id: false, text: "Unbillable" },
];

const years = [
  { id: 2024, text: 2024 },
  { id: 2025, text: 2025 },
];
const monthHeaderWidths = (detailedType) => ({
  minWidth: detailedType === "FFP" ? "200px" : "300px",
  maxWidth: detailedType === "FFP" ? "200px" : "300px",
});

const secWidth = (detailedType) => {
  let width = "92px";
  if (detailedType === "FFP") {
    width = "100px";
  } else if (detailedType === "Cost Plus") {
    width = "89px";
  }

  return {
    minWidth: width,
    maxWidth: width,
  };
};

const finalHeaderWidths = (detailedType) => ({
  minWidth: detailedType === "FFP" ? "220px" : "320px",
  maxWidth: detailedType === "FFP" ? "220px" : "320px",
});
const firstHeaderWidth = (detailedType) => ({
  minWidth: detailedType === "TM" ? "260px" : "185px",
  maxWidth: detailedType === "TM" ? "260px" : "185px",
});

const getDate = (date) => {
  if (date && date !== "") {
    const dateVal =
      typeof date === "string"
        ? new Date(date.replace(/-/g, "/"))
        : new Date(date);
    return dateVal;
  }
  return null;
};

const CostPlus = ({
  detailedType,
  changedAPIData,
  udpatedRates,
  changedRatesYear,
  contractYearValue,
  version,
  isEdit,
  isEditFee,
  setIsEdit,
  setIsEditFee,
  handleAddNewDirectLabor,
  handleClickViewRates,
  viewRatesData,
  handleAddNewODC,
  isSaveClickUpdateRates,
  updateIsSaveClickUpdateRates,
  onClickDirectLaborDetails,
  contractId,
  updateClinReviseDate,
  getVersionStatus,
  yearValue,
  otTypes,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const revenuTableRef = useRef(null);
  const directLabourRef = useRef(null);
  const otherDirectCostsRef = useRef(null);
  const marginRef = useRef(null);
  const limits = [5, 10, 15, 20, 25];
  const [search, setSearch] = useState("");
  const [searchLcat, setSearchLcat] = useState("");

  const [dateFormat, setDateFormat] = useState("DD/MM/YYYY");
  const [directLaborCostBind, setDirectLaborCostBind] = useState();
  const [originalDirectLaborData, setOriginalDirectLaborData] = useState();
  const [otherDirectCostBind, setOtherDirectCostBind] = useState();
  const [originalOtherDirectDirectCost, setOriginalOtherDirectCost] =
    useState();
  const [revenueBind, setRevenueBind] = useState();
  const [originalRevenue, setOriginalRevenue] = useState();
  const [marginBind, setMarginBind] = useState();
  const [headersData, setHeadersData] = useState([]);
  const [gaRate, setGaRate] = useState();
  const [smAndH, setSmAndH] = useState();
  const [nonLaborPer, setNonLaborPer] = useState();
  const [feeLabor, setFeeLabor] = useState();
  const [feeSubcon, setFeeSubcon] = useState();
  const [filteredRevenue, setFilteredRevenue] = useState([]);
  const [filteredDirectLabor, setFilteredDirectLabor] = useState([]);
  const [filteredOtherDirectCost, setFilteredOtherDirectCost] = useState([]);
  const [revenueSort, setRevenueSort] = useState({
    key: null,
    direction: "asc",
  });
  const [directLaborSort, setDirectLaborSort] = useState({
    key: null,
    direction: "asc",
  });
  const [otherDirectCostSort, setOtherDirectCostSort] = useState({
    key: null,
    direction: "asc",
  });
  const [deleteIdDL, setDeleteIdDL] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [deleteIdODC, setDeleteIdODC] = useState("");
  const [isDialogOpenODC, setIsDialogOpenODC] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [isEditEndDate, setIsEditEndDate] = useState(false);
  const [dateEditedId, setDateEditedId] = useState("");
  const [updatedReviseDate, setUpdatedReviseDate] = useState(null);
  const [costRateType, setCostRateType] = useState("U");
  const [hourType, setHourType] = useState("H");

  const firstheaderwidth = firstHeaderWidth(detailedType);
  const monthheaderwidths = monthHeaderWidths(detailedType);
  const finalheaderwidths = finalHeaderWidths(detailedType);
  const monthSubHeaderWidthsValue = {
    minWidth: "100px",
    maxWidth: "100px",
  };

  const secondheaderwidth = secWidth(detailedType);
  const monthsubheaderwidths = monthSubHeaderWidthsValue;
  const finalheadersubwidths = {
    wide: { minWidth: "120px", maxWidth: "120px", paddingLeft: "2px" }, // used for unburden cost & hours
    narrow: { minWidth: "100px", maxWidth: "100px" }, // used for burden cost & revenue
  };

  const generalSettingsData = useSelector(
    (state) => state.adminReducer.generalSettingsData,
  );

  const directLaborDetailsData = useSelector(
    (state) => state.financialManagementReducer.directLaborDetailsData,
  );

  const otherDirectCostData = useSelector(
    (state) => state.financialManagementReducer.otherDirectCostData,
  );

  const revenueData = useSelector(
    (state) => state.financialManagementReducer.revenueData,
  );

  const marginData = useSelector(
    (state) => state.financialManagementReducer.marginData,
  );

  const detailedViewRatesData = useSelector(
    (state) => state.financialManagementReducer.detailedViewRatesData,
  );

  const contractYearsData = useSelector(
    (state) => state.financialManagementReducer.contractYearsData,
  );

  const versionsData = useSelector(
    (state) => state.financialManagementReducer.versionsData,
  );

  const detailedViewHeadersData = useSelector(
    (state) => state.financialManagementReducer.detailedViewHeadersData,
  );

  const bindOTTypes = () => {
    const data = [];
    otTypes.forEach((item) => {
      data.push({ id: item.otTypeId, text: item.otDescription });
    });
    return data;
  };

  const getOTFactorById = (id) => {
    return otTypes.filter((val) => val.otTypeId === id)[0]?.factor || 1;
  };

  const getOTFixedAmtById = (id) => {
    return otTypes.filter((val) => val.otTypeId === id)[0]?.fixedAmt || 0;
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onDeleteDirectLaborClick = (id) => {
    setDeleteIdDL(id);
    setIsDialogOpen(true);
  };

  const onDeleteOtherDirectCostClick = (id) => {
    setDeleteIdODC(id);
    setIsDialogOpenODC(true);
  };

  const okConfirmClick = (val) => {
    if (val) {
      setLoading(true);
      deleteUnnamedResourceAPI(contractId, detailedType, deleteIdDL).then(
        (res) => {
          setLoading(false);
          if (res.status === 200) {
            setEmptyErrMsg(true);
            setMsgType("success");
            setMsgText("Clin deleted successfully");
            setIsDialogOpen(false);
            setDeleteIdDL("");
            const directLaborCostSave = JSON.parse(
              JSON.stringify(originalDirectLaborData),
            );
            const directLaborCostChanged = JSON.parse(
              JSON.stringify(directLaborCostBind),
            );
            const otherDirectCostSave = JSON.parse(
              JSON.stringify(originalOtherDirectDirectCost),
            );
            const revenueSave = JSON.parse(JSON.stringify(revenueBind));
            revenueSave.revenueDetailList.forEach((item) => {
              item.monthExpenseDetail = item.monthExpenseDetail.filter(
                (val) => !val.isDummy,
              );
            });
            revenueSave.totalRevenue = revenueSave.totalRevenue.filter(
              (val) => !val.isDummy,
            );
            directLaborCostSave.getDirectLaborDetailList =
              directLaborCostSave.getDirectLaborDetailList.filter(
                (val) => val.dlId !== deleteIdDL,
              );
            directLaborCostSave.getDirectLaborDetailList.forEach((item) => {
              item.monthExpenseDetail.forEach((val) => {
                val.hours = Number(val.hours);
              });
              item.monthExpenseDetail = item.monthExpenseDetail.filter(
                (val) => !val.isDummy,
              );
            });
            directLaborCostSave.adjustment =
              directLaborCostSave.adjustment.filter((val) => !val.isDummy);
            directLaborCostSave.totalDirectLaborCost =
              directLaborCostSave.totalDirectLaborCost.filter(
                (val) => !val.isDummy,
              );

            directLaborCostChanged.getDirectLaborDetailList =
              directLaborCostChanged.getDirectLaborDetailList.filter(
                (val) => val.dlId !== deleteIdDL,
              );
            directLaborCostChanged.getDirectLaborDetailList.forEach((item) => {
              item.monthExpenseDetail.forEach((val) => {
                val.hours = Number(val.hours);
              });
            });

            setDirectLaborCostBind(directLaborCostChanged);
            setOriginalDirectLaborData(directLaborCostSave);
            if (detailedType !== "FFP") {
              const updatedData = JSON.parse(JSON.stringify(revenueSave));
              updatedData.revenueDetailList.map((item, i) => {
                item.isUpdated = true;
                const totalRevenue = calculateTotalRevenueForCLIN(
                  item.clin,
                  directLaborCostSave,
                  otherDirectCostSave,
                );
                item.estCompletion = totalRevenue;
                item.remainingFund =
                  Math.round(
                    Number(
                      item.fundedValue - totalRevenue - item.priorYearActual,
                    ) * 100,
                  ) / 100;
                item.monthExpenseDetail.forEach((monthVal) => {
                  if (
                    monthVal.type.toLowerCase() === "forecast" &&
                    excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
                  ) {
                    monthVal.isUpdated = true;
                    monthVal.revenue = calculateMonthlyRevenueForCLIN(
                      item.clin,
                      monthVal.monthYear,
                      directLaborCostSave,
                      otherDirectCostSave,
                    );
                  }
                });
              });
              updateRevenueAPI(
                contractId,
                detailedType,
                version,
                updatedData,
                yearValue,
              ).then((res) => {});
            }
          } else {
            setMsgType("error");
            setMsgText("Error in deleting");
          }
        },
      );
    }
  };

  const okConfirmClickODC = (val) => {
    if (val) {
      setLoading(true);
      deleteODCAPI(detailedType, deleteIdODC).then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setEmptyErrMsg(true);
          setMsgType("success");
          setMsgText("Clin deleted successfully");
          setIsDialogOpenODC(false);
          const deletedItem = deleteIdODC;
          setDeleteIdODC("");
          const directLaborCostSave = JSON.parse(
            JSON.stringify(originalDirectLaborData),
          );
          const otherDirectCostSave = JSON.parse(
            JSON.stringify(originalOtherDirectDirectCost),
          );
          const otherDirectCostChanged = JSON.parse(
            JSON.stringify(otherDirectCostBind),
          );
          const revenueSave = JSON.parse(JSON.stringify(revenueBind));
          revenueSave.revenueDetailList.forEach((item) => {
            item.monthExpenseDetail = item.monthExpenseDetail.filter(
              (val) => !val.isDummy,
            );
          });
          revenueSave.totalRevenue = revenueSave.totalRevenue.filter(
            (val) => !val.isDummy,
          );
          otherDirectCostSave.otherDirectLabourDetailList =
            otherDirectCostSave.otherDirectLabourDetailList.filter(
              (val) => val.odlId !== deletedItem,
            );
          otherDirectCostSave.otherDirectLabourDetailList.forEach((item) => {
            item.monthExpenseDetail.forEach((val) => {
              val.hours = Number(val.hours);
            });
            item.monthExpenseDetail = item.monthExpenseDetail.filter(
              (val) => !val.isDummy,
            );
          });
          otherDirectCostSave.adjustment =
            otherDirectCostSave.adjustment.filter((val) => !val.isDummy);
          otherDirectCostSave.totalDirectLaborCost =
            otherDirectCostSave.totalDirectLaborCost.filter(
              (val) => !val.isDummy,
            );

          otherDirectCostChanged.otherDirectLabourDetailList =
            otherDirectCostChanged.otherDirectLabourDetailList.filter(
              (val) => val.odlId !== deletedItem,
            );
          otherDirectCostChanged.otherDirectLabourDetailList.forEach((item) => {
            item.monthExpenseDetail.forEach((val) => {
              val.hours = Number(val.hours);
            });
          });

          setOtherDirectCostBind(otherDirectCostChanged);
          setOriginalOtherDirectCost(otherDirectCostSave);
          if (detailedType !== "FFP") {
            const updatedData = JSON.parse(JSON.stringify(revenueSave));
            updatedData.revenueDetailList.map((item, i) => {
              item.isUpdated = true;
              const totalRevenue = calculateTotalRevenueForCLIN(
                item.clin,
                directLaborCostSave,
                otherDirectCostSave,
              );
              item.estCompletion = totalRevenue;
              item.remainingFund =
                Math.round(
                  Number(
                    item.fundedValue - totalRevenue - item.priorYearActual,
                  ) * 100,
                ) / 100;
              item.monthExpenseDetail.forEach((monthVal) => {
                if (
                  monthVal.type.toLowerCase() === "forecast" &&
                  excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
                ) {
                  monthVal.isUpdated = true;
                  monthVal.revenue = calculateMonthlyRevenueForCLIN(
                    item.clin,
                    monthVal.monthYear,
                    directLaborCostSave,
                    otherDirectCostSave,
                  );
                }
              });
            });
            updateRevenueAPI(
              contractId,
              detailedType,
              version,
              updatedData,
              yearValue,
            ).then((res) => {});
          }
        } else {
          setMsgType("error");
          setMsgText("Error in deleting");
        }
      });
    }
  };

  const cancelConfirmClick = () => {
    setIsDialogOpen(false);
    setDeleteIdDL("");
  };

  const cancelConfirmClickODC = () => {
    setIsDialogOpenODC(false);
    setDeleteIdODC("");
  };

  useEffect(() => {
    if (detailedViewRatesData && detailedViewRatesData.status === 200) {
      setGaRate(detailedViewRatesData.data.gAndA);
      setSmAndH(detailedViewRatesData.data.smAndH);
      if (detailedType === "Cost Plus") {
        setNonLaborPer(detailedViewRatesData.data.cpFeeNonLabor);
        setFeeLabor(detailedViewRatesData.data.cpFeeLabor);
        setFeeSubcon(detailedViewRatesData.data.cpFeeSubCon);
      }
      if (detailedType === "TM") {
        setFeeLabor(0);
        setNonLaborPer(detailedViewRatesData.data.tmFeeNonLabor);
        setFeeSubcon(detailedViewRatesData.data.tmFeeSubCon);
      }
      if (detailedType === "FFP") {
        setNonLaborPer(detailedViewRatesData.data.ffpFeeNonLabor);
        setFeeLabor(detailedViewRatesData.data.ffpFeeLabor);
        setFeeSubcon(detailedViewRatesData.data.ffpFeeSubCon);
      }
    }
  }, [detailedViewRatesData]);

  useEffect(() => {
    if (detailedViewHeadersData && detailedViewHeadersData.status === 200) {
      setHeadersData(detailedViewHeadersData.data);
    }
  }, [detailedViewHeadersData]);

  const addDummyRevenue = (data) => {
    const changedData = JSON.parse(JSON.stringify(data));
    changedData.revenueDetailList.forEach((item) => {
      const monthData = [];
      headersData.forEach((header) => {
        if (
          item.monthExpenseDetail.filter(
            (val) => val.monthYear === header.heading,
          ).length > 0
        )
          monthData.push({
            ...item.monthExpenseDetail.filter(
              (val) => val.monthYear === header.heading,
            )[0],
          });
        else {
          monthData.push({
            adjustedRevenue: null,
            adjustmentRevenue: null,
            contractId: "",
            expenseDate: "",
            id: 0,
            isUpdated: false,
            monthYear: header.heading,
            revenue: 0,
            rvId: 0,
            type: "Actual",
            isDummy: true,
          });
        }
      });
      if (
        item.monthExpenseDetail.filter((val) => val.monthYear === "ITD")
          .length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "ITD",
          )[0],
        });
      } else {
        monthData.push({
          adjustedRevenue: null,
          adjustmentRevenue: null,
          contractId: "",
          expenseDate: "",
          id: 0,
          isUpdated: false,
          monthYear: "ITD",
          revenue: 0,
          rvId: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter(
          (val) => val.monthYear === "Remaining Forecast",
        ).length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Remaining Forecast",
          )[0],
        });
      } else {
        monthData.push({
          adjustedRevenue: null,
          adjustmentRevenue: null,
          contractId: "",
          expenseDate: "",
          id: 0,
          isUpdated: false,
          monthYear: "Remaining Forecast",
          revenue: 0,
          rvId: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter((val) => val.monthYear === "Total")
          .length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Total",
          )[0],
        });
      } else {
        monthData.push({
          adjustedRevenue: null,
          adjustmentRevenue: null,
          contractId: "",
          expenseDate: "",
          id: 0,
          isUpdated: false,
          monthYear: "Total",
          revenue: 0,
          rvId: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter(
          (val) => val.monthYear === "Other Year Actual",
        ).length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Other Year Actual",
          )[0],
        });
      } else {
        monthData.push({
          adjustedRevenue: null,
          adjustmentRevenue: null,
          contractId: "",
          expenseDate: "",
          id: 0,
          isUpdated: false,
          monthYear: "Other Year Actual",
          revenue: 0,
          rvId: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter(
          (val) => val.monthYear === "Other Year Forecast",
        ).length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Other Year Forecast",
          )[0],
        });
      } else {
        monthData.push({
          adjustedRevenue: null,
          adjustmentRevenue: null,
          contractId: "",
          expenseDate: "",
          id: 0,
          isUpdated: false,
          monthYear: "Other Year Forecast",
          revenue: 0,
          rvId: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      item.monthExpenseDetail = monthData;
    });
    const totalData = [];
    headersData.forEach((header) => {
      if (
        changedData.totalRevenue.filter(
          (val) => val.monthYear === header.heading,
        ).length > 0
      )
        totalData.push(
          changedData.totalRevenue.filter(
            (val) => val.monthYear === header.heading,
          )[0],
        );
      else {
        totalData.push({
          adjustedRevenue: null,
          adjustmentRevenue: null,
          contractId: "",
          expenseDate: "",
          id: 0,
          isUpdated: false,
          monthYear: header.heading,
          revenue: 0,
          rvId: 0,
          type: "Actual",
          isDummy: true,
        });
      }
    });
    if (
      changedData.totalRevenue.filter((val) => val.monthYear === "ITD").length >
      0
    ) {
      totalData.push({
        ...changedData.totalRevenue.filter((val) => val.monthYear === "ITD")[0],
      });
    } else {
      totalData.push({
        adjustedRevenue: null,
        adjustmentRevenue: null,
        contractId: "",
        expenseDate: "",
        id: 0,
        isUpdated: false,
        monthYear: "ITD",
        revenue: 0,
        rvId: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalRevenue.filter(
        (val) => val.monthYear === "Remaining Forecast",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalRevenue.filter(
          (val) => val.monthYear === "Remaining Forecast",
        )[0],
      });
    } else {
      totalData.push({
        adjustedRevenue: null,
        adjustmentRevenue: null,
        contractId: "",
        expenseDate: "",
        id: 0,
        isUpdated: false,
        monthYear: "Remaining Forecast",
        revenue: 0,
        rvId: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalRevenue.filter((val) => val.monthYear === "Total")
        .length > 0
    ) {
      totalData.push({
        ...changedData.totalRevenue.filter(
          (val) => val.monthYear === "Total",
        )[0],
      });
    } else {
      totalData.push({
        adjustedRevenue: null,
        adjustmentRevenue: null,
        contractId: "",
        expenseDate: "",
        id: 0,
        isUpdated: false,
        monthYear: "Total",
        revenue: 0,
        rvId: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalRevenue.filter(
        (val) => val.monthYear === "Other Year Actual",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalRevenue.filter(
          (val) => val.monthYear === "Other Year Actual",
        )[0],
      });
    } else {
      totalData.push({
        adjustedRevenue: null,
        adjustmentRevenue: null,
        contractId: "",
        expenseDate: "",
        id: 0,
        isUpdated: false,
        monthYear: "Other Year Actual",
        revenue: 0,
        rvId: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalRevenue.filter(
        (val) => val.monthYear === "Other Year Forecast",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalRevenue.filter(
          (val) => val.monthYear === "Other Year Forecast",
        )[0],
      });
    } else {
      totalData.push({
        adjustedRevenue: null,
        adjustmentRevenue: null,
        contractId: "",
        expenseDate: "",
        id: 0,
        isUpdated: false,
        monthYear: "Other Year Forecast",
        revenue: 0,
        rvId: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    changedData.totalRevenue = totalData;
    return changedData;
  };

  const addDummyDirectLabor = (data) => {
    const changedData = JSON.parse(JSON.stringify(data));
    const adjustedData = [];
    const totalData = [];
    changedData.getDirectLaborDetailList.forEach((item) => {
      const monthData = [];
      headersData.forEach((header) => {
        if (
          item.monthExpenseDetail.filter(
            (val) => val.monthYear === header.heading,
          ).length > 0
        )
          monthData.push({
            ...item.monthExpenseDetail.filter(
              (val) => val.monthYear === header.heading,
            )[0],
          });
        else {
          monthData.push({
            burdenCost: 0,
            contractId: "",
            defaultAvailableHours: 0,
            dlId: 0,
            expenseDate: "",
            hours: 0,
            otHours: 0,
            costRateLoaded: 0,
            costRateUnloaded: 0,
            id: 0,
            isLaborEscalationApplied: false,
            isUpdated: false,
            monthYear: header.heading,
            revenue: 0,
            type: "Actual",
            isDummy: true,
          });
        }
      });
      if (
        item.monthExpenseDetail.filter((val) => val.monthYear === "ITD")
          .length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "ITD",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          otHours: 0,
          costRateLoaded: 0,
          costRateUnloaded: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "ITD",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter(
          (val) => val.monthYear === "Remaining Forecast",
        ).length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Remaining Forecast",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          otHours: 0,
          costRateLoaded: 0,
          costRateUnloaded: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "Remaining Forecast",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter((val) => val.monthYear === "Total")
          .length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Total",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          otHours: 0,
          costRateLoaded: 0,
          costRateUnloaded: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "Total",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter(
          (val) => val.monthYear === "Other Year Actual",
        ).length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Other Year Actual",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          otHours: 0,
          costRateLoaded: 0,
          costRateUnloaded: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "Other Year Actual",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter(
          (val) => val.monthYear === "Other Year Forecast",
        ).length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Other Year Forecast",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          otHours: 0,
          costRateLoaded: 0,
          costRateUnloaded: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "Other Year Forecast",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      item.monthExpenseDetail = monthData;
    });
    headersData.forEach((header) => {
      if (
        changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === header.heading,
        ).length > 0
      )
        totalData.push(
          changedData.totalDirectLaborCost.filter(
            (val) => val.monthYear === header.heading,
          )[0],
        );
      else {
        totalData.push({
          burdenCost: 0,
          expenseDate: "",
          monthYear: header.heading,
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        changedData.adjustment.filter((val) => val.monthYear === header.heading)
          .length > 0
      )
        adjustedData.push({
          ...changedData.adjustment.filter(
            (val) => val.monthYear === header.heading,
          )[0],
        });
      else {
        adjustedData.push({
          burdenCost: 0,
          expenseDate: "",
          monthYear: header.heading,
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
    });
    if (
      changedData.totalDirectLaborCost.filter((val) => val.monthYear === "ITD")
        .length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "ITD",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "ITD",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalDirectLaborCost.filter(
        (val) => val.monthYear === "Remaining Forecast",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "Remaining Forecast",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Remaining Forecast",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalDirectLaborCost.filter(
        (val) => val.monthYear === "Total",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "Total",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Total",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalDirectLaborCost.filter(
        (val) => val.monthYear === "Other Year Actual",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "Other Year Actual",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Other Year Actual",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalDirectLaborCost.filter(
        (val) => val.monthYear === "Other Year Forecast",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "Other Year Forecast",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Other Year Forecast",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter((val) => val.monthYear === "ITD").length > 0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter((val) => val.monthYear === "ITD")[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "ITD",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter(
        (val) => val.monthYear === "Remaining Forecast",
      ).length > 0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter(
          (val) => val.monthYear === "Remaining Forecast",
        )[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Remaining Forecast",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter((val) => val.monthYear === "Total").length >
      0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter((val) => val.monthYear === "Total")[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Total",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter(
        (val) => val.monthYear === "Other Year Actual",
      ).length > 0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter(
          (val) => val.monthYear === "Other Year Actual",
        )[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Other Year Actual",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter(
        (val) => val.monthYear === "Other Year Forecast",
      ).length > 0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter(
          (val) => val.monthYear === "Other Year Forecast",
        )[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Other Year Forecast",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    changedData.adjustment = adjustedData;
    changedData.totalDirectLaborCost = totalData;
    return changedData;
  };

  const addDummyOtherDirectCosts = (data) => {
    const changedData = JSON.parse(JSON.stringify(data));
    const adjustedData = [];
    const totalData = [];
    changedData.otherDirectLabourDetailList.forEach((item) => {
      const monthData = [];
      headersData.forEach((header) => {
        if (
          item.monthExpenseDetail.filter(
            (val) => val.monthYear === header.heading,
          ).length > 0
        )
          monthData.push({
            ...item.monthExpenseDetail.filter(
              (val) => val.monthYear === header.heading,
            )[0],
          });
        else {
          monthData.push({
            burdenCost: 0,
            contractId: "",
            defaultAvailableHours: 0,
            dlId: 0,
            expenseDate: "",
            hours: 0,
            id: 0,
            isLaborEscalationApplied: false,
            isUpdated: false,
            monthYear: header.heading,
            revenue: 0,
            type: "Actual",
            isDummy: true,
          });
        }
      });
      if (
        item.monthExpenseDetail.filter((val) => val.monthYear === "ITD")
          .length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "ITD",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "ITD",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter(
          (val) => val.monthYear === "Remaining Forecast",
        ).length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Remaining Forecast",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "Remaining Forecast",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter((val) => val.monthYear === "Total")
          .length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Total",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "Total",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter(
          (val) => val.monthYear === "Other Year Actual",
        ).length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Other Year Actual",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "Other Year Actual",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        item.monthExpenseDetail.filter(
          (val) => val.monthYear === "Other Year Forecast",
        ).length > 0
      ) {
        monthData.push({
          ...item.monthExpenseDetail.filter(
            (val) => val.monthYear === "Other Year Forecast",
          )[0],
        });
      } else {
        monthData.push({
          burdenCost: 0,
          contractId: "",
          defaultAvailableHours: 0,
          dlId: 0,
          expenseDate: "",
          hours: 0,
          id: 0,
          isLaborEscalationApplied: false,
          isUpdated: false,
          monthYear: "Other Year Forecast",
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      item.monthExpenseDetail = monthData;
    });
    headersData.forEach((header) => {
      if (
        changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === header.heading,
        ).length > 0
      )
        totalData.push(
          changedData.totalDirectLaborCost.filter(
            (val) => val.monthYear === header.heading,
          )[0],
        );
      else {
        totalData.push({
          burdenCost: 0,
          expenseDate: "",
          monthYear: header.heading,
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
      if (
        changedData.adjustment.filter((val) => val.monthYear === header.heading)
          .length > 0
      )
        adjustedData.push({
          ...changedData.adjustment.filter(
            (val) => val.monthYear === header.heading,
          )[0],
        });
      else {
        adjustedData.push({
          burdenCost: 0,
          expenseDate: "",
          monthYear: header.heading,
          revenue: 0,
          type: "Actual",
          isDummy: true,
        });
      }
    });
    if (
      changedData.totalDirectLaborCost.filter((val) => val.monthYear === "ITD")
        .length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "ITD",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "ITD",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalDirectLaborCost.filter(
        (val) => val.monthYear === "Remaining Forecast",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "Remaining Forecast",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Remaining Forecast",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalDirectLaborCost.filter(
        (val) => val.monthYear === "Total",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "Total",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Total",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalDirectLaborCost.filter(
        (val) => val.monthYear === "Other Year Actual",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "Other Year Actual",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Other Year Actual",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.totalDirectLaborCost.filter(
        (val) => val.monthYear === "Other Year Forecast",
      ).length > 0
    ) {
      totalData.push({
        ...changedData.totalDirectLaborCost.filter(
          (val) => val.monthYear === "Other Year Forecast",
        )[0],
      });
    } else {
      totalData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Other Year Forecast",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter((val) => val.monthYear === "ITD").length > 0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter((val) => val.monthYear === "ITD")[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "ITD",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter(
        (val) => val.monthYear === "Remaining Forecast",
      ).length > 0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter(
          (val) => val.monthYear === "Remaining Forecast",
        )[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Remaining Forecast",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter((val) => val.monthYear === "Total").length >
      0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter((val) => val.monthYear === "Total")[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Total",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter(
        (val) => val.monthYear === "Other Year Actual",
      ).length > 0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter(
          (val) => val.monthYear === "Other Year Actual",
        )[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Other Year Actual",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    if (
      changedData.adjustment.filter(
        (val) => val.monthYear === "Other Year Forecast",
      ).length > 0
    ) {
      adjustedData.push({
        ...changedData.adjustment.filter(
          (val) => val.monthYear === "Other Year Forecast",
        )[0],
      });
    } else {
      adjustedData.push({
        burdenCost: 0,
        expenseDate: "",
        monthYear: "Other Year Forecast",
        revenue: 0,
        type: "Actual",
        isDummy: true,
      });
    }
    changedData.adjustment = adjustedData;
    changedData.totalDirectLaborCost = totalData;
    return changedData;
  };

  const addDummyMargin = (data) => {
    const changedData = JSON.parse(JSON.stringify(data));
    const monthData = [];
    const netData = [];
    const netPerData = [];
    headersData.forEach((header) => {
      if (
        changedData.total.filter((val) => val.monthYear === header.heading)
          .length > 0
      )
        monthData.push({
          ...changedData.total.filter(
            (val) => val.monthYear === header.heading,
          )[0],
        });
      else {
        monthData.push({
          burdenCost: 0,
          expenseDate: "",
          monthYear: header.heading,
          revenue: 0,
          type: "Actual",
        });
      }
      if (
        changedData.netProfit.filter((val) => val.monthYear === header.heading)
          .length > 0
      )
        netData.push({
          ...changedData.netProfit.filter(
            (val) => val.monthYear === header.heading,
          )[0],
        });
      else {
        netData.push({
          burdenCost: 0,
          expenseDate: "",
          monthYear: header.heading,
          revenue: 0,
          type: "Actual",
        });
      }
      if (
        changedData.netProfitPercent.filter(
          (val) => val.monthYear === header.heading,
        ).length > 0
      )
        netPerData.push({
          ...changedData.netProfitPercent.filter(
            (val) => val.monthYear === header.heading,
          )[0],
        });
      else {
        netPerData.push({
          burdenCost: 0,
          expenseDate: "",
          monthYear: header.heading,
          revenue: 0,
          type: "Actual",
        });
      }
    });

    changedData.total
      .filter((val) => excludedItemsForMonthly.indexOf(val.monthYear) >= 0)
      .forEach((monthVal) => {
        monthData.push({
          ...monthVal,
        });
      });
    changedData.netProfit
      .filter((val) => excludedItemsForMonthly.indexOf(val.monthYear) >= 0)
      .forEach((monthVal) => {
        netData.push({
          ...monthVal,
        });
      });
    changedData.netProfitPercent
      .filter((val) => excludedItemsForMonthly.indexOf(val.monthYear) >= 0)
      .forEach((monthVal) => {
        netPerData.push({
          ...monthVal,
        });
      });
    changedData.total = monthData;
    changedData.netProfit = netData;
    changedData.netProfitPercent = netPerData;
    return changedData;
  };

  const getFeeValue = (clin, key) => {
    if (viewRatesData.filter((val) => clin.startsWith(val.clin)).length > 0) {
      return viewRatesData.filter((val) => clin.startsWith(val.clin))[0][key];
    }
    return 0;
  };

  useEffect(() => {
    if (
      directLaborDetailsData &&
      directLaborDetailsData.status === 200 &&
      directLaborDetailsData.data &&
      headersData.length > 0
    ) {
      const changedData = JSON.parse(
        JSON.stringify(addDummyDirectLabor(directLaborDetailsData.data)),
      );
      changedData.getDirectLaborDetailList.forEach((item) => {
        let calcBillRate = item.billRate;
        if (detailedType === "TM") {
          if (item.adjustmentBillRate)
            calcBillRate += Number(item.adjustmentBillRate);
        }
        item.adjustedBillRate = calcBillRate;
        item.margin = calculateDirectLaborMargin(
          calcBillRate,
          item.costRateLoaded,
        );
        item.monthExpenseDetail.forEach((monthVal) => {
          if (
            monthVal.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
          ) {
            const burdenCost =
              calculateDirectLaborBurdenCost(
                monthVal.hours,
                monthVal.costRateLoaded,
                false,
                item.laborEscalation,
                monthVal.laborEscalationIteration,
                monthVal.expenseDate,
                item.laborEscalationDate,
                item.startDate,
              ) +
              calculateDirectLaborBurdenCostOT(
                monthVal.otHours,
                item.costRateLoaded,
                monthVal.isLaborEscalationApplied,
                item.laborEscalation,
                monthVal.laborEscalationIteration,
                item.laborEscalationDate,
                getOTFixedAmtById(item.otTypeId),
                getOTFactorById(item.otTypeId),
              );
            monthVal.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              monthVal.revenue = !item.billingStatus
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    item.adjustedBillRate,
                    monthVal.hours,
                    burdenCost,
                    getFeeValue(item.clin, "feeLabor"),
                    getFeeValue(item.clin, "feeSubCon"),
                    item.employeeType,
                    item.isIwo,
                    item.billRateEscalation,
                    item.billRateEscalationDate,
                    monthVal.expenseDate,
                    monthVal.isBillRateEscalationApplied,
                    monthVal.billRateEscalationIteration,
                    item.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    item.adjustedBillRate,
                    monthVal.otHours,
                    item.billRateEscalation,
                    item.billRateEscalationDate,
                    monthVal.isBillRateEscalationApplied,
                    monthVal.billRateEscalationIteration,
                  );
          }
        });
      });
      setDirectLaborCostBind(changedData);
      setOriginalDirectLaborData(changedData);
    } else setDirectLaborCostBind();
  }, [directLaborDetailsData, headersData, viewRatesData]);

  useEffect(() => {
    if (
      otherDirectCostData &&
      otherDirectCostData.status === 200 &&
      otherDirectCostData.data &&
      headersData.length > 0 &&
      (gaRate || gaRate === 0) &&
      (smAndH || smAndH === 0)
    ) {
      setIsEdit(false);
      const changedData = JSON.parse(
        JSON.stringify(addDummyOtherDirectCosts(otherDirectCostData.data)),
      );
      changedData.otherDirectLabourDetailList.forEach((item) => {
        item.monthExpenseDetail.forEach((monthVal) => {
          if (
            monthVal.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
          ) {
            const burdenCost = item.applyBurden
              ? calculateOtherDirectCostBurdenCost(
                  monthVal.unburdenCost,
                  gaRate,
                  smAndH,
                  item.expenseType,
                )
              : Number(monthVal.unburdenCost);
            monthVal.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              if (item.expenseType === "Sub Con Travel") {
                monthVal.revenue = calculateOtherDirectCostRevenue(
                  item.billingStatus,
                  item.markUp,
                  monthVal.burdenCost,
                  getFeeValue(item.clin, "feeSubCon"),
                );
              } else {
                monthVal.revenue = calculateOtherDirectCostRevenue(
                  item.billingStatus,
                  item.markUp,
                  monthVal.burdenCost,
                  getFeeValue(item.clin, "feeNonLabor"),
                );
              }
          }
        });
      });
      setOtherDirectCostBind(changedData);
      setOriginalOtherDirectCost(changedData);
    } else setOtherDirectCostBind();
  }, [otherDirectCostData, gaRate, headersData, viewRatesData, smAndH]);

  useEffect(() => {
    if (
      revenueData &&
      revenueData.status === 200 &&
      revenueData.data &&
      headersData.length > 0
    ) {
      setDateEditedId("");
      setIsEditEndDate(false);
      setUpdatedReviseDate(null);
      const changedData = JSON.parse(
        JSON.stringify(addDummyRevenue(revenueData.data)),
      );
      changedData.revenueDetailList.forEach((revItem) => {
        revItem.monthExpenseDetail.forEach((monthItem) => {
          if (detailedType === "FFP") {
            let adjustedRevenue = monthItem.revenue;
            if (monthItem.adjustmentRevenue)
              adjustedRevenue += Number(monthItem.adjustmentRevenue);
            monthItem.adjustedRevenue = adjustedRevenue;
          }
        });
      });
      setOriginalRevenue(changedData);
      setRevenueBind(changedData);
    } else setRevenueBind();
  }, [revenueData, headersData]);

  useEffect(() => {
    if (marginData && marginData.status === 200 && marginData.data)
      setMarginBind(addDummyMargin(marginData.data));
    else setMarginBind();
  }, [marginData, headersData]);

  // const onChangeYear = (e) => {
  //   setYear(e.target.value);
  //   changedRatesYear(e.target.value);
  // };

  const handleClickEdit = () => {
    setIsEdit(!isEdit);
    setIsEditEndDate(false);
  };

  const onSaveClick = (isForceUpdated = false) => {
    updateIsSaveClickUpdateRates(false);
    const directLaborCostSave = JSON.parse(JSON.stringify(directLaborCostBind));
    const otherDirectCostSave = JSON.parse(JSON.stringify(otherDirectCostBind));
    const revenueSave = JSON.parse(JSON.stringify(revenueBind));
    directLaborCostSave.getDirectLaborDetailList.forEach((item) => {
      if (isForceUpdated) item.isUpdated = true;
      item.monthExpenseDetail.forEach((val) => {
        if (isForceUpdated && val.type === "Forecast") val.isUpdated = true;
        val.hours = Number(val.hours);
      });
      item.monthExpenseDetail = item.monthExpenseDetail.filter(
        (val) => !val.isDummy,
      );
    });
    directLaborCostSave.adjustment = directLaborCostSave.adjustment.filter(
      (val) => !val.isDummy,
    );
    directLaborCostSave.totalDirectLaborCost =
      directLaborCostSave.totalDirectLaborCost.filter((val) => !val.isDummy);
    otherDirectCostSave.otherDirectLabourDetailList.forEach((item) => {
      if (isForceUpdated) item.isUpdated = true;
      if (isForceUpdated) {
        item.monthExpenseDetail.forEach((val) => {
          if (val.type === "Forecast") val.isUpdated = true;
        });
      }
      item.monthExpenseDetail = item.monthExpenseDetail.filter(
        (val) => !val.isDummy,
      );
    });
    otherDirectCostSave.adjustment = otherDirectCostSave.adjustment.filter(
      (val) => !val.isDummy,
    );
    otherDirectCostSave.totalDirectLaborCost =
      otherDirectCostSave.totalDirectLaborCost.filter((val) => !val.isDummy);
    revenueSave.revenueDetailList.forEach((item) => {
      item.monthExpenseDetail = item.monthExpenseDetail.filter(
        (val) => !val.isDummy,
      );
    });
    revenueSave.totalRevenue = revenueSave.totalRevenue.filter(
      (val) => !val.isDummy,
    );
    if (detailedType !== "FFP") {
      const updatedData = JSON.parse(JSON.stringify(revenueSave));
      updatedData.revenueDetailList.map((item, i) => {
        item.isUpdated = true;
        const totalRevenue = calculateTotalRevenueForCLIN(
          item.clin,
          directLaborCostSave,
          otherDirectCostSave,
        );
        item.estCompletion = totalRevenue;
        item.remainingFund =
          Math.round(
            Number(item.fundedValue - totalRevenue - item.priorYearActual) *
              100,
          ) / 100;
        item.monthExpenseDetail.forEach((monthVal) => {
          if (
            monthVal.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
          ) {
            monthVal.isUpdated = true;
            monthVal.revenue = calculateMonthlyRevenueForCLIN(
              item.clin,
              monthVal.monthYear,
              directLaborCostSave,
              otherDirectCostSave,
            );
          }
        });
      });

      changedAPIData({
        directLaborCost: directLaborCostSave,
        otherDirectCost: otherDirectCostSave,
        revenueData: updatedData,
      });
    } else
      changedAPIData({
        directLaborCost: directLaborCostSave,
        otherDirectCost: otherDirectCostSave,
        revenueData: revenueSave,
      });
  };

  const onCancelClick = () => {
    setOtherDirectCostBind(originalOtherDirectDirectCost);
    setDirectLaborCostBind(originalDirectLaborData);
    setRevenueBind(originalRevenue);
    setIsEdit(false);
    ``;
  };

  const handleClickEditFee = () => {
    setIsEditFee(!isEdit);
  };

  const onSaveClickFee = () => {
    const updatedData = JSON.parse(JSON.stringify(detailedViewRatesData.data));
    if (detailedType === "Cost Plus") {
      updatedData.cpFeeLabor = feeLabor;
      updatedData.cpFeeNonLabor = nonLaborPer;
      updatedData.cpFeeSubCon = feeSubcon;
    } else if (detailedType === "TM") {
      updatedData.tmFeeNonLabor = nonLaborPer;
      updatedData.tmFeeSubCon = feeSubcon;
    } else if (detailedType === "FFP") {
      updatedData.ffpFeeLabor = nonLaborPer;
      updatedData.ffpFeeNonLabor = nonLaborPer;
      updatedData.ffpFeeSubCon = feeSubcon;
    }
    udpatedRates(updatedData);
    setIsEditFee(false);
  };

  const onCancelClickFee = () => {
    setIsEditFee(false);
    setGaRate(detailedViewRatesData.data.gAndA);
    setSmAndH(detailedViewRatesData.data.smAndH);
    if (detailedType === "Cost Plus") {
      setNonLaborPer(detailedViewRatesData.data.cpFeeNonLabor);
      setFeeLabor(detailedViewRatesData.data.cpFeeLabor);
      setFeeSubcon(detailedViewRatesData.data.cpFeeSubCon);
    }
    if (detailedType === "TM") {
      setNonLaborPer(detailedViewRatesData.data.tmFeeNonLabor);
      setFeeSubcon(detailedViewRatesData.data.tmFeeSubCon);
    }
    if (detailedType === "FFP") {
      setNonLaborPer(detailedViewRatesData.data.ffpFeeNonLabor);
      setFeeLabor(detailedViewRatesData.data.ffpFeeLabor);
      setFeeSubcon(detailedViewRatesData.data.ffpFeeSubCon);
    }
  };

  const onChangeReimbursement = (e, odlId) => {
    const changedData = JSON.parse(JSON.stringify(otherDirectCostBind));
    changedData.otherDirectLabourDetailList.forEach((val) => {
      if (val.odlId === odlId) {
        val.isUpdated = true;
        val.billingStatus = e.target.value;
        if (!e.target.value) {
          val.markUp = false;
        }
        val.monthExpenseDetail.forEach((monthVal) => {
          if (
            monthVal.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
          ) {
            monthVal.isUpdated = true;
            const burdenCost = val.applyBurden
              ? calculateOtherDirectCostBurdenCost(
                  monthVal.unburdenCost,
                  gaRate,
                  smAndH,
                  val.expenseType,
                )
              : Number(monthVal.unburdenCost);
            monthVal.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              if (val.expenseType === "Sub Con Travel") {
                monthVal.revenue = calculateOtherDirectCostRevenue(
                  e.target.value,
                  e.target.value ? val.markUp : false,
                  monthVal.burdenCost,
                  getFeeValue(val.clin, "feeSubCon"),
                );
              } else {
                monthVal.revenue = calculateOtherDirectCostRevenue(
                  e.target.value,
                  e.target.value ? val.markUp : false,
                  monthVal.burdenCost,
                  getFeeValue(val.clin, "feeNonLabor"),
                );
              }
          }
        });
      }
    });
    setOtherDirectCostBind(changedData);
  };

  const onChangeDirectLaborReimbursement = (e, odlId, item) => {
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === odlId) {
        val.isUpdated = true;
        val.billingStatus = e.target.value;

        val.monthExpenseDetail.forEach((monthVal) => {
          if (
            monthVal.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
          ) {
            monthVal.isUpdated = true;
            if (detailedType !== "FFP")
              monthVal.revenue = !e.target.value
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    val.adjustedBillRate,
                    monthVal.hours,
                    monthVal.burdenCost,
                    getFeeValue(val.clin, "feeLabor"),
                    getFeeValue(val.clin, "feeSubCon"),
                    val.employeeType,
                    val.isIwo,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    monthVal.expenseDate,
                    monthVal.isBillRateEscalationApplied,
                    monthVal.billRateEscalationIteration,
                    val.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    val.adjustedBillRate,
                    monthVal.otHours,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    monthVal.isBillRateEscalationApplied,
                    monthVal.billRateEscalationIteration,
                  );
          }
        });
      }
    });

    setDirectLaborCostBind(changedData);
  };

  const onChangeBillRateEscalation = (e, odlId) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === odlId) {
        val.isUpdated = true;
        val.billRateEscalation = changeVal;

        val.monthExpenseDetail.forEach((monthVal) => {
          if (
            monthVal.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
          ) {
            monthVal.isUpdated = true;
            if (detailedType !== "FFP")
              monthVal.revenue = !val.billingStatus
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    val.adjustedBillRate,
                    monthVal.hours,
                    monthVal.burdenCost,
                    getFeeValue(val.clin, "feeLabor"),
                    getFeeValue(val.clin, "feeSubCon"),
                    val.employeeType,
                    val.isIwo,
                    changeVal,
                    val.billRateEscalationDate,
                    monthVal.expenseDate,
                    monthVal.isBillRateEscalationApplied,
                    monthVal.billRateEscalationIteration,
                    val.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    val.adjustedBillRate,
                    monthVal.otHours,
                    changeVal,
                    val.billRateEscalationDate,
                    monthVal.isBillRateEscalationApplied,
                    monthVal.billRateEscalationIteration,
                  );
          }
        });
      }
    });

    setDirectLaborCostBind(changedData);
  };

  const onChangeBillRateEscalationDate = (date, odlId) => {
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    const dateChanged = formatDateBySetting(getDate(date), "YYYY-MM-DD");
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === odlId) {
        val.isUpdated = true;
        val.billRateEscalationDate = dateChanged;
        val.monthExpenseDetail.forEach((monthVal) => {
          if (
            monthVal.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
          ) {
            monthVal.isUpdated = true;
            const iterationVal = calculateEscalationIterationCount(
              parseLocalDate(dateChanged),
              parseLocalDate(monthVal.expenseDate),
            );
            const billRateApplied = iterationVal > 0 ? true : false;
            monthVal.billRateEscalationIteration = iterationVal;
            monthVal.isBillRateEscalationApplied = billRateApplied;
            if (detailedType !== "FFP")
              monthVal.revenue = !val.billingStatus
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    val.adjustedBillRate,
                    monthVal.hours,
                    monthVal.burdenCost,
                    getFeeValue(val.clin, "feeLabor"),
                    getFeeValue(val.clin, "feeSubCon"),
                    val.employeeType,
                    val.isIwo,
                    val.billRateEscalation,
                    dateChanged,
                    monthVal.expenseDate,
                    billRateApplied,
                    iterationVal,
                    val.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    val.adjustedBillRate,
                    monthVal.otHours,
                    val.billRateEscalation,
                    dateChanged,
                    billRateApplied,
                    iterationVal,
                  );
          }
        });
      }
    });

    setDirectLaborCostBind(changedData);
  };

  const onChangeLaborEscalationDate = (date, odlId) => {
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    const dateChanged = formatDateBySetting(getDate(date), "YYYY-MM-DD");
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === odlId) {
        val.isUpdated = true;
        val.laborEscalationDate = dateChanged;
        val.monthExpenseDetail.forEach((item) => {
          let costRateUnloadedCalc = val.costRateUnloaded;
          const monthlySalary =
            (getYearlyWorkingDays(yearValue) *
              workingHoursPerDay *
              Number(costRateUnloadedCalc)) /
            12;
          if (
            item.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(item.monthYear) < 0
          ) {
            item.isUpdated = true;
            const iterationVal = calculateEscalationIterationCount(
              parseLocalDate(dateChanged),
              parseLocalDate(item.expenseDate),
            );
            const laborApplied = iterationVal > 0;
            item.laborEscalationIteration = iterationVal;
            item.isLaborEscalationApplied = laborApplied;
            if (val.employeeType.toLowerCase() === "employee" || val.isIwo) {
              costRateUnloadedCalc = roundTwoDecimals(
                Number(
                  monthlySalary /
                    (getWeekdaysInMonth(
                      parseInt(getMonthOnly(item.expenseDate)),
                      yearValue,
                    ) *
                      workingHoursPerDay),
                ),
              );
            }
            if (
              getMonthOnly(item.expenseDate) === getMonthOnly(dateChanged) &&
              parseInt(getDateOnly(dateChanged)) !== 1
            ) {
              costRateUnloadedCalc = calculateDirectLaborCostRateUnloaded(
                costRateUnloadedCalc,
                laborApplied,
                val.laborEscalation,
                iterationVal > 0 ? iterationVal - 1 : 0,
              );
            } else {
              costRateUnloadedCalc = calculateDirectLaborCostRateUnloaded(
                costRateUnloadedCalc,
                laborApplied,
                val.laborEscalation,
                iterationVal,
              );
            }
            const costRateLoadedCalculated = val.applyBurden
              ? calculateCostRateLoaded(
                  Number(costRateUnloadedCalc),
                  val.employeeType,
                  val.isIwo,
                  detailedViewRatesData.data.fringe,
                  detailedViewRatesData.data.oh,
                  detailedViewRatesData.data.smAndH,
                  gaRate,
                )
              : Number(costRateUnloadedCalc);
            item.costRateLoaded = costRateLoadedCalculated;
            item.costRateUnloaded = costRateUnloadedCalc;
            const burdenCost =
              (getMonthOnly(item.expenseDate) === getMonthOnly(dateChanged) &&
              parseInt(getDateOnly(dateChanged)) !== 1
                ? calculateDirectLaborBurdenCost(
                    item.hours,
                    val.costRateLoaded,
                    laborApplied,
                    val.laborEscalation,
                    iterationVal,
                    item.expenseDate,
                    dateChanged,
                    val.startDate,
                  )
                : calculateDirectLaborBurdenCost(
                    item.hours,
                    costRateLoadedCalculated,
                    false,
                    val.laborEscalation,
                    iterationVal,
                    item.expenseDate,
                    dateChanged,
                    val.startDate,
                  )) +
              calculateDirectLaborBurdenCostOT(
                item.otHours,
                val.costRateLoaded,
                laborApplied,
                val.laborEscalation,
                iterationVal,
                dateChanged,
                getOTFixedAmtById(val.otTypeId),
                getOTFactorById(val.otTypeId),
              );
            item.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              item.revenue = !val.billingStatus
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    val.adjustedBillRate,
                    item.hours,
                    burdenCost,
                    getFeeValue(val.clin, "feeLabor"),
                    getFeeValue(val.clin, "feeSubCon"),
                    val.employeeType,
                    val.isIwo,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.expenseDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                    val.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    val.adjustedBillRate,
                    item.otHours,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                  );
          }
        });
      }
    });
    setDirectLaborCostBind(changedData);
  };

  const onChangeOTType = (e, odlId, item) => {
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === odlId) {
        val.isUpdated = true;
        val.otTypeId = e.target.value;
        val.monthExpenseDetail.forEach((item) => {
          if (
            item.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(item.monthYear) < 0
          ) {
            item.isUpdated = true;
            const burdenCost =
              calculateDirectLaborBurdenCost(
                item.hours,
                item.costRateLoaded,
                false,
                val.laborEscalation,
                item.laborEscalationIteration,
                item.expenseDate,
                val.laborEscalationDate,
                val.startDate,
              ) +
              calculateDirectLaborBurdenCostOT(
                item.otHours,
                val.costRateLoaded,
                item.isLaborEscalationApplied,
                val.laborEscalation,
                item.laborEscalationIteration,
                val.laborEscalationDate,

                getOTFixedAmtById(e.target.value),
                getOTFactorById(e.target.value),
              );
            item.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              item.revenue = !val.billingStatus
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    val.adjustedBillRate,
                    item.hours,
                    burdenCost,
                    getFeeValue(val.clin, "feeLabor"),
                    getFeeValue(val.clin, "feeSubCon"),
                    val.employeeType,
                    val.isIwo,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.expenseDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                    val.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    val.adjustedBillRate,
                    item.otHours,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                  );
          }
        });
      }
    });

    setDirectLaborCostBind(changedData);
  };

  // Shared by the manual "Apply Burden" dropdown and the "Is IWO?" checkbox forcing it off —
  // mutates `val` (one row of getDirectLaborDetailList) in place; callers still own their own
  // clone + setDirectLaborCostBind. `otTypeIdForOt` is whatever the caller has on hand for the
  // OT fixed-amount/factor lookup (the dropdown passes its own event value, same as before this
  // was extracted; the IWO checkbox path has no such event, so it passes val.otTypeId instead).
  // `employeeTypeOverride` defaults to the row's own employeeType; the IWO checkbox path passes
  // "employee" explicitly — an IWO row is really a contractor in the system, but its cost
  // rate/burden/revenue should still be calculated as if it were an employee.
  const recalcDirectLaborBurden = (
    val,
    isApply,
    otTypeIdForOt,
    employeeTypeOverride = val.employeeType,
  ) => {
    val.isUpdated = true;
    val.applyBurden = isApply;
    const costRateMain = isApply
      ? calculateCostRateLoaded(
          val.costRateUnloaded,
          employeeTypeOverride,
          val.isIwo,
          detailedViewRatesData.data.fringe,
          detailedViewRatesData.data.oh,
          detailedViewRatesData.data.smAndH,
          gaRate,
        )
      : val.costRateUnloaded;
    val.costRateLoaded = costRateMain;
    val.monthExpenseDetail.forEach((item) => {
      if (
        item.type.toLowerCase() === "forecast" &&
        excludedItemsForMonthly.indexOf(item.monthYear) < 0
      ) {
        item.isUpdated = true;
        const costRate = isApply
          ? calculateCostRateLoaded(
              item.costRateUnloaded,
              employeeTypeOverride,
              val.isIwo,
              detailedViewRatesData.data.fringe,
              detailedViewRatesData.data.oh,
              detailedViewRatesData.data.smAndH,
              gaRate,
            )
          : item.costRateUnloaded;
        item.costRateLoaded = costRate;
        const burdenCost =
          calculateDirectLaborBurdenCost(
            item.hours,
            costRate,
            false,
            val.laborEscalation,
            item.laborEscalationIteration,
            item.expenseDate,
            val.laborEscalationDate,
            val.startDate,
          ) +
          calculateDirectLaborBurdenCostOT(
            item.otHours,
            costRateMain,
            item.isLaborEscalationApplied,
            val.laborEscalation,
            item.laborEscalationIteration,
            val.laborEscalationDate,

            getOTFixedAmtById(otTypeIdForOt),
            getOTFactorById(otTypeIdForOt),
          );
        item.burdenCost = burdenCost;
        if (detailedType !== "FFP")
          item.revenue = !val.billingStatus
            ? 0
            : calculateDirectLaborRevenue(
                detailedType,
                val.adjustedBillRate,
                item.hours,
                burdenCost,
                getFeeValue(val.clin, "feeLabor"),
                getFeeValue(val.clin, "feeSubCon"),
                employeeTypeOverride,
                val.isIwo,
                val.billRateEscalation,
                val.billRateEscalationDate,
                item.expenseDate,
                item.isBillRateEscalationApplied,
                item.billRateEscalationIteration,
                val.startDate,
              ) +
              calculateDirectLaborRevenueOT(
                detailedType,
                val.adjustedBillRate,
                item.otHours,
                val.billRateEscalation,
                val.billRateEscalationDate,
                item.isBillRateEscalationApplied,
                item.billRateEscalationIteration,
              );
      }
    });
  };

  const onChangeApplyBurden = (e, odlId, item) => {
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    const isApply = e.target.value;
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === odlId) {
        recalcDirectLaborBurden(val, isApply, e.target.value);
      }
    });

    setDirectLaborCostBind(changedData);
  };

  const onChangeApplyBurdenODC = (e, odlId) => {
    const changedData = JSON.parse(JSON.stringify(otherDirectCostBind));
    const isApply = e.target.value;
    changedData.otherDirectLabourDetailList.forEach((val) => {
      if (val.odlId === odlId) {
        val.isUpdated = true;
        val.applyBurden = isApply;
        val.monthExpenseDetail.forEach((monthVal) => {
          if (
            monthVal.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
          ) {
            monthVal.isUpdated = true;
            const burdenCost = isApply
              ? calculateOtherDirectCostBurdenCost(
                  monthVal.unburdenCost,
                  gaRate,
                  smAndH,
                  val.expenseType,
                )
              : monthVal.unburdenCost;
            monthVal.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              if (val.expenseType === "Sub Con Travel") {
                monthVal.revenue = calculateOtherDirectCostRevenue(
                  val.billingStatus,
                  val.markUp,
                  monthVal.burdenCost,
                  getFeeValue(val.clin, "feeSubCon"),
                );
              } else {
                monthVal.revenue = calculateOtherDirectCostRevenue(
                  val.billingStatus,
                  val.markUp,
                  monthVal.burdenCost,
                  getFeeValue(val.clin, "feeNonLabor"),
                );
              }
          }
        });
      }
    });
    setOtherDirectCostBind(changedData);
  };

  const onChangeMarkupAllowed = (e, odlId) => {
    const changedData = JSON.parse(JSON.stringify(otherDirectCostBind));
    changedData.otherDirectLabourDetailList.forEach((val) => {
      if (val.odlId === odlId) {
        val.isUpdated = true;
        val.markUp = e.target.value;
        val.monthExpenseDetail.forEach((monthVal) => {
          if (
            monthVal.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(monthVal.monthYear) < 0
          ) {
            monthVal.isUpdated = true;
            const burdenCost = val.applyBurden
              ? calculateOtherDirectCostBurdenCost(
                  monthVal.unburdenCost,
                  gaRate,
                  smAndH,
                  val.expenseType,
                )
              : monthVal.unburdenCost;
            monthVal.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              if (val.expenseType === "Sub Con Travel") {
                monthVal.revenue = calculateOtherDirectCostRevenue(
                  val.billingStatus,
                  e.target.value,
                  monthVal.burdenCost,
                  getFeeValue(val.clin, "feeSubCon"),
                );
              } else {
                monthVal.revenue = calculateOtherDirectCostRevenue(
                  val.billingStatus,
                  e.target.value,
                  monthVal.burdenCost,
                  getFeeValue(val.clin, "feeNonLabor"),
                );
              }
          }
        });
      }
    });
    setOtherDirectCostBind(changedData);
  };

  const getMarginBackColor = (val) => {
    if (!val) return "none";
    if (val > 2) return "#c6efce";
    if (val < 0) return "#ffc7ce";
    return "#ffeb9c";
  };

  const bindYears = () => {
    const years = [];
    if (
      contractYearsData &&
      contractYearsData.data &&
      Array.isArray(contractYearsData.data) &&
      contractYearsData.data.filter(
        (val) => val.dropdownYear === contractYearValue,
      ).length > 0
    ) {
      contractYearsData.data
        .filter((val) => val.dropdownYear === contractYearValue)[0]
        .yearlyRatesOptions.forEach((item) => {
          years.push({ id: item, text: item });
        });
    }
    return years;
  };

  useEffect(() => {
    if (getResponse(generalSettingsData, []).length > 0) {
      setDateFormat(
        converDateFormatForPicker(
          getResponse(generalSettingsData, [])[0].date_format,
        ),
      );
    }
  }, [generalSettingsData]);

  useEffect(() => {
    if (isSaveClickUpdateRates) {
      onSaveClick(true);
    }
  }, [isSaveClickUpdateRates]);

  // useEffect(() => {
  //   if (
  //     contractYearsData &&
  //     contractYearsData.status === 200 &&
  //     contractYearsData.data &&
  //     contractYearsData.data.filter(
  //       (val) => val.dropdownYear === contractYearValue
  //     ).length > 0
  //   ) {
  //     setYear(
  //       contractYearsData.data.filter(
  //         (val) => val.dropdownYear === contractYearValue
  //       )[0].defaultYearlyRate
  //     );
  //   }
  // }, [contractYearsData, contractYearValue]);

  const handleScrollTable = (sourceTable) => {
    if (sourceTable === "revenueTable") {
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft = revenuTableRef.current.scrollLeft;
      if (otherDirectCostsRef.current)
        otherDirectCostsRef.current.scrollLeft =
          revenuTableRef.current.scrollLeft;
      if (marginRef.current)
        marginRef.current.scrollLeft = revenuTableRef.current.scrollLeft;
    } else if (sourceTable === "directLabor") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft = directLabourRef.current.scrollLeft;
      if (otherDirectCostsRef.current)
        otherDirectCostsRef.current.scrollLeft =
          directLabourRef.current.scrollLeft;
      if (marginRef.current)
        marginRef.current.scrollLeft = directLabourRef.current.scrollLeft;
    } else if (sourceTable === "otherDirectCosts") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft =
          otherDirectCostsRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft =
          otherDirectCostsRef.current.scrollLeft;
      if (marginRef.current)
        marginRef.current.scrollLeft = otherDirectCostsRef.current.scrollLeft;
    } else if (sourceTable === "marginTable") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft = marginRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft = marginRef.current.scrollLeft;
      if (otherDirectCostsRef.current)
        otherDirectCostsRef.current.scrollLeft = marginRef.current.scrollLeft;
    }
  };

  const onValidateNumber = (e) => {
    const changeVal = ["-", ""].includes(e.target.value.trim())
      ? 0
      : e.target.value;
    var validNumber = new RegExp(/^-?[0-9]\d*(\.\d+)?$/);
    if (
      (!validNumber.test(changeVal) && !changeVal.toString().includes(".")) ||
      changeVal.toString().split(".").length - 1 > 1
    )
      return { isValid: false, changeVal: 0 };
    return { isValid: true, changeVal: Number(changeVal) };
  };

  const onChangeCostRateMonthly = (e, dlItem, monthItem) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === dlItem.dlId) {
        val.isUpdated = true;
        val.monthExpenseDetail.forEach((item) => {
          if (item.monthYear === monthItem.monthYear) {
            item.costRateUnloaded = e.target.value === "" ? 0 : e.target.value;
            item.isUpdated = true;
            const costRate = val.applyBurden
              ? calculateCostRateLoaded(
                  Number(changeVal),
                  val.employeeType,
                  val.isIwo,
                  detailedViewRatesData.data.fringe,
                  detailedViewRatesData.data.oh,
                  detailedViewRatesData.data.smAndH,
                  gaRate,
                )
              : Number(changeVal);
            item.costRateLoaded = costRate;
            const burdenCost =
              calculateDirectLaborBurdenCost(
                item.hours,
                costRate,
                false,
                val.laborEscalation,
                item.laborEscalationIteration,
                item.expenseDate,
                val.laborEscalationDate,
                val.startDate,
              ) +
              calculateDirectLaborBurdenCostOT(
                item.otHours,
                val.costRateLoaded,
                item.isLaborEscalationApplied,
                val.laborEscalation,
                item.laborEscalationIteration,
                val.laborEscalationDate,
                getOTFixedAmtById(val.otTypeId),
                getOTFactorById(val.otTypeId),
              );
            item.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              item.revenue = !val.billingStatus
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    val.adjustedBillRate,
                    item.hours,
                    burdenCost,
                    getFeeValue(val.clin, "feeLabor"),
                    getFeeValue(val.clin, "feeSubCon"),
                    val.employeeType,
                    val.isIwo,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.expenseDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                    val.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    val.adjustedBillRate,
                    item.otHours,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                  );
            item.isUpdated = true;
          }
        });
      }
    });
    setDirectLaborCostBind(changedData);
  };

  const onChangeCostRate = (e, id, employeeType, isIwo) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === id) {
        val.costRateUnloaded = Number(changeVal);
        val.isUpdated = true;
        const costRate = val.applyBurden
          ? calculateCostRateLoaded(
              Number(changeVal),
              val.employeeType,
              val.isIwo,
              detailedViewRatesData.data.fringe,
              detailedViewRatesData.data.oh,
              detailedViewRatesData.data.smAndH,
              gaRate,
            )
          : Number(changeVal);
        val.costRateLoaded = costRate;
        if (employeeType.toLowerCase() !== "employee" && !isIwo) {
          val.monthExpenseDetail.forEach((item) => {
            if (
              item.type.toLowerCase() === "forecast" &&
              excludedItemsForMonthly.indexOf(item.monthYear) < 0
            ) {
              let costRateUnloadedCalc = Number(changeVal);
              if (
                getMonthOnly(item.expenseDate) ===
                  getMonthOnly(val.laborEscalationDate) &&
                parseInt(getDateOnly(val.laborEscalationDate)) !== 1
              ) {
                costRateUnloadedCalc = calculateDirectLaborCostRateUnloaded(
                  costRateUnloadedCalc,
                  item.isLaborEscalationApplied,
                  val.laborEscalation,
                  item.laborEscalationIteration > 0
                    ? item.laborEscalationIteration - 1
                    : 0,
                );
              } else {
                costRateUnloadedCalc = calculateDirectLaborCostRateUnloaded(
                  costRateUnloadedCalc,
                  item.isLaborEscalationApplied,
                  val.laborEscalation,
                  item.laborEscalationIteration,
                );
              }
              item.costRateUnloaded = costRateUnloadedCalc;
              const costRateCalc = val.applyBurden
                ? calculateCostRateLoaded(
                    costRateUnloadedCalc,
                    val.employeeType,
                    val.isIwo,
                    detailedViewRatesData.data.fringe,
                    detailedViewRatesData.data.oh,
                    detailedViewRatesData.data.smAndH,
                    gaRate,
                  )
                : costRateUnloadedCalc;
              item.costRateLoaded = costRateCalc;
              const burdenCost =
                (getMonthOnly(item.expenseDate) ===
                  getMonthOnly(val.laborEscalationDate) &&
                parseInt(getDateOnly(val.laborEscalationDate)) !== 1
                  ? calculateDirectLaborBurdenCost(
                      item.hours,
                      costRate,
                      item.isLaborEscalationApplied,
                      val.laborEscalation,
                      item.laborEscalationIteration,
                      item.expenseDate,
                      val.laborEscalationDate,
                      val.startDate,
                    )
                  : calculateDirectLaborBurdenCost(
                      item.hours,
                      costRateCalc,
                      false,
                      val.laborEscalation,
                      item.laborEscalationIteration,
                      item.expenseDate,
                      val.laborEscalationDate,
                      val.startDate,
                    )) +
                calculateDirectLaborBurdenCostOT(
                  item.otHours,
                  costRate,
                  item.isLaborEscalationApplied,
                  val.laborEscalation,
                  item.laborEscalationIteration,
                  val.laborEscalationDate,
                  getOTFixedAmtById(val.otTypeId),
                  getOTFactorById(val.otTypeId),
                );
              item.burdenCost = burdenCost;
              if (detailedType !== "FFP")
                item.revenue = !val.billingStatus
                  ? 0
                  : calculateDirectLaborRevenue(
                      detailedType,
                      val.adjustedBillRate,
                      item.hours,
                      burdenCost,
                      getFeeValue(val.clin, "feeLabor"),
                      getFeeValue(val.clin, "feeSubCon"),
                      val.employeeType,
                      val.isIwo,
                      val.billRateEscalation,
                      val.billRateEscalationDate,
                      item.expenseDate,
                      item.isBillRateEscalationApplied,
                      item.billRateEscalationIteration,
                      val.startDate,
                    ) +
                    calculateDirectLaborRevenueOT(
                      detailedType,
                      val.adjustedBillRate,
                      item.otHours,
                      val.billRateEscalation,
                      val.billRateEscalationDate,
                      item.isBillRateEscalationApplied,
                      item.billRateEscalationIteration,
                    );
              item.isUpdated = true;
            }
          });
        } else {
          const monthlySalary =
            (getYearlyWorkingDays(yearValue) *
              workingHoursPerDay *
              Number(changeVal)) /
            12;
          val.monthExpenseDetail.forEach((item) => {
            if (
              item.type.toLowerCase() === "forecast" &&
              excludedItemsForMonthly.indexOf(item.monthYear) < 0
            ) {
              const costRateNonCal = roundTwoDecimals(
                Number(
                  monthlySalary /
                    (getWeekdaysInMonth(
                      parseInt(getMonthOnly(item.expenseDate)),
                      yearValue,
                    ) *
                      workingHoursPerDay),
                ),
              );
              let costRateCalculated = costRateNonCal;
              if (
                getMonthOnly(item.expenseDate) ===
                  getMonthOnly(val.laborEscalationDate) &&
                parseInt(getDateOnly(val.laborEscalationDate)) !== 1
              ) {
                costRateCalculated = calculateDirectLaborCostRateUnloaded(
                  costRateCalculated,
                  item.isLaborEscalationApplied,
                  val.laborEscalation,
                  item.laborEscalationIteration > 0
                    ? item.laborEscalationIteration - 1
                    : 0,
                );
              } else {
                costRateCalculated = calculateDirectLaborCostRateUnloaded(
                  costRateCalculated,
                  item.isLaborEscalationApplied,
                  val.laborEscalation,
                  item.laborEscalationIteration,
                );
              }
              item.costRateUnloaded = costRateCalculated;
              const costRateLoadedCalculated = val.applyBurden
                ? calculateCostRateLoaded(
                    Number(costRateCalculated),
                    val.employeeType,
                    val.isIwo,
                    detailedViewRatesData.data.fringe,
                    detailedViewRatesData.data.oh,
                    detailedViewRatesData.data.smAndH,
                    gaRate,
                  )
                : Number(costRateCalculated);
              item.costRateLoaded = roundTwoDecimals(costRateLoadedCalculated);
              const burdenCost =
                (getMonthOnly(item.expenseDate) ===
                  getMonthOnly(val.laborEscalationDate) &&
                parseInt(getDateOnly(val.laborEscalationDate)) !== 1
                  ? calculateDirectLaborBurdenCost(
                      item.hours,
                      costRateNonCal,
                      item.isLaborEscalationApplied,
                      val.laborEscalation,
                      item.laborEscalationIteration,
                      item.expenseDate,
                      val.laborEscalationDate,
                      val.startDate,
                    )
                  : calculateDirectLaborBurdenCost(
                      item.hours,
                      costRateLoadedCalculated,
                      false,
                      val.laborEscalation,
                      item.laborEscalationIteration,
                      item.expenseDate,
                      val.laborEscalationDate,
                      val.startDate,
                    )) +
                calculateDirectLaborBurdenCostOT(
                  item.otHours,
                  costRate,
                  item.isLaborEscalationApplied,
                  val.laborEscalation,
                  item.laborEscalationIteration,
                  val.laborEscalationDate,
                  getOTFixedAmtById(val.otTypeId),
                  getOTFactorById(val.otTypeId),
                );
              item.burdenCost = burdenCost;
              if (detailedType !== "FFP")
                item.revenue = !val.billingStatus
                  ? 0
                  : calculateDirectLaborRevenue(
                      detailedType,
                      val.adjustedBillRate,
                      item.hours,
                      burdenCost,
                      getFeeValue(val.clin, "feeLabor"),
                      getFeeValue(val.clin, "feeSubCon"),
                      val.employeeType,
                      val.isIwo,
                      val.billRateEscalation,
                      val.billRateEscalationDate,
                      item.expenseDate,
                      item.isBillRateEscalationApplied,
                      item.billRateEscalationIteration,
                      val.startDate,
                    ) +
                    calculateDirectLaborRevenueOT(
                      detailedType,
                      val.adjustedBillRate,
                      item.otHours,
                      val.billRateEscalation,
                      val.billRateEscalationDate,
                      item.isBillRateEscalationApplied,
                      item.billRateEscalationIteration,
                    );
              item.isUpdated = true;
            }
          });
        }
      }
    });
    setDirectLaborCostBind(changedData);
  };

  const onChangeAdjustmentBillRate = (e, id) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === id) {
        val.adjustmentBillRate = changeVal.toString().includes(".")
          ? changeVal
          : Number(changeVal);
        const calcBillRate =
          Math.round((Number(changeVal) + Number(val.billRate)) * 100) / 100;
        val.adjustedBillRate = calcBillRate;
        val.margin = calculateDirectLaborMargin(
          calcBillRate,
          val.costRateLoaded,
        );
        val.isUpdated = true;
        val.monthExpenseDetail.forEach((item) => {
          if (
            item.type.toLowerCase() === "forecast" &&
            excludedItemsForMonthly.indexOf(item.monthYear) < 0
          ) {
            const burdenCost =
              calculateDirectLaborBurdenCost(
                item.hours,
                item.costRateLoaded,
                false,
                val.laborEscalation,
                item.laborEscalationIteration,
                item.expenseDate,
                val.laborEscalationDate,
                val.startDate,
              ) +
              calculateDirectLaborBurdenCostOT(
                item.otHours,
                val.costRateLoaded,
                item.isLaborEscalationApplied,
                val.laborEscalation,
                item.laborEscalationIteration,
                val.laborEscalationDate,

                getOTFixedAmtById(val.otTypeId),
                getOTFactorById(val.otTypeId),
              );
            item.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              item.revenue = !val.billingStatus
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    calcBillRate,
                    item.hours,
                    burdenCost,
                    getFeeValue(val.clin, "feeLabor"),
                    getFeeValue(val.clin, "feeSubCon"),
                    val.employeeType,
                    val.isIwo,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.expenseDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                    val.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    calcBillRate,
                    item.otHours,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                  );
            item.isUpdated = true;
          }
        });
      }
    });
    setDirectLaborCostBind(changedData);
  };

  const onChangeDataValue = (e, id, key) => {
    // onValidateNumber is a NUMBER-only check — only run it for the numeric
    // columns this handler also serves (billRate/laborEscalation). PO Line
    // and PN are free-text/alphanumeric identifiers: running them through
    // the numeric validator rejected any non-numeric text as "invalid" and
    // silently coerced it to 0, so a typed value like "PO-1234" was never
    // actually saved — this is what let 0 reach the API even after typing.
    const isNumericKey = key === "billRate" || key === "laborEscalation";
    let changeVal;
    if (isNumericKey) {
      const { isValid, changeVal: tempVal } = onValidateNumber(e);
      if (!isValid) return false;
      changeVal = e.target.value.trim() === "" ? 0 : tempVal;
    } else {
      changeVal = e.target.value;
    }
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === id) {
        val[key] = isNumericKey ? Number(changeVal) : changeVal;
        if (key === "billRate")
          val.margin = calculateDirectLaborMargin(
            Number(changeVal),
            val.costRateLoaded,
          );
        val.isUpdated = true;
        if (key === "billRate") {
          val.monthExpenseDetail.forEach((item) => {
            if (
              item.type.toLowerCase() === "forecast" &&
              excludedItemsForMonthly.indexOf(item.monthYear) < 0
            ) {
              const burdenCost =
                calculateDirectLaborBurdenCost(
                  item.hours,
                  item.costRateLoaded,
                  false,
                  val.laborEscalation,
                  item.laborEscalationIteration,
                  item.expenseDate,
                  val.laborEscalationDate,
                  val.startDate,
                ) +
                calculateDirectLaborBurdenCostOT(
                  item.otHours,
                  val.costRateLoaded,
                  item.isLaborEscalationApplied,
                  val.laborEscalation,
                  item.laborEscalationIteration,
                  val.laborEscalationDate,
                  getOTFixedAmtById(val.otTypeId),
                  getOTFactorById(val.otTypeId),
                );
              item.burdenCost = burdenCost;
              if (detailedType !== "FFP")
                item.revenue = !val.billingStatus
                  ? 0
                  : calculateDirectLaborRevenue(
                      detailedType,
                      Number(changeVal),
                      item.hours,
                      burdenCost,
                      getFeeValue(val.clin, "feeLabor"),
                      getFeeValue(val.clin, "feeSubCon"),
                      val.employeeType,
                      val.isIwo,
                      val.billRateEscalation,
                      val.billRateEscalationDate,
                      item.expenseDate,
                      item.isBillRateEscalationApplied,
                      item.billRateEscalationIteration,
                      val.startDate,
                    ) +
                    calculateDirectLaborRevenueOT(
                      detailedType,
                      Number(changeVal),
                      item.otHours,
                      val.billRateEscalation,
                      val.billRateEscalationDate,
                      item.isBillRateEscalationApplied,
                      item.billRateEscalationIteration,
                    );
              item.isUpdated = true;
            }
          });
        } else if (key === "laborEscalation") {
          val.monthExpenseDetail.forEach((item) => {
            let costRateUnloadedCalc = val.costRateUnloaded;
            const monthlySalary =
              (getYearlyWorkingDays(yearValue) *
                workingHoursPerDay *
                Number(costRateUnloadedCalc)) /
              12;
            if (
              item.type.toLowerCase() === "forecast" &&
              excludedItemsForMonthly.indexOf(item.monthYear) < 0
            ) {
              if (val.employeeType.toLowerCase() === "employee" || val.isIwo) {
                costRateUnloadedCalc = roundTwoDecimals(
                  Number(
                    monthlySalary /
                      (getWeekdaysInMonth(
                        parseInt(getMonthOnly(item.expenseDate)),
                        yearValue,
                      ) *
                        workingHoursPerDay),
                  ),
                );
              }
              if (
                getMonthOnly(item.expenseDate) ===
                  getMonthOnly(val.laborEscalationDate) &&
                parseInt(getDateOnly(val.laborEscalationDate)) !== 1
              ) {
                costRateUnloadedCalc = calculateDirectLaborCostRateUnloaded(
                  costRateUnloadedCalc,
                  item.isLaborEscalationApplied,
                  val.laborEscalation,
                  item.laborEscalationIteration > 0
                    ? item.laborEscalationIteration - 1
                    : 0,
                );
              } else {
                costRateUnloadedCalc = calculateDirectLaborCostRateUnloaded(
                  costRateUnloadedCalc,
                  item.isLaborEscalationApplied,
                  val.laborEscalation,
                  item.laborEscalationIteration,
                );
              }
              const costRateLoadedCalculated = val.applyBurden
                ? calculateCostRateLoaded(
                    Number(costRateUnloadedCalc),
                    val.employeeType,
                    val.isIwo,
                    detailedViewRatesData.data.fringe,
                    detailedViewRatesData.data.oh,
                    detailedViewRatesData.data.smAndH,
                    gaRate,
                  )
                : Number(costRateUnloadedCalc);
              item.costRateLoaded = costRateLoadedCalculated;
              item.costRateUnloaded = costRateUnloadedCalc;
              const burdenCost =
                (getMonthOnly(item.expenseDate) ===
                  getMonthOnly(val.laborEscalationDate) &&
                parseInt(getDateOnly(val.laborEscalationDate)) !== 1
                  ? calculateDirectLaborBurdenCost(
                      item.hours,
                      val.costRateLoaded,
                      item.isLaborEscalationApplied,
                      Number(changeVal),
                      item.laborEscalationIteration,
                      item.expenseDate,
                      val.laborEscalationDate,
                      val.startDate,
                    )
                  : calculateDirectLaborBurdenCost(
                      item.hours,
                      costRateLoadedCalculated,
                      false,
                      Number(changeVal),
                      item.laborEscalationIteration,
                      item.expenseDate,
                      val.laborEscalationDate,
                      val.startDate,
                    )) +
                calculateDirectLaborBurdenCostOT(
                  item.otHours,
                  val.costRateLoaded,
                  item.isLaborEscalationApplied,
                  Number(changeVal),
                  item.laborEscalationIteration,
                  val.laborEscalationDate,
                  getOTFixedAmtById(val.otTypeId),
                  getOTFactorById(val.otTypeId),
                );
              item.burdenCost = burdenCost;
              if (detailedType !== "FFP")
                item.revenue = !val.billingStatus
                  ? 0
                  : calculateDirectLaborRevenue(
                      detailedType,
                      val.adjustedBillRate,
                      item.hours,
                      burdenCost,
                      getFeeValue(val.clin, "feeLabor"),
                      getFeeValue(val.clin, "feeSubCon"),
                      val.employeeType,
                      val.isIwo,
                      val.billRateEscalation,
                      val.billRateEscalationDate,
                      item.expenseDate,
                      item.isBillRateEscalationApplied,
                      item.billRateEscalationIteration,
                      val.startDate,
                    ) +
                    calculateDirectLaborRevenueOT(
                      detailedType,
                      val.adjustedBillRate,
                      item.otHours,
                      val.billRateEscalation,
                      val.billRateEscalationDate,
                      item.isBillRateEscalationApplied,
                      item.billRateEscalationIteration,
                    );
              item.isUpdated = true;
            }
          });
        }
      }
    });
    setDirectLaborCostBind(changedData);
  };

  const onChangeIsIwo = (e, id) => {
    const isChecked = e.target.checked;
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === id) {
        val.isIwo = isChecked;
        val.isUpdated = true;
        // IWO rows are never burdened — force Apply Burden off (and recalculate the cost
        // rate/burden cost/revenue it drives) the same way a manual "Apply Burden: No"
        // selection would, rather than leaving a stale burdened rate sitting on the row.
        // IWO employee IDs start with "V" and are treated as subcontractors elsewhere in the
        // system, but for this calculation they should be treated as "employee" (e.g. the
        // feeLabor, not feeSubCon, rate applies to their revenue) — pass that override
        // explicitly rather than falling back to the row's own (contractor) employeeType.
        if (isChecked) {
          recalcDirectLaborBurden(val, false, val.otTypeId, "employee");
        } else {
          recalcDirectLaborBurden(
            val,
            val.applyBurden,
            val.otTypeId,
            "contractor",
          );
          val.monthExpenseDetail.forEach((item) => {
            if (
              item.type.toLowerCase() === "forecast" &&
              excludedItemsForMonthly.indexOf(item.monthYear) < 0
            ) {
              item.isUpdated = true;
            }
          });
        }
      }
    });
    setDirectLaborCostBind(changedData);
  };

  const onChangeUnburdenCost = (e, odlId, id) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(otherDirectCostBind));
    changedData.otherDirectLabourDetailList.forEach((val) => {
      if (val.odlId === odlId) {
        val.isUpdated = true;
        val.monthExpenseDetail.forEach((item) => {
          if (item.id === id) {
            item.unburdenCost = changeVal.toString().includes(".")
              ? changeVal
              : Number(changeVal);
            const burdenCost = val.applyBurden
              ? calculateOtherDirectCostBurdenCost(
                  Number(changeVal),
                  gaRate,
                  smAndH,
                  val.expenseType,
                )
              : Number(changeVal);
            item.burdenCost = burdenCost;
            if (detailedType !== "FFP") {
              if (val.expenseType === "Sub Con Travel") {
                item.revenue = calculateOtherDirectCostRevenue(
                  val.billingStatus,
                  val.markUp,
                  burdenCost,
                  getFeeValue(val.clin, "feeSubCon"),
                );
              } else {
                item.revenue = calculateOtherDirectCostRevenue(
                  val.billingStatus,
                  val.markUp,
                  burdenCost,
                  getFeeValue(val.clin, "feeNonLabor"),
                );
              }
            }

            item.isUpdated = true;
          }
        });
      }
    });
    setOtherDirectCostBind(changedData);
  };

  const onChangeRevenue = (e, rvId, monthYear) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(revenueBind));
    changedData.revenueDetailList.forEach((val) => {
      if (val.rvId === rvId) {
        val.isUpdated = true;
        val.monthExpenseDetail.forEach((item) => {
          if (item.monthYear === monthYear) {
            item.isUpdated = true;
            item.adjustmentRevenue = changeVal.toString().includes(".")
              ? changeVal
              : Number(changeVal);
            item.adjustedRevenue =
              Math.round((Number(item.revenue) + Number(changeVal)) * 100) /
              100;
          }
        });
      }
    });
    setRevenueBind(changedData);
  };

  const onChangeTotalHours = (e, dlId, id) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === dlId) {
        val.isUpdated = true;
        val.monthExpenseDetail.forEach((item) => {
          if (item.id === id) {
            item.hours =
              e.target.value === ""
                ? 0
                : e.target.value.at(-1) === "."
                  ? e.target.value
                  : Number(changeVal);
            item.isUpdated = true;
            const burdenCost =
              calculateDirectLaborBurdenCost(
                Number(changeVal),
                item.costRateLoaded,
                false,
                val.laborEscalation,
                item.laborEscalationIteration,
                item.expenseDate,
                val.laborEscalationDate,
                val.startDate,
              ) +
              calculateDirectLaborBurdenCostOT(
                item.otHours,
                val.costRateLoaded,
                item.isLaborEscalationApplied,
                val.laborEscalation,
                item.laborEscalationIteration,
                val.laborEscalationDate,

                getOTFixedAmtById(val.otTypeId),
                getOTFactorById(val.otTypeId),
              );
            item.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              item.revenue = !val.billingStatus
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    val.adjustedBillRate,
                    Number(changeVal),
                    burdenCost,
                    getFeeValue(val.clin, "feeLabor"),
                    getFeeValue(val.clin, "feeSubCon"),
                    val.employeeType,
                    val.isIwo,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.expenseDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                    val.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    val.adjustedBillRate,
                    item.otHours,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                  );
          }
        });
      }
    });

    setDirectLaborCostBind(changedData);
  };

  const onChangeTotalOtHours = (e, dlId, id) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.getDirectLaborDetailList.forEach((val) => {
      if (val.dlId === dlId) {
        val.isUpdated = true;
        val.monthExpenseDetail.forEach((item) => {
          if (item.id === id) {
            item.otHours =
              e.target.value === ""
                ? 0
                : e.target.value.at(-1) === "."
                  ? e.target.value
                  : Number(changeVal);
            item.isUpdated = true;
            const burdenCost =
              calculateDirectLaborBurdenCost(
                item.hours,
                item.costRateLoaded,
                false,
                val.laborEscalation,
                item.laborEscalationIteration,
                item.expenseDate,
                val.laborEscalationDate,
                val.startDate,
              ) +
              calculateDirectLaborBurdenCostOT(
                Number(changeVal),
                val.costRateLoaded,
                item.isLaborEscalationApplied,
                val.laborEscalation,
                item.laborEscalationIteration,
                val.laborEscalationDate,

                getOTFixedAmtById(val.otTypeId),
                getOTFactorById(val.otTypeId),
              );
            item.burdenCost = burdenCost;
            if (detailedType !== "FFP")
              item.revenue = !val.billingStatus
                ? 0
                : calculateDirectLaborRevenue(
                    detailedType,
                    val.adjustedBillRate,
                    item.hours,
                    burdenCost,
                    getFeeValue(val.clin, "feeLabor"),
                    getFeeValue(val.clin, "feeSubCon"),
                    val.employeeType,
                    val.isIwo,
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.expenseDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                    val.startDate,
                  ) +
                  calculateDirectLaborRevenueOT(
                    detailedType,
                    val.adjustedBillRate,
                    Number(changeVal),
                    val.billRateEscalation,
                    val.billRateEscalationDate,
                    item.isBillRateEscalationApplied,
                    item.billRateEscalationIteration,
                  );
          }
        });
      }
    });

    setDirectLaborCostBind(changedData);
  };

  const onChangeDirectLaborAdjustment = (e, id, key) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(directLaborCostBind));
    changedData.isAdjustmentUpdated = true;
    changedData.adjustment.forEach((val) => {
      if (val.id === id) {
        val.isUpdated = true;
        val[key] = changeVal == "-" ? 0 : Number(changeVal);
      }
    });
    setDirectLaborCostBind(changedData);
  };

  const onChangeOtherDirectCostsAdjustment = (e, id, key) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(otherDirectCostBind));
    changedData.isAdjustmentUpdated = true;
    changedData.adjustment.forEach((val) => {
      if (val.id === id) {
        val.isUpdated = true;
        val[key] = changeVal == "-" ? 0 : Number(changeVal);
      }
    });
    setOtherDirectCostBind(changedData);
  };

  const onChangeFeeLabor = (e) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;

    if (parseFloat(changeVal) < 0) {
      setFeeLabor(0);
    } else if (parseFloat(changeVal) > 100) {
      setFeeLabor(100);
    } else {
      setFeeLabor(
        changeVal.toString().includes(".") ? changeVal : Number(changeVal),
      );
    }
  };

  const onChangeFeeNonLabor = (e) => {
    const changeVal = e.target.value.trim() === "" ? 0 : e.target.value;
    var validNumber = new RegExp(/^-?[0-9]\d*(\.\d+)?$/);
    if (
      (!validNumber.test(changeVal) && !changeVal.toString().includes(".")) ||
      changeVal.toString().split(".").length - 1 > 1
    )
      return false;

    if (parseFloat(changeVal) < 0) {
      setNonLaborPer(0);
    } else if (parseFloat(changeVal) > 100) {
      setNonLaborPer(100);
    } else {
      setNonLaborPer(
        changeVal.toString().includes(".") ? changeVal : Number(changeVal),
      );
    }
  };

  const onChangeFeeSubCon = (e) => {
    const changeVal = e.target.value.trim() === "" ? 0 : e.target.value;
    var validNumber = new RegExp(/^-?[0-9]\d*(\.\d+)?$/);
    if (
      (!validNumber.test(changeVal) && !changeVal.toString().includes(".")) ||
      changeVal.toString().split(".").length - 1 > 1
    )
      return false;

    if (parseFloat(changeVal) < 0) {
      setFeeSubcon(0);
    } else if (parseFloat(changeVal) > 100) {
      setFeeSubcon(100);
    } else {
      setFeeSubcon(
        changeVal.toString().includes(".") ? changeVal : Number(changeVal),
      );
    }
  };

  const bindMarginTable = () => {
    if (
      marginBind &&
      marginBind.total &&
      marginBind.total.length > 0 &&
      marginBind.netProfit &&
      marginBind.netProfit.length > 0
    ) {
      const totalForecastAdjustment =
        revenueBind && revenueBind.revenueDetailList
          ? revenueBind.revenueDetailList.reduce(
              (sum, revItem) =>
                sum +
                revItem.monthExpenseDetail
                  .filter(
                    (m) =>
                      m.type?.toLowerCase() === "forecast" &&
                      excludedItemsForMonthly.indexOf(m.monthYear) < 0,
                  )
                  .reduce((s, m) => s + Number(m.adjustmentRevenue || 0), 0),
              0,
            )
          : 0;
      return (
        <Box display="flex" flexDirection="row">
          <Box
            style={{
              boxShadow: "0px 3px 6px #00000029",
              width: detailedViewWidths.margin.firstTable.reduce(
                (tot, val) => tot + val,
              ),
              marginRight: "8px",
            }}
          >
            <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr className="totalRow">
                  <td
                    style={{
                      minWidth: detailedViewWidths.margin.firstTable[0],
                      maxWidth: detailedViewWidths.margin.firstTable[0],
                      textAlign: "right",
                      paddingRight: "8px",
                    }}
                  >
                    Total Cost
                  </td>
                </tr>
                <tr className="totalRow">
                  <td
                    style={{
                      minWidth: detailedViewWidths.margin.firstTable[0],
                      maxWidth: detailedViewWidths.margin.firstTable[0],
                      textAlign: "right",
                      paddingRight: "8px",
                    }}
                  >
                    Net Profit
                  </td>
                </tr>
                <tr className="totalRow">
                  <td
                    style={{
                      minWidth: detailedViewWidths.margin.firstTable[0],
                      maxWidth: detailedViewWidths.margin.firstTable[0],
                      textAlign: "right",
                      paddingRight: "8px",
                    }}
                  >
                    Net Profit%
                  </td>
                </tr>
              </tbody>
            </table>
          </Box>
          {detailedType === "FFP" ? (
            <Box
              ref={marginRef}
              style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
              onScroll={() => handleScrollTable("marginTable")}
            >
              <Box display="flex" flexDirection="row">
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                    marginRight: "8px",
                  }}
                >
                  <table
                    className="secondTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr className="cumulativeTotalRow">
                        <td
                          colSpan={10}
                          style={{
                            minWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                        />
                        {marginBind.total
                          .filter(
                            (val) =>
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                              0,
                          )
                          .map((item, i) => {
                            const totalBurdenCost = calculateTotalMonthlyMargin(
                              directLaborCostBind,
                              otherDirectCostBind,
                              "burdenCost",
                              item.monthYear,
                            );
                            const totalRevenue = calculateTotalMonthlyMargin(
                              directLaborCostBind,
                              otherDirectCostBind,
                              "revenue",
                              item.monthYear,
                            );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totalBurdenCost}
                                >
                                  {`${convertValuesFM(totalBurdenCost)}`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                      <tr className="cumulativeTotalRow">
                        <td
                          colSpan={10}
                          style={{
                            minWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                        />
                        {marginBind.netProfit
                          .filter(
                            (val) =>
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                              0,
                          )
                          .map((item, i) => {
                            const netProfit = calculateNetProfitFFP(
                              revenueBind,
                              directLaborCostBind,
                              otherDirectCostBind,
                              item.monthYear,
                            );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={netProfit}
                                >
                                  {`${convertValuesFM(netProfit)}`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                      <tr className="cumulativeTotalRow">
                        <td
                          colSpan={10}
                          style={{
                            minWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                        />
                        {marginBind.netProfitPercent
                          .filter(
                            (val) =>
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                              0,
                          )
                          .map((item, i) => {
                            const netProfitPer = calculateNetProfitPecentageFFP(
                              revenueBind,
                              directLaborCostBind,
                              otherDirectCostBind,
                              item.monthYear,
                            );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />

                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={`${netProfitPer}%`}
                                >
                                  {netProfitPer < 0
                                    ? `(${Math.abs(netProfitPer).toFixed(2)}%)`
                                    : `${netProfitPer.toFixed(2)}%`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                    </tbody>
                  </table>
                </Box>
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                  }}
                >
                  <table
                    className="thirdTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr className="cumulativeTotalRow">
                        {marginBind.total
                          .filter((val) => val.monthYear === "ITD")
                          .map((item, i) => {
                            const otherActualsItem = marginBind.total.filter(
                              (value) =>
                                value.monthYear === "Other Year Actual",
                            )[0];
                            let otherYearCost = 0;
                            if (otherActualsItem) {
                              otherYearCost = otherActualsItem.burdenCost;
                            }
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={item.burdenCost + otherYearCost}
                                >
                                  {`${convertValuesFM(
                                    item.burdenCost + otherYearCost,
                                  )}`}
                                </td>
                              </>
                            );
                          })}
                        {marginBind.total
                          .filter(
                            (val) => val.monthYear === "Remaining Forecast",
                          )
                          .map((item, i) => {
                            const totaBurdenCost =
                              calculateTotalRemainingForecastMargin(
                                directLaborCostBind,
                                otherDirectCostBind,
                                "burdenCost",
                              );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totaBurdenCost}
                                >
                                  {`${convertValuesFM(totaBurdenCost)}`}
                                </td>
                              </>
                            );
                          })}
                        {marginBind.total
                          .filter((val) => val.monthYear === "Total")
                          .map((item, i) => {
                            const totaBurdenCost = calculateTotalMarginTotal(
                              directLaborCostBind,
                              otherDirectCostBind,
                              "burdenCost",
                            );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    paddingLeft: "4px",
                                    borderLeft: "1px solid #ccc",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totaBurdenCost}
                                >
                                  {`${convertValuesFM(totaBurdenCost)}`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                      <tr className="cumulativeTotalRow">
                        {marginBind.netProfit
                          .filter((val) => val.monthYear === "ITD")
                          .map((item, i) => (
                            <>
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  paddingLeft: "4px",
                                }}
                              />

                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                }}
                                title={calculateFFPITDNetProfit(
                                  revenueBind,
                                  marginBind,
                                )}
                              >
                                {`${convertValuesFM(
                                  calculateFFPITDNetProfit(
                                    revenueBind,
                                    marginBind,
                                  ),
                                )}`}
                              </td>
                            </>
                          ))}
                        {marginBind.netProfit
                          .filter(
                            (val) => val.monthYear === "Remaining Forecast",
                          )
                          .map((item, i) => {
                            const totalVal =
                              calculateNetProfitRemainingForecastFFP(
                                revenueBind,
                                directLaborCostBind,
                                otherDirectCostBind,
                              );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />

                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totalVal}
                                >
                                  {`${convertValuesFM(totalVal)}`}
                                </td>
                              </>
                            );
                          })}
                        {marginBind.netProfit
                          .filter((val) => val.monthYear === "Total")
                          .map((item, i) => {
                            const totalVal = calculateNetProfitTotalFFP(
                              revenueBind,
                              directLaborCostBind,
                              otherDirectCostBind,
                            );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    paddingLeft: "4px",
                                    borderLeft: "1px solid #ccc",
                                  }}
                                />

                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totalVal}
                                >
                                  {`${convertValuesFM(totalVal)}`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                      <tr className="cumulativeTotalRow">
                        {marginBind.netProfitPercent
                          .filter((val) => val.monthYear === "ITD")
                          .map((item, i) => (
                            <>
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  paddingLeft: "4px",
                                }}
                              />

                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                }}
                                title={`${calculateFFPITDNetProfitPercentage(
                                  revenueBind,
                                  marginBind,
                                )}%`}
                              >
                                {calculateFFPITDNetProfitPercentage(
                                  revenueBind,
                                  marginBind,
                                ) < 0
                                  ? `(${Math.abs(
                                      calculateFFPITDNetProfitPercentage(
                                        revenueBind,
                                        marginBind,
                                      ),
                                    ).toFixed(2)}%)`
                                  : `${calculateFFPITDNetProfitPercentage(
                                      revenueBind,
                                      marginBind,
                                    ).toFixed(2)}%`}
                              </td>
                            </>
                          ))}
                        {marginBind.netProfitPercent
                          .filter(
                            (val) => val.monthYear === "Remaining Forecast",
                          )
                          .map((item, i) => {
                            const totalVal =
                              calculateNetProfitPecentageRemainingForecastFFP(
                                revenueBind,
                                directLaborCostBind,
                                otherDirectCostBind,
                              );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />

                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={`${totalVal}%`}
                                >
                                  {totalVal < 0
                                    ? `(${Math.abs(totalVal).toFixed(2)}%)`
                                    : `${totalVal.toFixed(2)}%`}
                                </td>
                              </>
                            );
                          })}
                        {marginBind.netProfitPercent
                          .filter((val) => val.monthYear === "Total")
                          .map((item, i) => {
                            const totalVal =
                              calculateNetProfitPecentageTotalFFP(
                                revenueBind,
                                directLaborCostBind,
                                otherDirectCostBind,
                              );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    paddingLeft: "4px",
                                    borderLeft: "1px solid #ccc",
                                  }}
                                />

                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={`${totalVal}%`}
                                >
                                  {totalVal < 0
                                    ? `(${Math.abs(totalVal).toFixed(2)}%)`
                                    : `${totalVal.toFixed(2)}%`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                    </tbody>
                  </table>
                </Box>
              </Box>
            </Box>
          ) : (
            <Box
              ref={marginRef}
              style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
              onScroll={() => handleScrollTable("marginTable")}
            >
              <Box display="flex" flexDirection="row">
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                    marginRight: "8px",
                  }}
                >
                  <table
                    className="secondTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr className="cumulativeTotalRow">
                        <td
                          colSpan={detailedType === "TM" ? 14 : 10}
                          style={{
                            minWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                        />
                        {marginBind.total
                          .filter(
                            (val) =>
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                              0,
                          )
                          .map((item, i) => {
                            const isForecastMonth =
                              item.type.toLowerCase() === "forecast";
                            const monthAdjustment = isForecastMonth
                              ? revenueBind && revenueBind.revenueDetailList
                                ? revenueBind.revenueDetailList.reduce(
                                    (sum, revItem) => {
                                      const md =
                                        revItem.monthExpenseDetail.find(
                                          (m) => m.monthYear === item.monthYear,
                                        );
                                      return (
                                        sum + Number(md?.adjustmentRevenue || 0)
                                      );
                                    },
                                    0,
                                  )
                                : 0
                              : 0;
                            const totalBurdenCost = calculateTotalMonthlyMargin(
                              directLaborCostBind,
                              otherDirectCostBind,
                              "burdenCost",
                              item.monthYear,
                            );
                            const totalRevenue = isForecastMonth
                              ? calculateTotalMonthlyMargin(
                                  directLaborCostBind,
                                  otherDirectCostBind,
                                  "revenue",
                                  item.monthYear,
                                ) + monthAdjustment
                              : calculateMonthlyRevenueForMargin(
                                  revenueBind,
                                  item.monthYear,
                                );
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totalBurdenCost}
                                >
                                  {`${convertValuesFM(totalBurdenCost)}`}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={totalRevenue}
                                >
                                  {`${convertValuesFM(totalRevenue)}`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                      <tr className="cumulativeTotalRow">
                        <td
                          colSpan={detailedType === "TM" ? 14 : 10}
                          style={{
                            minWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                        />
                        {marginBind.netProfit
                          .filter(
                            (val) =>
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                              0,
                          )
                          .map((item, i) => {
                            const isForecastMonthNP = headersData.some(
                              (h) =>
                                h.heading === item.monthYear &&
                                h.type?.toLowerCase() === "forecast",
                            );
                            const monthAdjustmentNP = isForecastMonthNP
                              ? revenueBind && revenueBind.revenueDetailList
                                ? revenueBind.revenueDetailList.reduce(
                                    (sum, revItem) => {
                                      const md =
                                        revItem.monthExpenseDetail.find(
                                          (m) => m.monthYear === item.monthYear,
                                        );
                                      return (
                                        sum + Number(md?.adjustmentRevenue || 0)
                                      );
                                    },
                                    0,
                                  )
                                : 0
                              : 0;
                            const netProfit =
                              calculateNetProfit(
                                directLaborCostBind,
                                otherDirectCostBind,
                                item.monthYear,
                                isForecastMonthNP ? "Forecast" : "Actual",
                                revenueBind,
                              ) + monthAdjustmentNP;
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                ></td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={netProfit}
                                >
                                  {`${convertValuesFM(netProfit)}`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                      <tr className="cumulativeTotalRow">
                        <td
                          colSpan={detailedType === "TM" ? 14 : 10}
                          style={{
                            minWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.margin.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                        />
                        {marginBind.netProfitPercent
                          .filter(
                            (val) =>
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                              0,
                          )
                          .map((item, i) => {
                            const isForecastMonthPer = headersData.some(
                              (h) =>
                                h.heading === item.monthYear &&
                                h.type?.toLowerCase() === "forecast",
                            );
                            const monthAdjustmentPer = isForecastMonthPer
                              ? revenueBind && revenueBind.revenueDetailList
                                ? revenueBind.revenueDetailList.reduce(
                                    (sum, revItem) => {
                                      const md =
                                        revItem.monthExpenseDetail.find(
                                          (m) => m.monthYear === item.monthYear,
                                        );
                                      return (
                                        sum + Number(md?.adjustmentRevenue || 0)
                                      );
                                    },
                                    0,
                                  )
                                : 0
                              : 0;
                            const netProfitPer = (() => {
                              const totalRevAdj =
                                calculateNetProfit(
                                  directLaborCostBind,
                                  otherDirectCostBind,
                                  item.monthYear,
                                  isForecastMonthPer ? "Forecast" : "Actual",
                                  revenueBind,
                                ) + monthAdjustmentPer;
                              const totalRevForPer = isForecastMonthPer
                                ? parseInt(
                                    calculateTotalMonthlyMargin(
                                      directLaborCostBind,
                                      otherDirectCostBind,
                                      "revenue",
                                      item.monthYear,
                                    ),
                                  ) + monthAdjustmentPer
                                : parseInt(
                                    calculateMonthlyRevenueForMargin(
                                      revenueBind,
                                      item.monthYear,
                                    ),
                                  );
                              if (totalRevForPer > 0)
                                return (
                                  Math.round(
                                    (parseInt(totalRevAdj) / totalRevForPer) *
                                      100 *
                                      100,
                                  ) / 100
                                );
                              return 0;
                            })();
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                ></td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={`${netProfitPer}%`}
                                >
                                  {netProfitPer < 0
                                    ? `(${Math.abs(netProfitPer).toFixed(2)}%)`
                                    : `${netProfitPer.toFixed(2)}%`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                    </tbody>
                  </table>
                </Box>
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                  }}
                >
                  <table
                    className="thirdTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr className="cumulativeTotalRow">
                        {marginBind.total
                          .filter((val) => val.monthYear === "ITD")
                          .map((item, i) => {
                            const otherActualsItem = marginBind.total.filter(
                              (value) =>
                                value.monthYear === "Other Year Actual",
                            )[0];
                            let otherYearCost = 0;
                            if (otherActualsItem) {
                              otherYearCost = otherActualsItem.burdenCost;
                            }
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={item.burdenCost + otherYearCost}
                                >
                                  {`${convertValuesFM(
                                    item.burdenCost + otherYearCost,
                                  )}`}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={calculateMarginITDTotal(revenueBind)}
                                >
                                  {`${convertValuesFM(
                                    calculateMarginITDTotal(revenueBind),
                                  )}`}
                                </td>
                              </>
                            );
                          })}
                        {marginBind.total
                          .filter(
                            (val) => val.monthYear === "Remaining Forecast",
                          )
                          .map((item, i) => {
                            const totaBurdenCost =
                              calculateTotalRemainingForecastMargin(
                                directLaborCostBind,
                                otherDirectCostBind,
                                "burdenCost",
                              );
                            const totalRevenue =
                              calculateTotalRemainingForecastMargin(
                                directLaborCostBind,
                                otherDirectCostBind,
                                "revenue",
                              ) + totalForecastAdjustment;
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totaBurdenCost}
                                >
                                  {`${convertValuesFM(totaBurdenCost)}`}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={totalRevenue}
                                >
                                  {`${convertValuesFM(totalRevenue)}`}
                                </td>
                              </>
                            );
                          })}
                        {marginBind.total
                          .filter((val) => val.monthYear === "Total")
                          .map((item, i) => {
                            const totaBurdenCost = calculateTotalMarginTotal(
                              directLaborCostBind,
                              otherDirectCostBind,
                              "burdenCost",
                            );
                            let totalRevenue =
                              calculateTotalRemainingForecastMargin(
                                directLaborCostBind,
                                otherDirectCostBind,
                                "revenue",
                              ) + totalForecastAdjustment;
                            totalRevenue +=
                              calculateMarginITDTotal(revenueBind);
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    paddingLeft: "4px",
                                    borderLeft: "1px solid #ccc",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totaBurdenCost}
                                >
                                  {`${convertValuesFM(totaBurdenCost)}`}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={totalRevenue}
                                >
                                  {`${convertValuesFM(totalRevenue)}`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                      <tr className="cumulativeTotalRow">
                        {marginBind.netProfit
                          .filter((val) => val.monthYear === "ITD")
                          .map((item, i) => (
                            <>
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  paddingLeft: "4px",
                                }}
                              />
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                }}
                              ></td>
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[2],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[2],
                                }}
                                title={calculateITDMarginNetProfit(
                                  revenueBind,
                                  marginBind,
                                )}
                              >
                                {`${convertValuesFM(
                                  calculateITDMarginNetProfit(
                                    revenueBind,
                                    marginBind,
                                  ),
                                )}`}
                              </td>
                            </>
                          ))}
                        {marginBind.netProfit
                          .filter(
                            (val) => val.monthYear === "Remaining Forecast",
                          )
                          .map((item, i) => {
                            const totalVal =
                              calculateNetProfitRemainingForecast(
                                directLaborCostBind,
                                otherDirectCostBind,
                              ) + totalForecastAdjustment;
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                ></td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={totalVal}
                                >
                                  {`${convertValuesFM(totalVal)}`}
                                </td>
                              </>
                            );
                          })}
                        {marginBind.netProfit
                          .filter((val) => val.monthYear === "Total")
                          .map((item, i) => {
                            const totalVal =
                              calculateNetProfitTotal(
                                directLaborCostBind,
                                otherDirectCostBind,
                                revenueBind,
                              ) + totalForecastAdjustment;
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    paddingLeft: "4px",
                                    borderLeft: "1px solid #ccc",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                ></td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={totalVal}
                                >
                                  {`${convertValuesFM(totalVal)}`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                      <tr className="cumulativeTotalRow">
                        {marginBind.netProfitPercent
                          .filter((val) => val.monthYear === "ITD")
                          .map((item, i) => (
                            <>
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  paddingLeft: "4px",
                                }}
                              />
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                }}
                              ></td>
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[2],
                                  maxWidth:
                                    detailedViewWidths.margin.fourtTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[2],
                                }}
                                title={`${calculateNetProfitPecentageITD(
                                  revenueBind,
                                  marginBind,
                                )}%`}
                              >
                                {calculateNetProfitPecentageITD(
                                  revenueBind,
                                  marginBind,
                                ) < 0
                                  ? `(${Math.abs(
                                      calculateNetProfitPecentageITD(
                                        revenueBind,
                                        marginBind,
                                      ),
                                    ).toFixed(2)}%)`
                                  : `${calculateNetProfitPecentageITD(
                                      revenueBind,
                                      marginBind,
                                    ).toFixed(2)}%`}
                              </td>
                            </>
                          ))}
                        {marginBind.netProfitPercent
                          .filter(
                            (val) => val.monthYear === "Remaining Forecast",
                          )
                          .map((item, i) => {
                            const rfRevenue =
                              parseInt(
                                calculateTotalRemainingForecastMargin(
                                  directLaborCostBind,
                                  otherDirectCostBind,
                                  "revenue",
                                ),
                              ) + totalForecastAdjustment;
                            const rfNetProfit =
                              calculateNetProfitRemainingForecast(
                                directLaborCostBind,
                                otherDirectCostBind,
                              ) + totalForecastAdjustment;
                            const totalVal =
                              rfRevenue > 0
                                ? Math.round(
                                    (parseInt(rfNetProfit) / rfRevenue) *
                                      100 *
                                      100,
                                  ) / 100
                                : 0;
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                ></td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={`${totalVal}%`}
                                >
                                  {totalVal < 0
                                    ? `(${Math.abs(totalVal).toFixed(2)}%)`
                                    : `${totalVal.toFixed(2)}%`}
                                </td>
                              </>
                            );
                          })}
                        {marginBind.netProfitPercent
                          .filter((val) => val.monthYear === "Total")
                          .map((item, i) => {
                            const totalRevTotal =
                              calculateTotalRemainingForecastMargin(
                                directLaborCostBind,
                                otherDirectCostBind,
                                "revenue",
                              ) +
                              calculateMarginITDTotal(revenueBind) +
                              totalForecastAdjustment;
                            const netProfitTotal =
                              calculateNetProfitTotal(
                                directLaborCostBind,
                                otherDirectCostBind,
                                revenueBind,
                              ) + totalForecastAdjustment;
                            const totalVal =
                              totalRevTotal > 0
                                ? Math.round(
                                    (parseInt(netProfitTotal) / totalRevTotal) *
                                      100 *
                                      100,
                                  ) / 100
                                : 0;
                            return (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    paddingLeft: "4px",
                                    borderLeft: "1px solid #ccc",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                ></td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.margin.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={`${totalVal}%`}
                                >
                                  {totalVal < 0
                                    ? `(${Math.abs(totalVal).toFixed(2)}%)`
                                    : `${totalVal.toFixed(2)}%`}
                                </td>
                              </>
                            );
                          })}
                      </tr>
                    </tbody>
                  </table>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      );
    } else {
      return (
        <div
          style={{
            textAlign: "center",
            fontWeight: 600,
            background: "#fff",
            padding: "24px 0",
          }}
        >
          No Data
        </div>
      );
    }
  };

  const handleRevenueSort = (key) => {
    let direction = "asc";
    if (revenueSort.key === key && revenueSort.direction === "asc") {
      direction = "desc";
    }
    setRevenueSort({ key, direction });
  };

  const handleDirectLaborSort = (key) => {
    let direction = "asc";
    if (directLaborSort.key === key && directLaborSort.direction === "asc") {
      direction = "desc";
    }
    setDirectLaborSort({ key, direction });
  };

  const handleOtherDirectCostSort = (key) => {
    let direction = "asc";
    if (
      otherDirectCostSort.key === key &&
      otherDirectCostSort.direction === "asc"
    ) {
      direction = "desc";
    }
    setOtherDirectCostSort({ key, direction });
  };

  const bindRevenueTable = () => {
    if (
      revenueBind &&
      revenueBind.revenueDetailList &&
      revenueBind.revenueDetailList.length > 0
    ) {
      return (
        <>
          {detailedType === "FFP" ? (
            <Box display={"flex"} flexDirection={"column"}>
              <Box display="flex" flexDirection="row">
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                    width:
                      detailedViewWidths.revenue.firstTable[0] +
                      detailedViewWidths.revenue.firstTable[1] +
                      detailedViewWidths.revenue.firstTable[2] +
                      detailedViewWidths.revenue.firstTable[3],
                    marginRight: "8px",
                  }}
                >
                  <table
                    className="firstTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            minWidth: detailedViewWidths.revenue.firstTable[0],
                            maxWidth: detailedViewWidths.revenue.firstTable[0],
                            cursor: "pointer",
                          }}
                          onClick={() => handleRevenueSort("clin")}
                        >
                          CLIN{" "}
                          {revenueSort.key === "clin"
                            ? revenueSort.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}
                        </th>
                        <th
                          style={{
                            minWidth: detailedViewWidths.revenue.firstTable[1],
                            maxWidth: detailedViewWidths.revenue.firstTable[1],
                          }}
                        >
                          Clin Start Date
                        </th>
                        <th
                          style={{
                            minWidth: detailedViewWidths.revenue.firstTable[2],
                            maxWidth: detailedViewWidths.revenue.firstTable[2],
                          }}
                        >
                          Clin End Date
                        </th>
                        <th
                          style={{
                            minWidth: detailedViewWidths.revenue.firstTable[3],
                            maxWidth: detailedViewWidths.revenue.firstTable[3],
                          }}
                        >
                          Revised Clin End Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRevenue.map((item, i) => (
                        <>
                          <tr key={i}>
                            <td
                              title={item.clin}
                              style={{
                                minWidth:
                                  detailedViewWidths.revenue.firstTable[0],
                                maxWidth:
                                  detailedViewWidths.revenue.firstTable[0],
                                height: "105px",
                              }}
                            >
                              {item.clin}
                            </td>
                            <td
                              title={
                                item.clinStartDate && item.clinStartDate !== ""
                                  ? formatDateBySetting(
                                      new Date(
                                        item.clinStartDate.replace(/-/g, "/"),
                                      ),
                                      dateFormat,
                                    )
                                  : "NA"
                              }
                              style={{
                                minWidth:
                                  detailedViewWidths.revenue.firstTable[1],
                                maxWidth:
                                  detailedViewWidths.revenue.firstTable[1],
                                height: "105px",
                              }}
                            >
                              {item.clinStartDate && item.clinStartDate !== ""
                                ? formatDateBySetting(
                                    new Date(
                                      item.clinStartDate.replace(/-/g, "/"),
                                    ),
                                    dateFormat,
                                  )
                                : "NA"}
                            </td>
                            <td
                              title={
                                item.clinEndDate && item.clinEndDate !== ""
                                  ? formatDateBySetting(
                                      new Date(
                                        item.clinEndDate.replace(/-/g, "/"),
                                      ),
                                      dateFormat,
                                    )
                                  : "NA"
                              }
                              style={{
                                minWidth:
                                  detailedViewWidths.revenue.firstTable[2],
                                maxWidth:
                                  detailedViewWidths.revenue.firstTable[2],
                                height: "105px",
                              }}
                            >
                              {item.clinEndDate && item.clinEndDate !== ""
                                ? formatDateBySetting(
                                    new Date(
                                      item.clinEndDate.replace(/-/g, "/"),
                                    ),
                                    dateFormat,
                                  )
                                : "NA"}
                            </td>
                            <td
                              title={
                                item.revisedClinEndDate &&
                                item.revisedClinEndDate !== ""
                                  ? formatDateBySetting(
                                      new Date(
                                        item.revisedClinEndDate.replace(
                                          /-/g,
                                          "/",
                                        ),
                                      ),
                                      dateFormat,
                                    )
                                  : "NA"
                              }
                              style={{
                                minWidth:
                                  detailedViewWidths.revenue.firstTable[3],
                                maxWidth:
                                  detailedViewWidths.revenue.firstTable[3],
                                height: "105px",
                                position: "relative",
                              }}
                            >
                              {!isEdit &&
                              isEditEndDate &&
                              dateEditedId === item.rvId ? (
                                <>
                                  <CustomDatePicker
                                    dateFormat={dateFormat}
                                    dateValue={
                                      updatedReviseDate
                                        ? getDate(updatedReviseDate)
                                        : getDate(item.revisedClinEndDate)
                                    }
                                    setDateValue={(date) => {
                                      setUpdatedReviseDate(
                                        formatDateBySetting(
                                          getDate(date),
                                          "YYYY-MM-DD",
                                        ),
                                      );
                                    }}
                                    itemWidth="120px"
                                  />
                                </>
                              ) : (
                                <span style={{ float: "left" }}>
                                  {item.revisedClinEndDate &&
                                  item.revisedClinEndDate !== ""
                                    ? formatDateBySetting(
                                        new Date(
                                          item.revisedClinEndDate.replace(
                                            /-/g,
                                            "/",
                                          ),
                                        ),
                                        dateFormat,
                                      )
                                    : "NA"}
                                </span>
                              )}
                              {!isEdit && (
                                <>
                                  {isEditEndDate &&
                                  dateEditedId === item.rvId ? (
                                    <span
                                      style={{
                                        position: "absolute",
                                        right: "2px",
                                        top: "44px",
                                      }}
                                    >
                                      <CheckCircleIcon
                                        className={classes.checkCircleIcon}
                                        onClick={() => {
                                          updateClinReviseDate({
                                            rvnId: dateEditedId,
                                            contractId: contractId,
                                            revisedClinEndDate:
                                              updatedReviseDate,
                                            templateType: detailedType,
                                          });
                                        }}
                                      />
                                      <CancelIcon
                                        className={classes.cancelIcon}
                                        onClick={() => {
                                          setIsEditEndDate(false);
                                          setDateEditedId("");
                                          setUpdatedReviseDate(null);
                                        }}
                                      />
                                    </span>
                                  ) : getVersionStatus.toLowerCase() ===
                                      "open" &&
                                    localStorage.getItem("accessType") ===
                                      "RW" ? (
                                    <span>
                                      <EditIcon
                                        className={classes.editIconDate}
                                        style={{
                                          float: "left",
                                          margin: "2px 0 0 4px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setIsEditEndDate(true);
                                          setDateEditedId(item.rvId);
                                          setUpdatedReviseDate(
                                            item.revisedClinEndDate,
                                          );
                                        }}
                                      />
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        </>
                      ))}
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            textAlign: "right",
                            fontWeight: 600,
                            paddingRight: "8px",
                          }}
                        >
                          Total
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Box>
                <Box
                  ref={revenuTableRef}
                  style={{
                    overflowX: "auto",
                    boxShadow: "0px 3px 6px #00000029",
                  }}
                  onScroll={() => handleScrollTable("revenueTable")}
                >
                  <Box display="flex" flexDirection="row">
                    <Box
                      style={{
                        boxShadow: "0px 3px 6px #00000029",
                        marginRight: "8px",
                      }}
                    >
                      <table
                        className="secondTableFin"
                        cellPadding={0}
                        cellSpacing={0}
                      >
                        <thead>
                          <tr>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                            >
                              Contract Value
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                              }}
                            >
                              Funded Value
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                              }}
                            >
                              ITD Actuals till 2024
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                              }}
                            >
                              Est. At Completion
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[4],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[4],
                              }}
                            >
                              Remaining Funding
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[5],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[5],
                              }}
                            >
                              Revenue
                            </th>
                            {headersData.map((item, i) => (
                              <th
                                key={i}
                                className="centerAlignedHeaderLeftBorder"
                                style={{
                                  maxWidth:
                                    detailedViewWidths.revenue.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  minWidth:
                                    detailedViewWidths.revenue.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                }}
                              >
                                {item.heading}
                              </th>
                            ))}
                          </tr>
                          <tr>
                            {headersData.map((item, i) => (
                              <th
                                key={i}
                                className={
                                  item.type === "Actual"
                                    ? `actualsHeaderCell`
                                    : `forecastHeaderCell`
                                }
                              >
                                {item.type === "Actual"
                                  ? `Actuals`
                                  : `Forecast`}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {filteredRevenue.map((item, i) => {
                            const totalRevenue = calculateFFPESTRevenueById(
                              item,
                              "adjustedRevenue",
                            );
                            const remainingFund =
                              Math.round(
                                Number(
                                  item.fundedValue -
                                    totalRevenue -
                                    item.priorYearActual,
                                ) * 100,
                              ) / 100;
                            return (
                              <>
                                <tr key={i}>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={item.contractValue}
                                  >{`${convertValuesFM(
                                    item.contractValue,
                                  )}`}</td>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={item.fundedValue}
                                  >{`${convertValuesFM(item.fundedValue)}`}</td>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={item.priorYearActual}
                                  >{`${convertValuesFM(
                                    item.priorYearActual,
                                  )}`}</td>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[3],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[3],
                                    }}
                                    title={totalRevenue}
                                  >{`${convertValuesFM(totalRevenue)}`}</td>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[4],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[4],
                                    }}
                                    title={remainingFund}
                                  >{`${convertValuesFM(remainingFund)}`}</td>
                                  <td
                                    title={item.revenue}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      paddingLeft: "8px",
                                      borderLeft: "1px solid #ccc",
                                    }}
                                  >
                                    {item.revenue}
                                  </td>
                                  {item.monthExpenseDetail
                                    .filter(
                                      (val) =>
                                        excludedItemsForMonthly.indexOf(
                                          val.monthYear,
                                        ) < 0,
                                    )
                                    .map((monthItem, j) => (
                                      <>
                                        {!monthItem.isDummy ? (
                                          <td
                                            key={j}
                                            className="centerAlignedDataLeftBorder"
                                            style={{
                                              maxWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                              minWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                            }}
                                            title={monthItem.revenue}
                                          >
                                            {convertValuesFM(monthItem.revenue)}
                                          </td>
                                        ) : (
                                          <td
                                            key={j}
                                            className="centerAlignedDataLeftBorder"
                                            style={{
                                              maxWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                              minWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                            }}
                                          />
                                        )}
                                      </>
                                    ))}
                                </tr>

                                <tr>
                                  <td
                                    title={item.revenue}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      paddingLeft: "8px",
                                      borderLeft: "1px solid #ccc",
                                    }}
                                  >
                                    Adjustment Revenue
                                  </td>
                                  {item.monthExpenseDetail
                                    .filter(
                                      (val) =>
                                        excludedItemsForMonthly.indexOf(
                                          val.monthYear,
                                        ) < 0,
                                    )
                                    .map((monthItem, j) => (
                                      <>
                                        {!monthItem.isDummy ? (
                                          <td
                                            key={j}
                                            className="centerAlignedDataLeftBorder"
                                            style={{
                                              maxWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                              minWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                            }}
                                            title={monthItem.adjustmentRevenue}
                                          >
                                            {isEdit &&
                                            monthItem.type.toLowerCase() ===
                                              "forecast" ? (
                                              <input
                                                type="text"
                                                style={{
                                                  width: "70px",
                                                  border: "1px solid #ccc",
                                                  borderRadius: "3px",
                                                  padding: "2px",
                                                }}
                                                defaultValue={
                                                  monthItem.adjustmentRevenue
                                                }
                                                onChange={(e) =>
                                                  onChangeRevenue(
                                                    e,
                                                    item.rvId,
                                                    monthItem.monthYear,
                                                  )
                                                }
                                              />
                                            ) : (
                                              `${convertValuesFM(
                                                monthItem.adjustmentRevenue,
                                              )}`
                                            )}
                                          </td>
                                        ) : (
                                          <td
                                            key={j}
                                            className="centerAlignedDataLeftBorder"
                                            style={{
                                              maxWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                              minWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                            }}
                                          />
                                        )}
                                      </>
                                    ))}
                                </tr>

                                <tr>
                                  <td
                                    title={item.revenue}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      paddingLeft: "8px",
                                      borderLeft: "1px solid #ccc",
                                    }}
                                  >
                                    Adjusted Revenue
                                  </td>
                                  {item.monthExpenseDetail
                                    .filter(
                                      (val) =>
                                        excludedItemsForMonthly.indexOf(
                                          val.monthYear,
                                        ) < 0,
                                    )
                                    .map((monthItem, j) => (
                                      <>
                                        {!monthItem.isDummy ? (
                                          <td
                                            key={j}
                                            className="centerAlignedDataLeftBorder"
                                            style={{
                                              maxWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                              minWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                            }}
                                            title={monthItem.adjustedRevenue}
                                          >
                                            {convertValuesFM(
                                              monthItem.adjustedRevenue,
                                            )}
                                          </td>
                                        ) : (
                                          <td
                                            key={j}
                                            className="centerAlignedDataLeftBorder"
                                            style={{
                                              maxWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                              minWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                            }}
                                          />
                                        )}
                                      </>
                                    ))}
                                </tr>
                              </>
                            );
                          })}
                          <tr className="totalDataRow">
                            <td
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                              title={calculateTotalContractFunded(
                                revenueBind,
                                "contractValue",
                              )}
                            >{`${convertValuesFM(
                              calculateTotalContractFunded(
                                revenueBind,
                                "contractValue",
                              ),
                            )}`}</td>
                            <td
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                              }}
                              title={calculateTotalContractFunded(
                                revenueBind,
                                "fundedValue",
                              )}
                            >{`${convertValuesFM(
                              calculateTotalContractFunded(
                                revenueBind,
                                "fundedValue",
                              ),
                            )}`}</td>
                            <td
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                              }}
                              title={calculateTotalContractFunded(
                                revenueBind,
                                "priorYearActual",
                              )}
                            >{`${convertValuesFM(
                              calculateTotalContractFunded(
                                revenueBind,
                                "priorYearActual",
                              ),
                            )}`}</td>
                            <td
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                              }}
                              title={calculateFFPTotalESTRevenue(revenueBind)}
                            >{`${convertValuesFM(
                              calculateFFPTotalESTRevenue(revenueBind),
                            )}`}</td>
                            <td
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[4],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[4],
                              }}
                              title={
                                calculateTotalContractFunded(
                                  revenueBind,
                                  "fundedValue",
                                ) - calculateFFPTotalESTRevenue(revenueBind)
                              }
                            >{`${convertValuesFM(
                              calculateTotalContractFunded(
                                revenueBind,
                                "fundedValue",
                              ) - calculateFFPTotalESTRevenue(revenueBind),
                            )}`}</td>
                            <td
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[5],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[5],
                              }}
                              title="Total Revenue"
                            ></td>
                            {revenueBind.totalRevenue
                              .filter(
                                (val) =>
                                  excludedItemsForMonthly.indexOf(
                                    val.monthYear,
                                  ) < 0,
                              )
                              .map((item, i) => {
                                const revenue =
                                  calculateFFPTotalESTRevenueByMonth(
                                    revenueBind,
                                    item.monthYear,
                                  );
                                return (
                                  <td
                                    key={i}
                                    className="centerAlignedDataLeftBorder"
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.thirdTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.thirdTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={revenue}
                                  >{`${convertValuesFM(revenue)}`}</td>
                                );
                              })}
                          </tr>
                        </tbody>
                      </table>
                    </Box>
                    <Box
                      style={{
                        boxShadow: "0px 3px 6px #00000029",
                      }}
                    >
                      <table
                        className="thirdTableFin"
                        cellPadding={0}
                        cellSpacing={0}
                      >
                        <thead>
                          <tr>
                            <th
                              className="centerAlignedHeaderLeftBorder"
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                            >
                              ITD from 2025
                            </th>
                            <th
                              className="centerAlignedHeaderLeftBorder"
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                            >
                              Remaining Forecast
                            </th>
                            <th
                              className="centerAlignedHeaderLeftBorder"
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                            >
                              Total
                            </th>
                          </tr>
                          <tr>
                            <th className="actualsHeaderCell ">Actuals</th>
                            <th className="forecastHeaderCell ">Forecast</th>
                            <th className="forecastHeaderCell ">Forecast</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredRevenue.map((item, i) => (
                            <>
                              <tr key={i}>
                                {item.monthExpenseDetail
                                  .filter((val) => val.monthYear === "ITD")
                                  .map((monthItem, j) => {
                                    const otherActualsItem =
                                      item.monthExpenseDetail.filter(
                                        (value) =>
                                          value.monthYear ===
                                          "Other Year Actual",
                                      )[0];
                                    let otherYearRevenue = 0;
                                    if (otherActualsItem) {
                                      otherYearRevenue =
                                        otherActualsItem.revenue;
                                    }
                                    return (
                                      <td
                                        key={j}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={
                                          monthItem.revenue + otherYearRevenue
                                        }
                                      >{`${convertValuesFM(
                                        monthItem.revenue + otherYearRevenue,
                                      )}`}</td>
                                    );
                                  })}
                                {item.monthExpenseDetail
                                  .filter(
                                    (val) =>
                                      val.monthYear === "Remaining Forecast",
                                  )
                                  .map((monthItem, j) => {
                                    const revenue =
                                      calculateFFPForecastRevenueById(
                                        item,
                                        "revenue",
                                      );
                                    return (
                                      <td
                                        key={j}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={revenue}
                                      >{`${convertValuesFM(revenue)}`}</td>
                                    );
                                  })}
                                {item.monthExpenseDetail
                                  .filter((val) => val.monthYear === "Total")
                                  .map((monthItem, j) => {
                                    const revenue = calculateFFPESTRevenueById(
                                      item,
                                      "revenue",
                                    );
                                    return (
                                      <td
                                        key={j}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={revenue}
                                      >{`${convertValuesFM(revenue)}`}</td>
                                    );
                                  })}
                              </tr>
                              <tr>
                                {item.monthExpenseDetail
                                  .filter((val) => val.monthYear === "ITD")
                                  .map((monthItem, j) => {
                                    const otherActualsItem =
                                      item.monthExpenseDetail.filter(
                                        (value) =>
                                          value.monthYear ===
                                          "Other Year Actual",
                                      )[0];
                                    let otherYearRevenue = 0;
                                    if (otherActualsItem) {
                                      otherYearRevenue =
                                        otherActualsItem.adjustmentRevenue;
                                    }
                                    return (
                                      <td
                                        key={j}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={
                                          monthItem.adjustmentRevenue +
                                          otherYearRevenue
                                        }
                                      >{`${convertValuesFM(
                                        monthItem.adjustmentRevenue +
                                          otherYearRevenue,
                                      )}`}</td>
                                    );
                                  })}
                                {item.monthExpenseDetail
                                  .filter(
                                    (val) =>
                                      val.monthYear === "Remaining Forecast",
                                  )
                                  .map((monthItem, j) => {
                                    const revenue =
                                      calculateFFPForecastRevenueById(
                                        item,
                                        "adjustmentRevenue",
                                      );
                                    return (
                                      <td
                                        key={j}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={revenue}
                                      >{`${convertValuesFM(revenue)}`}</td>
                                    );
                                  })}
                                {item.monthExpenseDetail
                                  .filter((val) => val.monthYear === "Total")
                                  .map((monthItem, j) => {
                                    const revenue = calculateFFPESTRevenueById(
                                      item,
                                      "adjustmentRevenue",
                                    );
                                    return (
                                      <td
                                        key={j}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={revenue}
                                      >{`${convertValuesFM(revenue)}`}</td>
                                    );
                                  })}
                              </tr>
                              <tr>
                                {item.monthExpenseDetail
                                  .filter((val) => val.monthYear === "ITD")
                                  .map((monthItem, j) => {
                                    const otherActualsItem =
                                      item.monthExpenseDetail.filter(
                                        (value) =>
                                          value.monthYear ===
                                          "Other Year Actual",
                                      )[0];
                                    let otherYearRevenue = 0;
                                    if (otherActualsItem) {
                                      otherYearRevenue =
                                        otherActualsItem.adjustedRevenue;
                                    }
                                    return (
                                      <td
                                        key={j}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={
                                          monthItem.adjustedRevenue +
                                          otherYearRevenue
                                        }
                                      >{`${convertValuesFM(
                                        monthItem.adjustedRevenue +
                                          otherYearRevenue,
                                      )}`}</td>
                                    );
                                  })}
                                {item.monthExpenseDetail
                                  .filter(
                                    (val) =>
                                      val.monthYear === "Remaining Forecast",
                                  )
                                  .map((monthItem, j) => {
                                    const revenue =
                                      calculateFFPForecastRevenueById(
                                        item,
                                        "adjustedRevenue",
                                      );
                                    return (
                                      <td
                                        key={j}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={revenue}
                                      >{`${convertValuesFM(revenue)}`}</td>
                                    );
                                  })}
                                {item.monthExpenseDetail
                                  .filter((val) => val.monthYear === "Total")
                                  .map((monthItem, j) => {
                                    const revenue = calculateFFPESTRevenueById(
                                      item,
                                      "adjustedRevenue",
                                    );
                                    return (
                                      <td
                                        key={j}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.fourtTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={revenue}
                                      >{`${convertValuesFM(revenue)}`}</td>
                                    );
                                  })}
                              </tr>
                            </>
                          ))}
                          <tr className="totalRow">
                            {revenueBind.totalRevenue
                              .filter((val) => val.monthYear === "ITD")
                              .map((item, i) => {
                                let revenue =
                                  calculateFFPTotalYTDRevenue(revenueBind);
                                return (
                                  <td
                                    key={i}
                                    className="centerAlignedDataLeftBorder"
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={revenue}
                                  >{`${convertValuesFM(revenue)}`}</td>
                                );
                              })}
                            {revenueBind.totalRevenue
                              .filter(
                                (val) => val.monthYear === "Remaining Forecast",
                              )
                              .map((item, i) => {
                                const revenue =
                                  calculateFFPTotalForecastRevenue(revenueBind);
                                return (
                                  <td
                                    key={i}
                                    className="centerAlignedDataLeftBorder"
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={revenue}
                                  >{`${convertValuesFM(revenue)}`}</td>
                                );
                              })}
                            {revenueBind.totalRevenue
                              .filter((val) => val.monthYear === "Total")
                              .map((item, i) => {
                                const revenue =
                                  calculateFFPTotalESTRevenue(revenueBind);
                                return (
                                  <td
                                    key={i}
                                    className="centerAlignedDataLeftBorder"
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={revenue}
                                  >{`${convertValuesFM(revenue)}`}</td>
                                );
                              })}
                          </tr>
                        </tbody>
                      </table>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <PaginationData
                data={revenueBind.revenueDetailList}
                setFilteredData={setFilteredRevenue}
                search={search}
                alwaysShow
              />
            </Box>
          ) : (
            <Box display={"flex"} flexDirection={"column"}>
              <Box display="flex" flexDirection="row">
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                    width:
                      detailedViewWidths.revenue.firstTable[0] +
                      detailedViewWidths.revenue.firstTable[1] +
                      detailedViewWidths.revenue.firstTable[2] +
                      detailedViewWidths.revenue.firstTable[3],
                    marginRight: "8px",
                  }}
                >
                  <table
                    className="firstTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            minWidth: detailedViewWidths.revenue.firstTable[0],
                            maxWidth: detailedViewWidths.revenue.firstTable[0],
                            cursor: "pointer",
                          }}
                          onClick={() => handleRevenueSort("clin")}
                        >
                          CLIN{" "}
                          {revenueSort.key === "clin"
                            ? revenueSort.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}
                        </th>
                        <th
                          style={{
                            minWidth: detailedViewWidths.revenue.firstTable[1],
                            maxWidth: detailedViewWidths.revenue.firstTable[1],
                          }}
                        >
                          Clin Start Date
                        </th>
                        <th
                          style={{
                            minWidth: detailedViewWidths.revenue.firstTable[2],
                            maxWidth: detailedViewWidths.revenue.firstTable[2],
                          }}
                        >
                          Clin End Date
                        </th>
                        <th
                          style={{
                            minWidth: detailedViewWidths.revenue.firstTable[3],
                            maxWidth: detailedViewWidths.revenue.firstTable[3],
                          }}
                        >
                          Revised Clin End Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRevenue.map((item, i) => (
                        <tr key={i}>
                          <td
                            title={item.clin}
                            style={{
                              minWidth:
                                detailedViewWidths.revenue.firstTable[0],
                              maxWidth:
                                detailedViewWidths.revenue.firstTable[0],
                              height: "105px",
                            }}
                          >
                            {item.clin}
                          </td>
                          <td
                            title={
                              item.clinStartDate && item.clinStartDate !== ""
                                ? formatDateBySetting(
                                    new Date(
                                      item.clinStartDate.replace(/-/g, "/"),
                                    ),
                                    dateFormat,
                                  )
                                : "NA"
                            }
                            style={{
                              minWidth:
                                detailedViewWidths.revenue.firstTable[1],
                              maxWidth:
                                detailedViewWidths.revenue.firstTable[1],
                              height: "105px",
                            }}
                          >
                            {item.clinStartDate && item.clinStartDate !== ""
                              ? formatDateBySetting(
                                  new Date(
                                    item.clinStartDate.replace(/-/g, "/"),
                                  ),
                                  dateFormat,
                                )
                              : "NA"}
                          </td>
                          <td
                            title={
                              item.clinEndDate && item.clinEndDate !== ""
                                ? formatDateBySetting(
                                    new Date(
                                      item.clinEndDate.replace(/-/g, "/"),
                                    ),
                                    dateFormat,
                                  )
                                : "NA"
                            }
                            style={{
                              minWidth:
                                detailedViewWidths.revenue.firstTable[2],
                              maxWidth:
                                detailedViewWidths.revenue.firstTable[2],
                              height: "105px",
                            }}
                          >
                            {item.clinEndDate && item.clinEndDate !== ""
                              ? formatDateBySetting(
                                  new Date(item.clinEndDate.replace(/-/g, "/")),
                                  dateFormat,
                                )
                              : "NA"}
                          </td>
                          <td
                            title={
                              item.revisedClinEndDate &&
                              item.revisedClinEndDate !== ""
                                ? formatDateBySetting(
                                    new Date(
                                      item.revisedClinEndDate.replace(
                                        /-/g,
                                        "/",
                                      ),
                                    ),
                                    dateFormat,
                                  )
                                : "NA"
                            }
                            style={{
                              minWidth:
                                detailedViewWidths.revenue.firstTable[3],
                              maxWidth:
                                detailedViewWidths.revenue.firstTable[3],
                              height: "105px",
                              position: "relative",
                            }}
                          >
                            {!isEdit &&
                            isEditEndDate &&
                            dateEditedId === item.rvId ? (
                              <>
                                <CustomDatePicker
                                  dateFormat={dateFormat}
                                  dateValue={
                                    updatedReviseDate
                                      ? getDate(updatedReviseDate)
                                      : getDate(item.revisedClinEndDate)
                                  }
                                  setDateValue={(date) => {
                                    setUpdatedReviseDate(
                                      formatDateBySetting(
                                        getDate(date),
                                        "YYYY-MM-DD",
                                      ),
                                    );
                                  }}
                                  itemWidth="120px"
                                />
                              </>
                            ) : (
                              <span style={{ float: "left" }}>
                                {item.revisedClinEndDate &&
                                item.revisedClinEndDate !== ""
                                  ? formatDateBySetting(
                                      new Date(
                                        item.revisedClinEndDate.replace(
                                          /-/g,
                                          "/",
                                        ),
                                      ),
                                      dateFormat,
                                    )
                                  : "NA"}
                              </span>
                            )}
                            {!isEdit && (
                              <>
                                {isEditEndDate && dateEditedId === item.rvId ? (
                                  <span
                                    style={{
                                      position: "absolute",
                                      right: "2px",
                                      top: "44px",
                                    }}
                                  >
                                    <CheckCircleIcon
                                      className={classes.checkCircleIcon}
                                      onClick={() => {
                                        updateClinReviseDate({
                                          rvnId: dateEditedId,
                                          contractId: contractId,
                                          revisedClinEndDate: updatedReviseDate,
                                          templateType: detailedType,
                                        });
                                      }}
                                    />
                                    <CancelIcon
                                      className={classes.cancelIcon}
                                      onClick={() => {
                                        setIsEditEndDate(false);
                                        setDateEditedId("");
                                        setUpdatedReviseDate(null);
                                      }}
                                    />
                                  </span>
                                ) : getVersionStatus.toLowerCase() === "open" &&
                                  localStorage.getItem("accessType") ===
                                    "RW" ? (
                                  <span>
                                    <EditIcon
                                      className={classes.editIconDate}
                                      style={{
                                        float: "left",
                                        margin: "2px 0 0 4px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setIsEditEndDate(true);
                                        setDateEditedId(item.rvId);
                                        setUpdatedReviseDate(
                                          item.revisedClinEndDate,
                                        );
                                      }}
                                    />
                                  </span>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            textAlign: "right",
                            fontWeight: 600,
                            paddingRight: "8px",
                          }}
                        >
                          Adjustment
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            textAlign: "right",
                            fontWeight: 600,
                            paddingRight: "8px",
                          }}
                        >
                          Total
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Box>
                <Box
                  ref={revenuTableRef}
                  style={{
                    overflowX: "auto",
                    boxShadow: "0px 3px 6px #00000029",
                  }}
                  onScroll={() => handleScrollTable("revenueTable")}
                >
                  <Box display="flex" flexDirection="row">
                    <Box
                      style={{
                        boxShadow: "0px 3px 6px #00000029",
                        marginRight: "8px",
                      }}
                    >
                      <table
                        className="secondTableFin"
                        cellPadding={0}
                        cellSpacing={0}
                      >
                        <thead>
                          <tr>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                            >
                              Contract Value
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                              }}
                            >
                              Funded Value
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                              }}
                            >
                              ITD Actuals till 2024
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                              }}
                            >
                              Est. At Completion
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[4],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[4],
                              }}
                            >
                              Remaining Funding
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[5],
                                minWidth:
                                  detailedViewWidths.revenue.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[5],
                              }}
                            >
                              Revenue
                            </th>
                            {headersData.map((item, i) => (
                              <th
                                key={i}
                                className="centerAlignedHeaderLeftBorder"
                                style={{
                                  maxWidth:
                                    detailedViewWidths.revenue.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  minWidth:
                                    detailedViewWidths.revenue.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                }}
                              >
                                {item.heading}
                              </th>
                            ))}
                          </tr>
                          <tr>
                            {headersData.map((item, i) => (
                              <th
                                key={i}
                                className={
                                  item.type === "Actual"
                                    ? `actualsHeaderCell`
                                    : `forecastHeaderCell`
                                }
                              >
                                {item.type === "Actual"
                                  ? `Actuals`
                                  : `Forecast`}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {filteredRevenue.map((item, i) => {
                            const forecastAdjustmentForCLIN =
                              item.monthExpenseDetail
                                .filter(
                                  (m) =>
                                    m.type?.toLowerCase() === "forecast" &&
                                    excludedItemsForMonthly.indexOf(
                                      m.monthYear,
                                    ) < 0,
                                )
                                .reduce(
                                  (sum, m) =>
                                    sum + Number(m.adjustmentRevenue || 0),
                                  0,
                                );
                            const totalRevenue =
                              item.monthExpenseDetail.filter(
                                (val) => val.monthYear === "ITD",
                              )[0].adjustedRevenue +
                              calculateRemainingForecastRevenueForCLIN(
                                item.clin,
                                directLaborCostBind,
                                otherDirectCostBind,
                              ) +
                              forecastAdjustmentForCLIN;
                            const remainingFund =
                              Math.round(
                                Number(
                                  item.fundedValue -
                                    totalRevenue -
                                    item.priorYearActual,
                                ) * 100,
                              ) / 100;
                            return (
                              <>
                                <tr key={i}>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={item.contractValue}
                                  >{`${convertValuesFM(
                                    item.contractValue,
                                  )}`}</td>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={item.fundedValue}
                                  >{`${convertValuesFM(item.fundedValue)}`}</td>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={item.priorYearActual}
                                  >{`${convertValuesFM(
                                    item.priorYearActual,
                                  )}`}</td>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[3],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[3],
                                    }}
                                    title={totalRevenue}
                                  >{`${convertValuesFM(totalRevenue)}`}</td>
                                  <td
                                    rowSpan={3}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[4],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[4],
                                    }}
                                    title={remainingFund}
                                  >{`${convertValuesFM(remainingFund)}`}</td>
                                  <td
                                    title={item.revenue}
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      paddingLeft: "8px",
                                      borderLeft: "1px solid #ccc",
                                    }}
                                  >
                                    {item.revenue}
                                  </td>
                                  {item.monthExpenseDetail
                                    .filter(
                                      (val) =>
                                        excludedItemsForMonthly.indexOf(
                                          val.monthYear,
                                        ) < 0,
                                    )
                                    .map((monthItem, j) => {
                                      const revenue =
                                        monthItem.type.toLowerCase() ===
                                        "forecast"
                                          ? calculateMonthlyRevenueForCLIN(
                                              item.clin,
                                              monthItem.monthYear,
                                              directLaborCostBind,
                                              otherDirectCostBind,
                                            )
                                          : monthItem.revenue;
                                      return !monthItem.isDummy ? (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={revenue}
                                        >
                                          {convertValuesFM(revenue)}
                                        </td>
                                      ) : (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                        />
                                      );
                                    })}
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      paddingLeft: "8px",
                                      borderLeft: "1px solid #ccc",
                                    }}
                                  >
                                    Adjustment Revenue
                                  </td>
                                  {item.monthExpenseDetail
                                    .filter(
                                      (val) =>
                                        excludedItemsForMonthly.indexOf(
                                          val.monthYear,
                                        ) < 0,
                                    )
                                    .map((monthItem, j) => {
                                      const adjustmentRevenue =
                                        monthItem.adjustmentRevenue;

                                      return !monthItem.isDummy ? (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={adjustmentRevenue}
                                        >
                                          {isEdit &&
                                          monthItem.type.toLowerCase() ===
                                            "forecast" ? (
                                            <input
                                              type="text"
                                              style={{
                                                width: "70px",
                                                border: "1px solid #ccc",
                                                borderRadius: "3px",
                                                padding: "2px",
                                              }}
                                              defaultValue={adjustmentRevenue}
                                              onChange={(e) =>
                                                onChangeRevenue(
                                                  e,
                                                  item.rvId,
                                                  monthItem.monthYear,
                                                )
                                              }
                                            />
                                          ) : (
                                            `${convertValuesFM(adjustmentRevenue)}`
                                          )}
                                        </td>
                                      ) : (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                        />
                                      );
                                    })}
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      minWidth:
                                        detailedViewWidths.revenue.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[5],
                                      paddingLeft: "8px",
                                      borderLeft: "1px solid #ccc",
                                    }}
                                  >
                                    Adjusted Revenue
                                  </td>
                                  {item.monthExpenseDetail
                                    .filter(
                                      (val) =>
                                        excludedItemsForMonthly.indexOf(
                                          val.monthYear,
                                        ) < 0,
                                    )
                                    .map((monthItem, j) => {
                                      const adjustedRevenue =
                                        monthItem.type.toLowerCase() ===
                                        "forecast"
                                          ? Math.round(
                                              (calculateMonthlyRevenueForCLIN(
                                                item.clin,
                                                monthItem.monthYear,
                                                directLaborCostBind,
                                                otherDirectCostBind,
                                              ) +
                                                Number(
                                                  monthItem.adjustmentRevenue ||
                                                    0,
                                                )) *
                                                100,
                                            ) / 100
                                          : monthItem.adjustedRevenue;
                                      {
                                        return !monthItem.isDummy ? (
                                          <td
                                            key={j}
                                            className="centerAlignedDataLeftBorder"
                                            style={{
                                              maxWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                              minWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                            }}
                                            title={adjustedRevenue}
                                          >
                                            {convertValuesFM(adjustedRevenue)}
                                          </td>
                                        ) : (
                                          <td
                                            key={j}
                                            className="centerAlignedDataLeftBorder"
                                            style={{
                                              maxWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                              minWidth:
                                                detailedViewWidths.revenue.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[0],
                                            }}
                                          />
                                        );
                                      }
                                    })}
                                </tr>
                              </>
                            );
                          })}
                          <tr className="adjustmentRow">
                            <td colSpan={6} />
                            {revenueBind.totalRevenue
                              .filter(
                                (val) =>
                                  excludedItemsForMonthly.indexOf(
                                    val.monthYear,
                                  ) < 0,
                              )
                              .map((item, i) => {
                                const revenue =
                                  calculateRevenueAdjustementForMonth(
                                    item.monthYear,
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  );

                                return (
                                  <td
                                    key={i}
                                    className="centerAlignedDataLeftBorder"
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.thirdTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.thirdTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={revenue}
                                  >
                                    {convertValuesFM(revenue)}
                                  </td>
                                );
                              })}
                          </tr>
                          {(() => {
                            const totalForecastAdjustment =
                              revenueBind.revenueDetailList.reduce(
                                (sum, revItem) =>
                                  sum +
                                  revItem.monthExpenseDetail
                                    .filter(
                                      (m) =>
                                        m.type?.toLowerCase() === "forecast" &&
                                        excludedItemsForMonthly.indexOf(
                                          m.monthYear,
                                        ) < 0,
                                    )
                                    .reduce(
                                      (s, m) =>
                                        s + Number(m.adjustmentRevenue || 0),
                                      0,
                                    ),
                                0,
                              );
                            return (
                              <tr className="totalDataRow">
                                <td
                                  style={{
                                    maxWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    minWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                  }}
                                  title={calculateTotalContractFunded(
                                    revenueBind,
                                    "contractValue",
                                  )}
                                >{`${convertValuesFM(
                                  calculateTotalContractFunded(
                                    revenueBind,
                                    "contractValue",
                                  ),
                                )}`}</td>
                                <td
                                  style={{
                                    maxWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    minWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={calculateTotalContractFunded(
                                    revenueBind,
                                    "fundedValue",
                                  )}
                                >{`${convertValuesFM(
                                  calculateTotalContractFunded(
                                    revenueBind,
                                    "fundedValue",
                                  ),
                                )}`}</td>
                                <td
                                  style={{
                                    maxWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    minWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={calculateTotalContractFunded(
                                    revenueBind,
                                    "priorYearActual",
                                  )}
                                >{`${convertValuesFM(
                                  calculateTotalContractFunded(
                                    revenueBind,
                                    "priorYearActual",
                                  ),
                                )}`}</td>
                                <td
                                  style={{
                                    maxWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[3],
                                    minWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[3],
                                  }}
                                  title={
                                    revenueBind.totalRevenue.filter(
                                      (val) => val.monthYear === "ITD",
                                    )[0].adjustedRevenue +
                                    calculateRemainingForecastRevenue(
                                      revenueBind,
                                      directLaborCostBind,
                                      otherDirectCostBind,
                                    ) +
                                    calculateRevenueAdjustmentTotal(
                                      directLaborCostBind,
                                      otherDirectCostBind,
                                    ) +
                                    totalForecastAdjustment
                                  }
                                >{`${convertValuesFM(
                                  revenueBind.totalRevenue.filter(
                                    (val) => val.monthYear === "ITD",
                                  )[0].adjustedRevenue +
                                    revenueBind.totalRevenue.filter(
                                      (val) =>
                                        val.monthYear === "Other Year Actual",
                                    )[0].adjustedRevenue +
                                    calculateRemainingForecastRevenue(
                                      revenueBind,
                                      directLaborCostBind,
                                      otherDirectCostBind,
                                    ) +
                                    calculateRevenueAdjustmentTotal(
                                      directLaborCostBind,
                                      otherDirectCostBind,
                                    ) +
                                    totalForecastAdjustment,
                                )}`}</td>
                                <td
                                  style={{
                                    maxWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[4],
                                    minWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[4],
                                  }}
                                  title={
                                    calculateTotalContractFunded(
                                      revenueBind,
                                      "fundedValue",
                                    ) -
                                    calculateTotalContractFunded(
                                      revenueBind,
                                      "priorYearActual",
                                    ) -
                                    revenueBind.totalRevenue.filter(
                                      (val) => val.monthYear === "ITD",
                                    )[0].adjustedRevenue -
                                    calculateRemainingForecastRevenue(
                                      revenueBind,
                                      directLaborCostBind,
                                      otherDirectCostBind,
                                    ) -
                                    calculateRevenueAdjustmentTotal(
                                      directLaborCostBind,
                                      otherDirectCostBind,
                                    ) -
                                    totalForecastAdjustment
                                  }
                                >{`${convertValuesFM(
                                  calculateTotalContractFunded(
                                    revenueBind,
                                    "fundedValue",
                                  ) -
                                    calculateTotalContractFunded(
                                      revenueBind,
                                      "priorYearActual",
                                    ) -
                                    revenueBind.totalRevenue.filter(
                                      (val) => val.monthYear === "ITD",
                                    )[0].adjustedRevenue -
                                    calculateRemainingForecastRevenue(
                                      revenueBind,
                                      directLaborCostBind,
                                      otherDirectCostBind,
                                    ) -
                                    calculateRevenueAdjustmentTotal(
                                      directLaborCostBind,
                                      otherDirectCostBind,
                                    ) -
                                    totalForecastAdjustment,
                                )}`}</td>
                                <td
                                  style={{
                                    maxWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[5],
                                    minWidth:
                                      detailedViewWidths.revenue.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[5],
                                  }}
                                  title="Total Revenue"
                                ></td>
                                {revenueBind.totalRevenue
                                  .filter(
                                    (val) =>
                                      excludedItemsForMonthly.indexOf(
                                        val.monthYear,
                                      ) < 0,
                                  )
                                  .map((item, i) => {
                                    const monthAdjustment =
                                      item.type.toLowerCase() === "forecast"
                                        ? revenueBind.revenueDetailList.reduce(
                                            (sum, revItem) => {
                                              const md =
                                                revItem.monthExpenseDetail.find(
                                                  (m) =>
                                                    m.monthYear ===
                                                    item.monthYear,
                                                );
                                              return (
                                                sum +
                                                Number(
                                                  md?.adjustmentRevenue || 0,
                                                )
                                              );
                                            },
                                            0,
                                          )
                                        : 0;
                                    const revenue =
                                      item.type.toLowerCase() === "forecast"
                                        ? calculateMonthlyRevenue(
                                            item.monthYear,
                                            revenueBind,
                                            directLaborCostBind,
                                            otherDirectCostBind,
                                          ) +
                                          calculateRevenueAdjustementForMonth(
                                            item.monthYear,
                                            directLaborCostBind,
                                            otherDirectCostBind,
                                          ) +
                                          monthAdjustment
                                        : item.adjustedRevenue;
                                    return (
                                      <td
                                        key={i}
                                        className="centerAlignedDataLeftBorder"
                                        style={{
                                          maxWidth:
                                            detailedViewWidths.revenue.thirdTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          minWidth:
                                            detailedViewWidths.revenue.thirdTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                        }}
                                        title={revenue}
                                      >
                                        {convertValuesFM(revenue)}
                                      </td>
                                    );
                                  })}
                              </tr>
                            );
                          })()}
                        </tbody>
                      </table>
                    </Box>
                    <Box
                      style={{
                        boxShadow: "0px 3px 6px #00000029",
                      }}
                    >
                      <table
                        className="thirdTableFin"
                        cellPadding={0}
                        cellSpacing={0}
                      >
                        <thead>
                          <tr>
                            <th
                              className="centerAlignedHeaderLeftBorder"
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                            >
                              ITD from 2025
                            </th>
                            <th
                              className="centerAlignedHeaderLeftBorder"
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                            >
                              Remaining Forecast
                            </th>
                            <th
                              className="centerAlignedHeaderLeftBorder"
                              style={{
                                maxWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.revenue.fourtTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                            >
                              Total
                            </th>
                          </tr>
                          <tr>
                            <th className="actualsHeaderCell ">Actuals</th>
                            <th className="forecastHeaderCell ">Forecast</th>
                            <th className="forecastHeaderCell ">Forecast</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredRevenue.map((item, i) => {
                            const forecastAdjustmentForCLIN =
                              item.monthExpenseDetail
                                .filter(
                                  (m) =>
                                    m.type?.toLowerCase() === "forecast" &&
                                    excludedItemsForMonthly.indexOf(
                                      m.monthYear,
                                    ) < 0,
                                )
                                .reduce(
                                  (sum, m) =>
                                    sum + Number(m.adjustmentRevenue || 0),
                                  0,
                                );
                            return (
                              <>
                                <tr key={i}>
                                  {item.monthExpenseDetail
                                    .filter((val) => val.monthYear === "ITD")
                                    .map((monthItem, j) => {
                                      const otherActualsItem =
                                        item.monthExpenseDetail.filter(
                                          (value) =>
                                            value.monthYear ===
                                            "Other Year Actual",
                                        )[0];
                                      let otherYearRevenue = 0;
                                      if (otherActualsItem) {
                                        otherYearRevenue =
                                          otherActualsItem.revenue;
                                      }
                                      return (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={
                                            monthItem.revenue + otherYearRevenue
                                          }
                                        >{`${convertValuesFM(
                                          monthItem.revenue + otherYearRevenue,
                                        )}`}</td>
                                      );
                                    })}
                                  {item.monthExpenseDetail
                                    .filter(
                                      (val) =>
                                        val.monthYear === "Remaining Forecast",
                                    )
                                    .map((monthItem, j) => {
                                      const revenue =
                                        calculateRemainingForecastRevenueForCLIN(
                                          item.clin,
                                          directLaborCostBind,
                                          otherDirectCostBind,
                                        );
                                      return (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={revenue}
                                        >{`${convertValuesFM(revenue)}`}</td>
                                      );
                                    })}
                                  {item.monthExpenseDetail
                                    .filter((val) => val.monthYear === "Total")
                                    .map((monthItem, j) => {
                                      const revenue =
                                        item.monthExpenseDetail.filter(
                                          (val) => val.monthYear === "ITD",
                                        )[0].revenue +
                                        item.monthExpenseDetail.filter(
                                          (val) =>
                                            val.monthYear ===
                                            "Other Year Actual",
                                        )[0].revenue +
                                        calculateRemainingForecastRevenueForCLIN(
                                          item.clin,
                                          directLaborCostBind,
                                          otherDirectCostBind,
                                        );
                                      return (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={revenue}
                                        >{`${convertValuesFM(revenue)}`}</td>
                                      );
                                    })}
                                </tr>
                                <tr>
                                  {item.monthExpenseDetail
                                    .filter((val) => val.monthYear === "ITD")
                                    .map((monthItem, j) => {
                                      const otherActualsItem =
                                        item.monthExpenseDetail.filter(
                                          (value) =>
                                            value.monthYear ===
                                            "Other Year Actual",
                                        )[0];
                                      let otherYearRevenue = 0;
                                      if (otherActualsItem) {
                                        otherYearRevenue =
                                          otherActualsItem.adjustmentRevenue;
                                      }
                                      return (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={
                                            monthItem.adjustmentRevenue +
                                            otherYearRevenue
                                          }
                                        >{`${convertValuesFM(
                                          monthItem.adjustmentRevenue +
                                            otherYearRevenue,
                                        )}`}</td>
                                      );
                                    })}
                                  {item.monthExpenseDetail
                                    .filter(
                                      (val) =>
                                        val.monthYear === "Remaining Forecast",
                                    )
                                    .map((monthItem, j) => {
                                      const revenue = forecastAdjustmentForCLIN;
                                      return (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={revenue}
                                        >{`${convertValuesFM(revenue)}`}</td>
                                      );
                                    })}
                                  {item.monthExpenseDetail
                                    .filter((val) => val.monthYear === "Total")
                                    .map((monthItem, j) => {
                                      const itdAdjustment =
                                        item.monthExpenseDetail.filter(
                                          (val) => val.monthYear === "ITD",
                                        )[0].adjustmentRevenue;
                                      const otherYearAdjustment =
                                        item.monthExpenseDetail.filter(
                                          (val) =>
                                            val.monthYear ===
                                            "Other Year Actual",
                                        )[0].adjustmentRevenue;
                                      const revenue =
                                        (itdAdjustment || 0) +
                                        (otherYearAdjustment || 0) +
                                        forecastAdjustmentForCLIN;
                                      return (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={revenue}
                                        >{`${convertValuesFM(revenue)}`}</td>
                                      );
                                    })}
                                </tr>
                                <tr>
                                  {item.monthExpenseDetail
                                    .filter((val) => val.monthYear === "ITD")
                                    .map((monthItem, j) => {
                                      const otherActualsItem =
                                        item.monthExpenseDetail.filter(
                                          (value) =>
                                            value.monthYear ===
                                            "Other Year Actual",
                                        )[0];
                                      let otherYearRevenue = 0;
                                      if (otherActualsItem) {
                                        otherYearRevenue =
                                          otherActualsItem.adjustedRevenue;
                                      }
                                      return (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={
                                            monthItem.adjustedRevenue +
                                            otherYearRevenue
                                          }
                                        >{`${convertValuesFM(
                                          monthItem.adjustedRevenue +
                                            otherYearRevenue,
                                        )}`}</td>
                                      );
                                    })}
                                  {item.monthExpenseDetail
                                    .filter(
                                      (val) =>
                                        val.monthYear === "Remaining Forecast",
                                    )
                                    .map((monthItem, j) => {
                                      const revenue =
                                        Math.round(
                                          (calculateRemainingForecastRevenueForCLIN(
                                            item.clin,
                                            directLaborCostBind,
                                            otherDirectCostBind,
                                          ) +
                                            forecastAdjustmentForCLIN) *
                                            100,
                                        ) / 100;
                                      return (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={revenue}
                                        >{`${convertValuesFM(revenue)}`}</td>
                                      );
                                    })}
                                  {item.monthExpenseDetail
                                    .filter((val) => val.monthYear === "Total")
                                    .map((monthItem, j) => {
                                      const revenue =
                                        item.monthExpenseDetail.filter(
                                          (val) => val.monthYear === "ITD",
                                        )[0].adjustedRevenue +
                                        item.monthExpenseDetail.filter(
                                          (val) =>
                                            val.monthYear ===
                                            "Other Year Actual",
                                        )[0].adjustedRevenue +
                                        calculateRemainingForecastRevenueForCLIN(
                                          item.clin,
                                          directLaborCostBind,
                                          otherDirectCostBind,
                                        ) +
                                        forecastAdjustmentForCLIN;
                                      return (
                                        <td
                                          key={j}
                                          className="centerAlignedDataLeftBorder"
                                          style={{
                                            maxWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            minWidth:
                                              detailedViewWidths.revenue.fourtTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                          }}
                                          title={revenue}
                                        >{`${convertValuesFM(revenue)}`}</td>
                                      );
                                    })}
                                </tr>
                              </>
                            );
                          })}
                          <tr className="adjustmentRow">
                            {
                              <>
                                <td
                                  className="centerAlignedDataLeftBorder"
                                  style={{
                                    maxWidth:
                                      detailedViewWidths.revenue.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    minWidth:
                                      detailedViewWidths.revenue.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                  }}
                                  title={calculateRevenueAdjustmentITD(
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  )}
                                >{`${convertValuesFM(
                                  calculateRevenueAdjustmentITD(
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  ),
                                )}`}</td>
                                <td
                                  className="centerAlignedDataLeftBorder"
                                  style={{
                                    maxWidth:
                                      detailedViewWidths.revenue.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    minWidth:
                                      detailedViewWidths.revenue.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                  }}
                                  title={calculateRevenueAdjustmentRemainingForecast(
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  )}
                                >{`${convertValuesFM(
                                  calculateRevenueAdjustmentRemainingForecast(
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  ),
                                )}`}</td>
                                <td
                                  className="centerAlignedDataLeftBorder"
                                  style={{
                                    maxWidth:
                                      detailedViewWidths.revenue.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    minWidth:
                                      detailedViewWidths.revenue.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                  }}
                                  title={calculateRevenueAdjustmentTotal(
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  )}
                                >{`${convertValuesFM(
                                  calculateRevenueAdjustmentTotal(
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  ),
                                )}`}</td>
                              </>
                            }
                          </tr>
                          <tr className="totalRow">
                            {revenueBind.totalRevenue
                              .filter((val) => val.monthYear === "ITD")
                              .map((item, i) => {
                                const otherActualsItem =
                                  revenueBind.totalRevenue.filter(
                                    (value) =>
                                      value.monthYear === "Other Year Actual",
                                  )[0];
                                let otherYearRevenue = 0;
                                if (otherActualsItem) {
                                  otherYearRevenue =
                                    otherActualsItem.adjustedRevenue;
                                }
                                return (
                                  <td
                                    key={i}
                                    className="centerAlignedDataLeftBorder"
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={
                                      item.adjustedRevenue + otherYearRevenue
                                    }
                                  >{`${convertValuesFM(
                                    item.adjustedRevenue + otherYearRevenue,
                                  )}`}</td>
                                );
                              })}
                            {revenueBind.totalRevenue
                              .filter(
                                (val) => val.monthYear === "Remaining Forecast",
                              )
                              .map((item, i) => {
                                const totalForecastAdjustment =
                                  revenueBind.revenueDetailList.reduce(
                                    (sum, revItem) =>
                                      sum +
                                      revItem.monthExpenseDetail
                                        .filter(
                                          (m) =>
                                            m.type?.toLowerCase() ===
                                              "forecast" &&
                                            excludedItemsForMonthly.indexOf(
                                              m.monthYear,
                                            ) < 0,
                                        )
                                        .reduce(
                                          (s, m) =>
                                            s +
                                            Number(m.adjustmentRevenue || 0),
                                          0,
                                        ),
                                    0,
                                  );
                                const revenue =
                                  calculateRemainingForecastRevenue(
                                    revenueBind,
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  ) +
                                  calculateRevenueAdjustmentRemainingForecast(
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  ) +
                                  totalForecastAdjustment;
                                return (
                                  <td
                                    key={i}
                                    className="centerAlignedDataLeftBorder"
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={revenue}
                                  >{`${convertValuesFM(revenue)}`}</td>
                                );
                              })}
                            {revenueBind.totalRevenue
                              .filter((val) => val.monthYear === "Total")
                              .map((item, i) => {
                                const totalForecastAdjustment =
                                  revenueBind.revenueDetailList.reduce(
                                    (sum, revItem) =>
                                      sum +
                                      revItem.monthExpenseDetail
                                        .filter(
                                          (m) =>
                                            m.type?.toLowerCase() ===
                                              "forecast" &&
                                            excludedItemsForMonthly.indexOf(
                                              m.monthYear,
                                            ) < 0,
                                        )
                                        .reduce(
                                          (s, m) =>
                                            s +
                                            Number(m.adjustmentRevenue || 0),
                                          0,
                                        ),
                                    0,
                                  );
                                const revenue =
                                  revenueBind.totalRevenue.filter(
                                    (val) => val.monthYear === "ITD",
                                  )[0].adjustedRevenue +
                                  revenueBind.totalRevenue.filter(
                                    (val) =>
                                      val.monthYear === "Other Year Actual",
                                  )[0].adjustedRevenue +
                                  calculateRemainingForecastRevenue(
                                    revenueBind,
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  ) +
                                  calculateRevenueAdjustmentTotal(
                                    directLaborCostBind,
                                    otherDirectCostBind,
                                  ) +
                                  totalForecastAdjustment;
                                return (
                                  <td
                                    key={i}
                                    className="centerAlignedDataLeftBorder"
                                    style={{
                                      maxWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      minWidth:
                                        detailedViewWidths.revenue.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={revenue}
                                  >{`${convertValuesFM(revenue)}`}</td>
                                );
                              })}
                          </tr>
                        </tbody>
                      </table>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <PaginationData
                data={revenueBind.revenueDetailList}
                setFilteredData={setFilteredRevenue}
                search={search}
                sortDirection={revenueSort.direction}
                sortKey={revenueSort.key}
                alwaysShow
              />
            </Box>
          )}
        </>
      );
    } else {
      return (
        <div
          style={{
            textAlign: "center",
            fontWeight: 600,
            background: "#fff",
            padding: "24px 0",
          }}
        >
          No Data
        </div>
      );
    }
  };

  const bindOtherDirectCostsTable = () => {
    if (
      otherDirectCostBind &&
      otherDirectCostBind.otherDirectLabourDetailList &&
      otherDirectCostBind.otherDirectLabourDetailList.length > 0
    ) {
      return (
        <Box>
          <Box display="flex" flexDirection="row">
            <Box
              style={{
                boxShadow: "0px 3px 6px #00000029",
                width: detailedViewWidths.otherDirectCosts.firstTable.reduce(
                  (tot, val) => tot + val,
                ),
                marginRight: "8px",
              }}
            >
              <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th
                      onClick={() => handleOtherDirectCostSort("clin")}
                      style={{
                        minWidth:
                          detailedViewWidths.otherDirectCosts.firstTable[0],
                        maxWidth:
                          detailedViewWidths.otherDirectCosts.firstTable[0],
                        cursor: "pointer",
                      }}
                    >
                      CLIN{" "}
                      {otherDirectCostSort.key === "clin"
                        ? otherDirectCostSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>
                    <th
                      onClick={() => handleOtherDirectCostSort("expenseType")}
                      style={{
                        minWidth:
                          detailedViewWidths.otherDirectCosts.firstTable[1],
                        maxWidth:
                          detailedViewWidths.otherDirectCosts.firstTable[1],
                        cursor: "pointer",
                      }}
                    >
                      Expense{" "}
                      {otherDirectCostSort.key === "expenseType"
                        ? otherDirectCostSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>
                    <th
                      onClick={() => handleOtherDirectCostSort("accountName")}
                      style={{
                        minWidth:
                          detailedViewWidths.otherDirectCosts.firstTable[2],
                        maxWidth:
                          detailedViewWidths.otherDirectCosts.firstTable[2],
                        cursor: "pointer",
                      }}
                    >
                      Account Name{" "}
                      {otherDirectCostSort.key === "accountName"
                        ? otherDirectCostSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOtherDirectCost.map((item, i) => (
                    <tr key={i}>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.otherDirectCosts.firstTable[0],
                          maxWidth:
                            detailedViewWidths.otherDirectCosts.firstTable[0],
                        }}
                        title={item.clin}
                      >
                        <span style={{ float: "left" }}> {item.clin}</span>
                        {isEdit &&
                          getVersionStatus.toLowerCase() === "open" &&
                          localStorage.getItem("accessType") === "RW" &&
                          item.deletePossible && (
                            <span style={{ float: "left" }}>
                              <DeleteForeverIcon
                                style={{
                                  color: "red",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  onDeleteOtherDirectCostClick(item.odlId)
                                }
                              />
                            </span>
                          )}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.otherDirectCosts.firstTable[1],
                          maxWidth:
                            detailedViewWidths.otherDirectCosts.firstTable[1],
                        }}
                        title={item.expenseType}
                      >
                        {item.expenseType}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.otherDirectCosts.firstTable[2],
                          maxWidth:
                            detailedViewWidths.otherDirectCosts.firstTable[2],
                        }}
                        title={item.accountName}
                      >
                        {item.accountName}
                      </td>
                    </tr>
                  ))}

                  <tr>
                    <td>
                      {!isEdit &&
                        getVersionStatus.toLowerCase() === "open" &&
                        localStorage.getItem("accessType") === "RW" && (
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#09659c",
                              fontWeight: 600,
                            }}
                            onClick={() => handleAddNewODC()}
                          >
                            + Add New ODC
                          </span>
                        )}
                    </td>
                    <td
                      colSpan={2}
                      style={{
                        textAlign: "right",
                        fontWeight: 600,
                        paddingRight: "8px",
                      }}
                    >
                      Adjustment
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{
                        textAlign: "right",
                        fontWeight: 600,
                        paddingRight: "8px",
                      }}
                    >
                      Total Other Direct Cost
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
            <Box
              ref={otherDirectCostsRef}
              style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
              onScroll={() => handleScrollTable("otherDirectCosts")}
            >
              <Box display="flex" flexDirection="row">
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                    marginRight: "8px",
                  }}
                >
                  <table
                    className="secondTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        <th
                          rowSpan={2}
                          colSpan={
                            detailedType === "TM" || detailedType === "FFP"
                              ? detailedType === "TM"
                                ? 10
                                : 6
                              : 6
                          }
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                        />

                        <th
                          rowSpan={2}
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                          }}
                        >
                          Billable/Unbillable
                        </th>
                        <th
                          rowSpan={2}
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[2],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[2],
                          }}
                        >
                          Mark-Up
                        </th>
                        <th
                          rowSpan={2}
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[3],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[3],
                          }}
                        >
                          Apply Burden
                        </th>
                        {headersData.map((item, i) => (
                          <th
                            colSpan={detailedType === "FFP" ? 2 : 3}
                            key={i}
                            className="centerAlignedHeaderLeftBorder"
                            style={{
                              minWidth:
                                detailedViewWidths.otherDirectCosts.thirdTable
                                  .filter((val) => val.type === detailedType)[0]
                                  .widths.reduce((tot, val) => tot + val),
                              maxWidth:
                                detailedViewWidths.otherDirectCosts.thirdTable
                                  .filter((val) => val.type === detailedType)[0]
                                  .widths.reduce((tot, val) => tot + val),
                            }}
                          >
                            {item.heading}
                          </th>
                        ))}
                      </tr>
                      <tr>
                        {headersData.map((item, i) => (
                          <>
                            <th
                              className={
                                item.type === "Actual"
                                  ? "actualHeaderCost"
                                  : "forecastHeaderCost"
                              }
                              style={{
                                minWidth:
                                  detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                maxWidth:
                                  detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                paddingLeft: "10px",
                              }}
                            >
                              Unburden Cost
                            </th>
                            <th
                              className={
                                item.type === "Actual"
                                  ? "actualHeaderCost"
                                  : "forecastHeaderCost"
                              }
                              style={{
                                minWidth:
                                  detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                                maxWidth:
                                  detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                              }}
                            >
                              Burden Cost
                            </th>
                            {detailedType !== "FFP" && (
                              <th
                                className={
                                  item.type === "Actual"
                                    ? "actualHeaderCost"
                                    : "forecastHeaderCost"
                                }
                                style={{
                                  minWidth:
                                    detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[2],
                                  maxWidth:
                                    detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[2],
                                }}
                              >
                                Revenue
                              </th>
                            )}
                          </>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredOtherDirectCost.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td
                              colSpan={
                                detailedType === "TM" || detailedType === "FFP"
                                  ? detailedType === "TM"
                                    ? 10
                                    : 6
                                  : 6
                              }
                            />

                            <td
                              title={item?.billingStatus}
                              style={{
                                minWidth:
                                  detailedViewWidths.otherDirectCosts.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                                maxWidth:
                                  detailedViewWidths.otherDirectCosts.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                              }}
                            >
                              <TableFilterSelect
                                selectedValue={item?.billingStatus}
                                onChangeItem={(e) =>
                                  onChangeReimbursement(e, item.odlId)
                                }
                                labelVal="billable"
                                id="billable"
                                items={billableItems}
                                width="100%"
                                disabled={!isEdit}
                              />
                            </td>
                            <td
                              title={item?.markUp}
                              style={{
                                minWidth:
                                  detailedViewWidths.otherDirectCosts.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                                maxWidth:
                                  detailedViewWidths.otherDirectCosts.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                              }}
                            >
                              <TableFilterSelect
                                selectedValue={item?.markUp}
                                onChangeItem={(e) =>
                                  onChangeMarkupAllowed(e, item.odlId)
                                }
                                labelVal="MarkupAllowed"
                                id="MarkupAllowed"
                                items={reimbursementItems}
                                width="100%"
                                disabled={!isEdit || !item?.billingStatus}
                              />
                            </td>

                            <td
                              title={item?.applyBurden}
                              style={{
                                minWidth:
                                  detailedViewWidths.otherDirectCosts.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                                maxWidth:
                                  detailedViewWidths.otherDirectCosts.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                              }}
                            >
                              <TableFilterSelect
                                selectedValue={item?.applyBurden}
                                onChangeItem={(e) =>
                                  onChangeApplyBurdenODC(e, item.odlId)
                                }
                                labelVal="Apply Burden"
                                id="applyBurden"
                                items={yesNoDdl}
                                width="100%"
                                disabled={!isEdit}
                              />
                            </td>
                            {item.monthExpenseDetail
                              .filter((val) => val.id || val.isDummy)
                              .map((monthItem, j) => {
                                return (
                                  <>
                                    {!monthItem.isDummy ? (
                                      <>
                                        <td
                                          key={`unburden-cost-${monthItem.id}`}
                                          style={{
                                            minWidth:
                                              detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            maxWidth:
                                              detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[0],
                                            borderLeft: "1px solid #ccc",
                                            paddingLeft: "4px",
                                          }}
                                          title={monthItem.unburdenCost}
                                        >
                                          {isEdit &&
                                          monthItem.type !== "Actual" ? (
                                            <input
                                              type="text"
                                              style={{
                                                width: "70px",
                                                border: "1px solid #ccc",
                                                borderRadius: "3px",
                                                padding: "2px",
                                              }}
                                              defaultValue={
                                                monthItem.unburdenCost
                                              }
                                              onChange={(e) =>
                                                onChangeUnburdenCost(
                                                  e,
                                                  item.odlId,
                                                  monthItem.id,
                                                )
                                              }
                                            />
                                          ) : (
                                            `${convertValuesFM(
                                              monthItem.unburdenCost,
                                            )}`
                                          )}
                                        </td>
                                        <td
                                          title={monthItem.burdenCost}
                                          style={{
                                            minWidth:
                                              detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[1],
                                            maxWidth:
                                              detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[1],
                                          }}
                                        >
                                          {`${convertValuesFM(
                                            monthItem.burdenCost,
                                          )}`}
                                        </td>
                                        {detailedType !== "FFP" && (
                                          <td
                                            title={monthItem.revenue}
                                            style={{
                                              minWidth:
                                                detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[2],
                                              maxWidth:
                                                detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0].widths[2],
                                            }}
                                          >{`${convertValuesFM(
                                            monthItem.revenue,
                                          )}`}</td>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <td
                                          colSpan={
                                            detailedType !== "FFP" ? 3 : 2
                                          }
                                          style={{
                                            minWidth:
                                              detailedViewWidths.otherDirectCosts.thirdTable
                                                .filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0]
                                                .widths.reduce(
                                                  (tot, val) => tot + val,
                                                ),
                                            maxWidth:
                                              detailedViewWidths.otherDirectCosts.thirdTable
                                                .filter(
                                                  (val) =>
                                                    val.type === detailedType,
                                                )[0]
                                                .widths.reduce(
                                                  (tot, val) => tot + val,
                                                ),
                                            borderLeft: "1px solid #ccc",
                                            paddingLeft: "4px",
                                          }}
                                        ></td>
                                      </>
                                    )}
                                  </>
                                );
                              })}
                          </tr>
                        );
                      })}
                      <tr className="adjustmentRow">
                        <td colSpan={detailedType === "TM" ? 13 : 9} />
                        {otherDirectCostBind.adjustment
                          .filter(
                            (val) =>
                              (val.id || val.isDummy) &&
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                                0,
                          )
                          .map((item, i) => (
                            <>
                              <td
                                style={{
                                  borderLeft: "1px solid #ccc",
                                  minWidth:
                                    detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  maxWidth:
                                    detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                }}
                              />
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                  maxWidth:
                                    detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                }}
                                title={item.burdenCost}
                                key={`burden-cost-${item.id}`}
                              >
                                {isEdit && item.type !== "Actual" ? (
                                  <input
                                    type="text"
                                    style={{
                                      width: "70px",
                                      border: "1px solid #ccc",
                                      borderRadius: "3px",
                                      padding: "2px",
                                    }}
                                    defaultValue={item.burdenCost}
                                    onChange={(e) =>
                                      onChangeOtherDirectCostsAdjustment(
                                        e,
                                        item.id,
                                        "burdenCost",
                                      )
                                    }
                                  />
                                ) : (
                                  convertValuesFM(item.burdenCost)
                                )}
                              </td>
                              {detailedType !== "FFP" && (
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={item.revenue}
                                  key={`revenue-${item.id}`}
                                >
                                  {isEdit && item.type !== "Actual" ? (
                                    <input
                                      type="text"
                                      style={{
                                        width: "70px",
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                        padding: "2px",
                                      }}
                                      defaultValue={item.revenue}
                                      onChange={(e) =>
                                        onChangeOtherDirectCostsAdjustment(
                                          e,
                                          item.id,
                                          "revenue",
                                        )
                                      }
                                    />
                                  ) : (
                                    convertValuesFM(item.revenue)
                                  )}
                                </td>
                              )}
                            </>
                          ))}
                      </tr>
                      <tr className="totalDataRow">
                        <td colSpan={detailedType === "TM" ? 13 : 9} />
                        {otherDirectCostBind.totalDirectLaborCost
                          .filter(
                            (val) =>
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                              0,
                          )
                          .map((item, i) => {
                            const totalBurdenCost =
                              calculateTotalOtherDirectCost(
                                otherDirectCostBind,
                                "burdenCost",
                                item.monthYear,
                              );
                            let totalRevenueCost = 0;
                            if (detailedType !== "FFP")
                              totalRevenueCost = calculateTotalOtherDirectCost(
                                otherDirectCostBind,
                                "revenue",
                                item.monthYear,
                              );
                            return (
                              <>
                                <td
                                  style={{
                                    borderLeft: "1px solid #ccc",
                                    minWidth:
                                      detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totalBurdenCost}
                                >{`${convertValuesFM(totalBurdenCost)}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.thirdTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={totalRevenueCost}
                                  >{`${convertValuesFM(totalRevenueCost)}`}</td>
                                )}
                              </>
                            );
                          })}
                      </tr>
                    </tbody>
                  </table>
                </Box>
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                  }}
                >
                  <table
                    className="thirdTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        <th
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable
                                .filter((val) => val.type === detailedType)[0]
                                .widths.reduce((tot, val) => tot + val),
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable
                                .filter((val) => val.type === detailedType)[0]
                                .widths.reduce((tot, val) => tot + val),
                          }}
                          colSpan={detailedType === "FFP" ? 2 : 3}
                        >
                          ITD from 2025
                        </th>
                        <th
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable
                                .filter((val) => val.type === detailedType)[0]
                                .widths.reduce((tot, val) => tot + val),
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable
                                .filter((val) => val.type === detailedType)[0]
                                .widths.reduce((tot, val) => tot + val),
                          }}
                          colSpan={detailedType === "FFP" ? 2 : 3}
                        >
                          Remaining Forecast
                        </th>
                        <th
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable
                                .filter((val) => val.type === detailedType)[0]
                                .widths.reduce((tot, val) => tot + val),
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable
                                .filter((val) => val.type === detailedType)[0]
                                .widths.reduce((tot, val) => tot + val),
                          }}
                          colSpan={detailedType === "FFP" ? 2 : 3}
                        >
                          Total
                        </th>
                      </tr>
                      <tr>
                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                          className="actualHeaderCost "
                        >
                          Total Unburden Cost
                        </th>
                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                          }}
                          className="actualHeaderCost "
                        >
                          Total Burden Cost
                        </th>
                        {detailedType !== "FFP" && (
                          <th
                            style={{
                              minWidth:
                                detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                              maxWidth:
                                detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                            }}
                            className="actualHeaderCost"
                          >
                            Total Revenue
                          </th>
                        )}

                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                          className="forecastHeaderCost "
                        >
                          Total Unburden Cost
                        </th>
                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                          }}
                          className="forecastHeaderCost "
                        >
                          Total Burden Cost
                        </th>
                        {detailedType !== "FFP" && (
                          <th
                            style={{
                              minWidth:
                                detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                              maxWidth:
                                detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                            }}
                            className="forecastHeaderCost"
                          >
                            Total Revenue
                          </th>
                        )}
                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                          className="forecastHeaderCost "
                        >
                          Total Unburden Cost
                        </th>
                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                            maxWidth:
                              detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                          }}
                          className="forecastHeaderCost "
                        >
                          Total Burden Cost
                        </th>
                        {detailedType !== "FFP" && (
                          <th
                            style={{
                              minWidth:
                                detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                              maxWidth:
                                detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                            }}
                            className="forecastHeaderCost "
                          >
                            Total Revenue
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredOtherDirectCost.map((item) => (
                        <tr>
                          {item.monthExpenseDetail
                            .filter((val) => val.monthYear === "ITD")
                            .map((bindItem, i) => {
                              const otherActualsItem =
                                item.monthExpenseDetail.filter(
                                  (value) =>
                                    value.monthYear === "Other Year Actual",
                                )[0];
                              let otherYearUnburdenCost = 0;
                              let otherYearCost = 0;
                              let otherYearRevenue = 0;
                              if (otherActualsItem) {
                                otherYearUnburdenCost =
                                  otherActualsItem.unburdenCost;
                                otherYearCost = otherActualsItem.burdenCost;
                                otherYearRevenue = otherActualsItem.revenue;
                              }
                              return (
                                <>
                                  <td
                                    style={{
                                      paddingLeft: "4px",
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={
                                      bindItem.unburdenCost +
                                      otherYearUnburdenCost
                                    }
                                  >
                                    {`${convertValuesFM(
                                      bindItem.unburdenCost +
                                        otherYearUnburdenCost,
                                    )}`}
                                  </td>
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={bindItem.burdenCost + otherYearCost}
                                  >{`${convertValuesFM(
                                    bindItem.burdenCost + otherYearCost,
                                  )}`}</td>
                                  {detailedType !== "FFP" && (
                                    <td
                                      style={{
                                        minWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                        maxWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                      }}
                                      title={
                                        bindItem.revenue + otherYearRevenue
                                      }
                                    >{`${convertValuesFM(
                                      bindItem.revenue + otherYearRevenue,
                                    )}`}</td>
                                  )}
                                </>
                              );
                            })}
                          {item.monthExpenseDetail
                            .filter(
                              (val) => val.monthYear === "Remaining Forecast",
                            )
                            .map((bindItem, i) => {
                              const totalUnburdenCost =
                                calculateRemainingForecastOtherDirectCost(
                                  otherDirectCostBind,
                                  "unburdenCost",
                                  item.odlId,
                                );
                              const totalBurdenCost =
                                calculateRemainingForecastOtherDirectCost(
                                  otherDirectCostBind,
                                  "burdenCost",
                                  item.odlId,
                                );
                              let totalRevenue = 0;
                              if (detailedType !== "FFP")
                                totalRevenue =
                                  calculateRemainingForecastOtherDirectCost(
                                    otherDirectCostBind,
                                    "revenue",
                                    item.odlId,
                                  );
                              return (
                                <>
                                  <td
                                    style={{
                                      paddingLeft: "4px",
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      borderLeft: "1px solid #ccc",
                                    }}
                                    title={totalUnburdenCost}
                                  >
                                    {`${convertValuesFM(totalUnburdenCost)}`}
                                  </td>
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={totalBurdenCost}
                                  >{`${convertValuesFM(totalBurdenCost)}`}</td>
                                  {detailedType !== "FFP" && (
                                    <td
                                      style={{
                                        minWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                        maxWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                      }}
                                      title={totalRevenue}
                                    >{`${convertValuesFM(totalRevenue)}`}</td>
                                  )}
                                </>
                              );
                            })}
                          {item.monthExpenseDetail
                            .filter((val) => val.monthYear === "Total")
                            .map((bindItem, i) => {
                              const totalUnburdenCost =
                                calculateItemTotalOtherDirectCost(
                                  otherDirectCostBind,
                                  "unburdenCost",
                                  item.odlId,
                                );
                              const totalBurdenCost =
                                calculateItemTotalOtherDirectCost(
                                  otherDirectCostBind,
                                  "burdenCost",
                                  item.odlId,
                                );
                              let totalRevenue = 0;
                              if (detailedType !== "FFP")
                                totalRevenue =
                                  calculateItemTotalOtherDirectCost(
                                    otherDirectCostBind,
                                    "revenue",
                                    item.odlId,
                                  );
                              return (
                                <>
                                  <td
                                    style={{
                                      paddingLeft: "4px",
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      borderLeft: "1px solid #ccc",
                                    }}
                                    title={totalUnburdenCost}
                                  >
                                    {`${convertValuesFM(totalUnburdenCost)}`}
                                  </td>
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={totalBurdenCost}
                                  >{`${convertValuesFM(totalBurdenCost)}`}</td>
                                  {detailedType !== "FFP" && (
                                    <td
                                      style={{
                                        minWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                        maxWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                      }}
                                      title={totalRevenue}
                                    >{`${convertValuesFM(totalRevenue)}`}</td>
                                  )}
                                </>
                              );
                            })}
                        </tr>
                      ))}
                      <tr className="adjustmentRow">
                        {otherDirectCostBind &&
                          otherDirectCostBind.adjustment &&
                          otherDirectCostBind.adjustment
                            .filter((val) => val.monthYear === "ITD")
                            .map((item, i) => {
                              const otherActualsItem =
                                otherDirectCostBind.adjustment.filter(
                                  (value) =>
                                    value.monthYear === "Other Year Actual",
                                )[0];
                              let otherYearCost = 0;
                              let otherYearRevenue = 0;
                              if (otherActualsItem) {
                                otherYearCost = otherActualsItem.burdenCost;
                                otherYearRevenue = otherActualsItem.revenue;
                              }
                              return (
                                <>
                                  <td
                                    style={{
                                      paddingLeft: "4px",
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                  />
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={item.burdenCost + otherYearCost}
                                  >{`${convertValuesFM(
                                    item.burdenCost + otherYearCost,
                                  )}`}</td>
                                  {detailedType !== "FFP" && (
                                    <td
                                      style={{
                                        minWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                        maxWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                      }}
                                      title={item.revenue + otherYearRevenue}
                                    >{`${convertValuesFM(
                                      item.revenue + otherYearRevenue,
                                    )}`}</td>
                                  )}
                                </>
                              );
                            })}
                        {otherDirectCostBind &&
                          otherDirectCostBind.adjustment &&
                          otherDirectCostBind.adjustment
                            .filter(
                              (val) => val.monthYear === "Remaining Forecast",
                            )
                            .map((item, i) => {
                              const totalBurdenCost =
                                calculateRemainingForecastDirectLaborAdjustment(
                                  otherDirectCostBind,
                                  "burdenCost",
                                );
                              let totalRevenue = 0;
                              if (detailedType !== "FFP")
                                totalRevenue =
                                  calculateRemainingForecastDirectLaborAdjustment(
                                    otherDirectCostBind,
                                    "revenue",
                                  );
                              return (
                                <>
                                  <td
                                    style={{
                                      borderLeft: "1px solid #ccc",
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                  />
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={totalBurdenCost}
                                  >{`${convertValuesFM(totalBurdenCost)}`}</td>
                                  {detailedType !== "FFP" && (
                                    <td
                                      style={{
                                        minWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                        maxWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                      }}
                                      title={totalRevenue}
                                    >{`${convertValuesFM(totalRevenue)}`}</td>
                                  )}
                                </>
                              );
                            })}
                        {otherDirectCostBind &&
                          otherDirectCostBind.adjustment &&
                          otherDirectCostBind.adjustment
                            .filter((val) => val.monthYear === "Total")
                            .map((item, i) => {
                              const totalBurdenCost =
                                calculateItemTotalDirectLaborAdjustment(
                                  otherDirectCostBind,
                                  "burdenCost",
                                );
                              let totalRevenue = 0;
                              if (detailedType !== "FFP")
                                totalRevenue =
                                  calculateItemTotalDirectLaborAdjustment(
                                    otherDirectCostBind,
                                    "revenue",
                                  );
                              return (
                                <>
                                  <td
                                    style={{
                                      borderLeft: "1px solid #ccc",
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                  />
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={totalBurdenCost}
                                  >{`${convertValuesFM(totalBurdenCost)}`}</td>
                                  {detailedType !== "FFP" && (
                                    <td
                                      style={{
                                        minWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                        maxWidth:
                                          detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                      }}
                                      title={totalRevenue}
                                    >{`${convertValuesFM(totalRevenue)}`}</td>
                                  )}
                                </>
                              );
                            })}
                      </tr>
                      <tr className="totalDataRow">
                        {otherDirectCostBind.totalDirectLaborCost
                          .filter((val) => val.monthYear === "ITD")
                          .map((item, i) => {
                            const otherActualsItem =
                              otherDirectCostBind.totalDirectLaborCost.filter(
                                (value) =>
                                  value.monthYear === "Other Year Actual",
                              )[0];
                            let otherYearCost = 0;
                            let otherYearRevenue = 0;
                            if (otherActualsItem) {
                              otherYearCost = otherActualsItem.burdenCost;
                              otherYearRevenue = otherActualsItem.revenue;
                            }
                            return (
                              <>
                                <td
                                  style={{
                                    paddingLeft: "4px",
                                    minWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={item.burdenCost + otherYearCost}
                                >{`${convertValuesFM(
                                  item.burdenCost + otherYearCost,
                                )}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={item.revenue + otherYearRevenue}
                                  >{`${convertValuesFM(
                                    item.revenue + otherYearRevenue,
                                  )}`}</td>
                                )}
                              </>
                            );
                          })}
                        {otherDirectCostBind.totalDirectLaborCost
                          .filter(
                            (val) => val.monthYear === "Remaining Forecast",
                          )
                          .map((item, i) => {
                            const totalBurdenCost =
                              calculateRemainingForecastOtherDirectCostTotal(
                                otherDirectCostBind,
                                "burdenCost",
                              );
                            let totalRevenue = 0;
                            if (detailedType !== "FFP")
                              totalRevenue =
                                calculateRemainingForecastOtherDirectCostTotal(
                                  otherDirectCostBind,
                                  "revenue",
                                );
                            return (
                              <>
                                <td
                                  style={{
                                    borderLeft: "1px solid #ccc",
                                    minWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totalBurdenCost}
                                >{`${convertValuesFM(totalBurdenCost)}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={totalRevenue}
                                  >{`${convertValuesFM(totalRevenue)}`}</td>
                                )}
                              </>
                            );
                          })}
                        {otherDirectCostBind.totalDirectLaborCost
                          .filter((val) => val.monthYear === "Total")
                          .map((item, i) => {
                            const totalBurdenCost =
                              calculateItemTotalDirectOtherDirectCost(
                                otherDirectCostBind,
                                "burdenCost",
                              );
                            let totalRevenue = 0;
                            if (detailedType !== "FFP")
                              totalRevenue =
                                calculateItemTotalDirectOtherDirectCost(
                                  otherDirectCostBind,
                                  "revenue",
                                );
                            return (
                              <>
                                <td
                                  style={{
                                    borderLeft: "1px solid #ccc",
                                    minWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totalBurdenCost}
                                >{`${convertValuesFM(totalBurdenCost)}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.otherDirectCosts.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={totalRevenue}
                                  >{`${convertValuesFM(totalRevenue)}`}</td>
                                )}
                              </>
                            );
                          })}
                      </tr>
                    </tbody>
                  </table>
                </Box>
              </Box>
            </Box>
          </Box>
          <PaginationData
            data={otherDirectCostBind.otherDirectLabourDetailList}
            setFilteredData={setFilteredOtherDirectCost}
            search={search}
            sortDirection={otherDirectCostSort.direction}
            sortKey={otherDirectCostSort.key}
            alwaysShow
          />
        </Box>
      );
    } else {
      return (
        <div
          style={{
            textAlign: "center",
            fontWeight: 600,
            background: "#fff",
            padding: "24px 0",
          }}
        >
          {!isEdit &&
          getVersionStatus.toLowerCase() === "open" &&
          localStorage.getItem("accessType") === "RW" ? (
            <span
              style={{
                cursor: "pointer",
                color: "#09659c",
                fontWeight: 600,
              }}
              onClick={() => handleAddNewODC()}
            >
              + Add New ODC
            </span>
          ) : (
            `No Data`
          )}
        </div>
      );
    }
  };

  const bindDirectLaborTable = () => {
    if (
      directLaborCostBind &&
      directLaborCostBind.getDirectLaborDetailList &&
      directLaborCostBind.getDirectLaborDetailList.length > 0
    ) {
      const updateddirectLabourCost = filteredDirectLabor.map((item) => {
        const updatedDetaisls = item.monthExpenseDetail.map((val) => {
          if (val.id) {
            if (val.defaultAvailableHours < val.hours) {
              return {
                ...val,
                exceedsHours: true,
              };
            } else {
              return {
                ...val,
                exceedsHours: false,
              };
            }
          }
          return val;
        });
        return { ...item, monthExpenseDetail: updatedDetaisls };
      });

      return (
        <Box>
          <Box display="flex" flexDirection="row">
            <Box
              style={{
                boxShadow: "0px 3px 6px #00000029",
                width: detailedViewWidths.directLabor.firstTable.reduce(
                  (tot, val) => tot + val,
                ),
                // Capped at the pre-"Is IWO?" column total (700px) so this table scrolls
                // horizontally on its own instead of growing the row and pushing the
                // rate/forecast tables beside it further off-screen.
                maxWidth: "700px",
                minWidth: "700px",
                overflowX: "auto",
                marginRight: "8px",
              }}
            >
              <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th
                      style={{
                        minWidth: detailedViewWidths.directLabor.firstTable[0],
                        maxWidth: detailedViewWidths.directLabor.firstTable[0],
                        cursor: "pointer",
                      }}
                      onClick={() => handleDirectLaborSort("clin")}
                    >
                      CLIN{" "}
                      {directLaborSort.key === "clin"
                        ? directLaborSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>
                    <th
                      style={{
                        minWidth: detailedViewWidths.directLabor.firstTable[1],
                        maxWidth: detailedViewWidths.directLabor.firstTable[1],
                        cursor: "pointer",
                      }}
                      onClick={() => handleDirectLaborSort("pOLine")}
                    >
                      NOTE{" "}
                      {directLaborSort.key === "pOLine"
                        ? directLaborSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>
                    <th
                      style={{
                        minWidth: detailedViewWidths.directLabor.firstTable[2],
                        maxWidth: detailedViewWidths.directLabor.firstTable[2],
                        cursor: "pointer",
                      }}
                      onClick={() => handleDirectLaborSort("pn")}
                    >
                      PN{" "}
                      {directLaborSort.key === "pn"
                        ? directLaborSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>
                    <th
                      style={{
                        minWidth: detailedViewWidths.directLabor.firstTable[3],
                        maxWidth: detailedViewWidths.directLabor.firstTable[3],
                        textAlign: "center",
                      }}
                    >
                      Is IWO?
                    </th>
                    <th
                      onClick={() => handleDirectLaborSort("employeeSubConId")}
                      style={{
                        minWidth: detailedViewWidths.directLabor.firstTable[4],
                        maxWidth: detailedViewWidths.directLabor.firstTable[4],
                        cursor: "pointer",
                      }}
                    >
                      EMP ID / Sub ID{" "}
                      {directLaborSort.key === "employeeSubConId"
                        ? directLaborSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>
                    <th
                      style={{
                        minWidth: detailedViewWidths.directLabor.firstTable[5],
                        maxWidth: detailedViewWidths.directLabor.firstTable[5],
                        cursor: "pointer",
                      }}
                      onClick={() => handleDirectLaborSort("employeeName")}
                    >
                      Employee Name{" "}
                      {directLaborSort.key === "employeeName"
                        ? directLaborSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>

                    <th
                      style={{
                        minWidth: detailedViewWidths.directLabor.firstTable[6],
                        maxWidth: detailedViewWidths.directLabor.firstTable[6],
                        cursor: "pointer",
                      }}
                      onClick={() => handleDirectLaborSort("lCatId")}
                    >
                      LCAT ID{" "}
                      {directLaborSort.key === "lCatId"
                        ? directLaborSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>

                    <th
                      style={{
                        minWidth: detailedViewWidths.directLabor.firstTable[7],
                        maxWidth: detailedViewWidths.directLabor.firstTable[7],
                        cursor: "pointer",
                      }}
                      onClick={() => handleDirectLaborSort("lCatDescription")}
                    >
                      LCAT Description
                      {directLaborSort.key === "lCatDescription"
                        ? directLaborSort.direction === "asc"
                          ? "↑"
                          : "↓"
                        : "↕"}
                    </th>
                    <th
                      style={{
                        minWidth: detailedViewWidths.directLabor.firstTable[8],
                        maxWidth: detailedViewWidths.directLabor.firstTable[8],
                      }}
                    >
                      Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDirectLabor.map((item, i) => (
                    <tr key={`direct-labor-${item.dlId}`}>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.directLabor.firstTable[0],
                          maxWidth:
                            detailedViewWidths.directLabor.firstTable[0],
                        }}
                        title={item.clin}
                      >
                        <span style={{ float: "left" }}> {item.clin}</span>
                        {isEdit &&
                          getVersionStatus.toLowerCase() === "open" &&
                          localStorage.getItem("accessType") === "RW" &&
                          item.deletePossible && (
                            <span style={{ float: "left" }}>
                              <DeleteForeverIcon
                                style={{
                                  color: "red",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  onDeleteDirectLaborClick(item.dlId)
                                }
                              />
                            </span>
                          )}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.directLabor.firstTable[1],
                          maxWidth:
                            detailedViewWidths.directLabor.firstTable[1],
                        }}
                        title={item.pOLine}
                      >
                        {isEdit ? (
                          <input
                            type="text"
                            style={{
                              width: "60px",
                              border: "1px solid #ccc",
                              borderRadius: "3px",
                              padding: "2px",
                            }}
                            defaultValue={item.pOLine}
                            onChange={(e) =>
                              onChangeDataValue(e, item.dlId, "pOLine")
                            }
                          />
                        ) : (
                          item.pOLine
                        )}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.directLabor.firstTable[2],
                          maxWidth:
                            detailedViewWidths.directLabor.firstTable[2],
                        }}
                        title={item.pn}
                      >
                        {isEdit ? (
                          <input
                            type="text"
                            style={{
                              width: "60px",
                              border: "1px solid #ccc",
                              borderRadius: "3px",
                              padding: "2px",
                            }}
                            defaultValue={item.pn}
                            onChange={(e) =>
                              onChangeDataValue(e, item.dlId, "pn")
                            }
                          />
                        ) : (
                          item.pn
                        )}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.directLabor.firstTable[3],
                          maxWidth:
                            detailedViewWidths.directLabor.firstTable[3],
                          textAlign: "center",
                        }}
                      >
                        {(item.employeeType || "").toLowerCase() !==
                          "employee" && (
                          <input
                            type="checkbox"
                            checked={!!item.isIwo}
                            disabled={!isEdit}
                            onChange={(e) => onChangeIsIwo(e, item.dlId)}
                          />
                        )}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.directLabor.firstTable[4],
                          maxWidth:
                            detailedViewWidths.directLabor.firstTable[4],
                        }}
                        title={item.employeeSubConId}
                      >
                        {item.employeeSubConId}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.directLabor.firstTable[5],
                          maxWidth:
                            detailedViewWidths.directLabor.firstTable[5],
                        }}
                        title={item.employeeName}
                      >
                        {item.employeeName}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.directLabor.firstTable[6],
                          maxWidth:
                            detailedViewWidths.directLabor.firstTable[6],
                        }}
                        title={item.lCatId}
                      >
                        {item.lCatId}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.directLabor.firstTable[7],
                          maxWidth:
                            detailedViewWidths.directLabor.firstTable[7],
                        }}
                        title={item.lCatDescription}
                      >
                        {item.lCatDescription}
                      </td>
                      <td
                        style={{
                          minWidth:
                            detailedViewWidths.directLabor.firstTable[8],
                          maxWidth:
                            detailedViewWidths.directLabor.firstTable[8],
                          textAlign: "center",
                        }}
                      >
                        {item.notes && item.notes.toString().trim !== "" && (
                          <span
                            style={{
                              fontWeight: 600,
                              color: "#09659c",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => onClickDirectLaborDetails(item)}
                          >
                            View
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}

                  <tr>
                    <td colSpan={4}>
                      {!isEdit &&
                        getVersionStatus.toLowerCase() === "open" &&
                        localStorage.getItem("accessType") === "RW" && (
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#09659c",
                              fontWeight: 600,
                            }}
                            onClick={() => handleAddNewDirectLabor()}
                          >
                            + Add New Resource
                          </span>
                        )}
                    </td>
                    <td
                      colSpan={4}
                      style={{
                        textAlign: "right",
                        fontWeight: 600,
                        paddingRight: "8px",
                      }}
                    >
                      Adjustment
                    </td>
                  </tr>
                  {/* <td
                    colSpan={6}
                    style={{
                      textAlign: "right",
                      fontWeight: 600,
                      paddingRight: "8px",
                    }}
                  >
                    Adjustment
                  </td>
                </tr>*/}
                  <tr>
                    <td
                      colSpan={8}
                      style={{
                        textAlign: "right",
                        fontWeight: 600,
                        paddingRight: "8px",
                      }}
                    >
                      Total Direct Labor Cost
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
            <Box
              ref={directLabourRef}
              style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
              onScroll={() => handleScrollTable("directLabor")}
            >
              <Box display="flex" flexDirection="row">
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                    marginRight: "8px",
                  }}
                >
                  <table
                    className="secondTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                        >
                          Project Start Date
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                          }}
                        >
                          Project End Date
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[2],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[2],
                          }}
                        >
                          Revised Project End Date
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[3],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[3],
                          }}
                        >
                          Account
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[4],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[4],
                          }}
                        >
                          Company
                        </th>

                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[5],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[5],
                          }}
                        >
                          Base Cost Rate (Unloaded)
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[6],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[6],
                          }}
                        >
                          Base Cost Rate (Loaded)
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[7],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[7],
                          }}
                        >
                          Labor Escalation %
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[8],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[8],
                            paddingRight: "4px",
                          }}
                        >
                          Labor Escalation Date
                        </th>
                        {detailedType === "TM" && (
                          <>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[9],
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[9],
                              }}
                            >
                              Bill Rate Escalation %
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[10],
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[10],
                              }}
                            >
                              Bill Rate Escalation Date
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[11],
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[11],
                              }}
                            >
                              System Bill Rate
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[12],
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[12],
                              }}
                            >
                              Adjustment Bill Rate
                            </th>
                          </>
                        )}
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[13],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[13],
                          }}
                        >
                          {detailedType === "TM"
                            ? "Adjusted Bill Rate"
                            : "Bid Rate"}
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[14],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[14],
                            cursor: "pointer",
                          }}
                          onClick={() => handleDirectLaborSort("margin")}
                        >
                          Margin
                          {directLaborSort.key === "margin"
                            ? directLaborSort.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}
                        </th>
                        {detailedType !== "FFP" && (
                          <th
                            rowSpan={2}
                            style={{
                              maxWidth:
                                detailedViewWidths.directLabor.secondTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[15],
                              minWidth:
                                detailedViewWidths.directLabor.secondTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[15],
                            }}
                          >
                            Billable / Unbillable
                          </th>
                        )}
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[16],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[16],
                          }}
                        >
                          Pay Type
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            maxWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[17],
                            minWidth:
                              detailedViewWidths.directLabor.secondTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[17],
                          }}
                        >
                          Apply Burden
                        </th>
                        {headersData.map((item, i) => (
                          <th
                            colSpan={detailedType === "FFP" ? 3 : 4}
                            key={i}
                            className="centerAlignedHeaderLeftBorder"
                            style={{
                              minWidth:
                                detailedViewWidths.directLabor.thirdTable
                                  .filter((val) => val.type === detailedType)[0]
                                  .widths.reduce((tot, val) => tot + val),
                              maxWidth:
                                detailedViewWidths.directLabor.thirdTable
                                  .filter((val) => val.type === detailedType)[0]
                                  .widths.reduce((tot, val) => tot + val),
                            }}
                          >
                            {item.heading}
                          </th>
                        ))}
                      </tr>
                      <tr>
                        {headersData.map((item, i) => (
                          <>
                            <th
                              className={
                                item.type === "Actual"
                                  ? "actualHeaderCost"
                                  : "forecastHeaderCost"
                              }
                              style={{
                                maxWidth:
                                  detailedViewWidths.directLabor.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                minWidth:
                                  detailedViewWidths.directLabor.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                paddingLeft: "4px",
                              }}
                            >
                              {costRateType === "U"
                                ? "Eff. Cost Rate (Unloaded)"
                                : "Eff. Cost Rate (Loaded)"}
                            </th>
                            <th
                              className={
                                item.type === "Actual"
                                  ? "actualHeaderCost"
                                  : "forecastHeaderCost"
                              }
                              style={{
                                maxWidth:
                                  detailedViewWidths.directLabor.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                                minWidth:
                                  detailedViewWidths.directLabor.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                              }}
                            >
                              {hourType === "H"
                                ? `Hours (${item.defaultAvailableHours})`
                                : "OT Hours"}
                            </th>
                            <th
                              className={
                                item.type === "Actual"
                                  ? "actualHeaderCost"
                                  : "forecastHeaderCost"
                              }
                              style={{
                                maxWidth:
                                  detailedViewWidths.directLabor.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                                minWidth:
                                  detailedViewWidths.directLabor.thirdTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                              }}
                            >
                              Burden Cost
                            </th>
                            {detailedType !== "FFP" && (
                              <th
                                className={
                                  item.type === "Actual"
                                    ? "actualHeaderCost"
                                    : "forecastHeaderCost"
                                }
                                style={{
                                  maxWidth:
                                    detailedViewWidths.directLabor.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[3],
                                  minWidth:
                                    detailedViewWidths.directLabor.thirdTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[3],
                                }}
                              >
                                Revenue
                              </th>
                            )}
                          </>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {updateddirectLabourCost.map((item, i) => {
                        return (
                          <tr key={`direct-labour-cost-${item.dlId}`}>
                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[0],
                              }}
                              title={
                                item.startDate && item.startDate !== ""
                                  ? formatDateBySetting(
                                      new Date(
                                        item.startDate.replace(/-/g, "/"),
                                      ),
                                      dateFormat,
                                    )
                                  : "NA"
                              }
                            >
                              {item.startDate && item.startDate !== ""
                                ? formatDateBySetting(
                                    new Date(item.startDate.replace(/-/g, "/")),
                                    dateFormat,
                                  )
                                : "NA"}
                            </td>
                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[1],
                              }}
                              title={
                                item.endDate && item.endDate !== ""
                                  ? formatDateBySetting(
                                      new Date(item.endDate.replace(/-/g, "/")),
                                      dateFormat,
                                    )
                                  : "NA"
                              }
                            >
                              {item.endDate && item.endDate !== ""
                                ? formatDateBySetting(
                                    new Date(item.endDate.replace(/-/g, "/")),
                                    dateFormat,
                                  )
                                : "NA"}
                            </td>
                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[2],
                              }}
                              title={
                                item.revisedEndDate &&
                                item.revisedEndDate !== ""
                                  ? formatDateBySetting(
                                      new Date(
                                        item.revisedEndDate.replace(/-/g, "/"),
                                      ),
                                      dateFormat,
                                    )
                                  : "NA"
                              }
                            >
                              {item.revisedEndDate && item.revisedEndDate !== ""
                                ? formatDateBySetting(
                                    new Date(
                                      item.revisedEndDate.replace(/-/g, "/"),
                                    ),
                                    dateFormat,
                                  )
                                : "NA"}
                            </td>
                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[3],
                              }}
                              title={item.acctName}
                            >
                              {item.acctName}
                            </td>
                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[4],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[4],
                              }}
                              title={item.company}
                            >
                              {item.company}
                            </td>

                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[5],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[5],
                              }}
                              title={item.costRateUnloaded}
                            >
                              {isEdit ? (
                                <input
                                  type="text"
                                  style={{
                                    width: "70px",
                                    border: "1px solid #ccc",
                                    borderRadius: "3px",
                                    padding: "2px",
                                  }}
                                  defaultValue={item.costRateUnloaded}
                                  onChange={(e) =>
                                    onChangeCostRate(
                                      e,
                                      item.dlId,
                                      item.employeeType,
                                      item.isIwo,
                                    )
                                  }
                                />
                              ) : (
                                convertValuesFM(item.costRateUnloaded)
                              )}
                            </td>
                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[6],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[6],
                              }}
                              title={item.costRateLoaded}
                            >
                              {convertValuesFM(item.costRateLoaded)}
                            </td>
                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[7],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[7],
                              }}
                              title={`${item.laborEscalation}%`}
                            >
                              {isEdit ? (
                                <input
                                  type="text"
                                  style={{
                                    width: "70px",
                                    border: "1px solid #ccc",
                                    borderRadius: "3px",
                                    padding: "2px",
                                  }}
                                  defaultValue={item.laborEscalation}
                                  onChange={(e) =>
                                    onChangeDataValue(
                                      e,
                                      item.dlId,
                                      "laborEscalation",
                                    )
                                  }
                                />
                              ) : item.laborEscalation < 0 ? (
                                `(${Math.abs(item.laborEscalation)}%)`
                              ) : (
                                `${item.laborEscalation}%`
                              )}
                            </td>
                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[8],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[8],
                              }}
                              title={
                                item.laborEscalationDate &&
                                item.laborEscalationDate !== ""
                                  ? formatDateBySetting(
                                      new Date(
                                        item.laborEscalationDate.replace(
                                          /-/g,
                                          "/",
                                        ),
                                      ),
                                      dateFormat,
                                    )
                                  : "NA"
                              }
                            >
                              {isEdit ? (
                                <CustomDatePicker
                                  dateFormat={dateFormat}
                                  dateValue={getDate(item.laborEscalationDate)}
                                  setDateValue={(date) => {
                                    onChangeLaborEscalationDate(
                                      date,
                                      item.dlId,
                                    );
                                  }}
                                  classVal="datePickerDetailedView"
                                />
                              ) : item.laborEscalationDate &&
                                item.laborEscalationDate !== "" ? (
                                formatDateBySetting(
                                  new Date(
                                    item.laborEscalationDate.replace(/-/g, "/"),
                                  ),
                                  dateFormat,
                                )
                              ) : (
                                "NA"
                              )}
                            </td>
                            {detailedType === "TM" && (
                              <>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[8],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[8],
                                  }}
                                  title={`${
                                    item.billRateEscalation
                                      ? item.billRateEscalation
                                      : 0
                                  }%`}
                                >
                                  {isEdit ? (
                                    <input
                                      type="text"
                                      style={{
                                        width: "70px",
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                        padding: "2px",
                                      }}
                                      defaultValue={item.billRateEscalation}
                                      onChange={(e) =>
                                        onChangeBillRateEscalation(e, item.dlId)
                                      }
                                    />
                                  ) : item.billRateEscalation ? (
                                    item.billRateEscalation < 0 ? (
                                      `(${Math.abs(item.billRateEscalation)}%)`
                                    ) : (
                                      `${item.billRateEscalation}%`
                                    )
                                  ) : (
                                    "0%"
                                  )}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[9],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[9],
                                  }}
                                  title={
                                    item.billRateEscalationDate &&
                                    item.billRateEscalationDate !== ""
                                      ? formatDateBySetting(
                                          new Date(
                                            item.billRateEscalationDate.replace(
                                              /-/g,
                                              "/",
                                            ),
                                          ),
                                          dateFormat,
                                        )
                                      : "NA"
                                  }
                                >
                                  {isEdit ? (
                                    <CustomDatePicker
                                      dateFormat={dateFormat}
                                      dateValue={getDate(
                                        item.billRateEscalationDate,
                                      )}
                                      setDateValue={(date) => {
                                        onChangeBillRateEscalationDate(
                                          date,
                                          item.dlId,
                                        );
                                      }}
                                      classVal="datePickerDetailedView"
                                    />
                                  ) : item.billRateEscalationDate &&
                                    item.billRateEscalationDate !== "" ? (
                                    formatDateBySetting(
                                      new Date(
                                        item.billRateEscalationDate.replace(
                                          /-/g,
                                          "/",
                                        ),
                                      ),
                                      dateFormat,
                                    )
                                  ) : (
                                    "NA"
                                  )}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[10],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[10],
                                  }}
                                  title={item.billRate}
                                >
                                  {convertValuesFM(item.billRate)}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[11],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[11],
                                  }}
                                  title={item.adjustmentBillRate}
                                >
                                  {isEdit ? (
                                    <input
                                      type="text"
                                      style={{
                                        width: "60px",
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                        padding: "2px",
                                      }}
                                      defaultValue={item.adjustmentBillRate}
                                      onChange={(e) =>
                                        onChangeAdjustmentBillRate(e, item.dlId)
                                      }
                                    />
                                  ) : (
                                    convertValuesFM(item.adjustmentBillRate)
                                  )}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[13],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[13],
                                  }}
                                  title={item.adjustedBillRate}
                                >
                                  {convertValuesFM(item.adjustedBillRate)}
                                </td>
                              </>
                            )}
                            {detailedType !== "TM" && (
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.directLabor.secondTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[13],
                                  maxWidth:
                                    detailedViewWidths.directLabor.secondTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[13],
                                }}
                                title={item.billRate}
                              >
                                {isEdit ? (
                                  <input
                                    type="text"
                                    style={{
                                      width: "60px",
                                      border: "1px solid #ccc",
                                      borderRadius: "3px",
                                      padding: "2px",
                                    }}
                                    defaultValue={item.billRate}
                                    onChange={(e) =>
                                      onChangeDataValue(
                                        e,
                                        item.dlId,
                                        "billRate",
                                      )
                                    }
                                  />
                                ) : (
                                  convertValuesFM(item.billRate)
                                )}
                              </td>
                            )}

                            <td
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[14],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[14],
                                paddingLeft: "8px",
                              }}
                              title={
                                item.margin
                                  ? `${
                                      Math.round(item.margin * 100 * 10) / 10
                                    }%`
                                  : `NA`
                              }
                            >
                              <span
                                style={{
                                  padding: "2px 6px",
                                  background: getMarginBackColor(item.margin),
                                  display: "inline-block",
                                  width: "60px",
                                  textAlign: "center",
                                  fontSize: "12px",
                                  borderRadius: "3px",
                                }}
                              >
                                {item.margin
                                  ? item.margin >= 0
                                    ? `${
                                        Math.round(item.margin * 100 * 10) / 10
                                      }%`
                                    : `(${Math.abs(
                                        Math.round(item.margin * 100 * 10) / 10,
                                      )}%)`
                                  : `NA`}
                              </span>
                            </td>
                            {detailedType !== "FFP" && (
                              <>
                                <td
                                  title={item?.billingStatus}
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[15],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[15],
                                  }}
                                >
                                  <TableFilterSelect
                                    selectedValue={item?.billingStatus}
                                    onChangeItem={(e) =>
                                      onChangeDirectLaborReimbursement(
                                        e,
                                        item.odlId || item.dlId,
                                        item,
                                      )
                                    }
                                    labelVal="billable"
                                    id="billable"
                                    items={billableItems}
                                    width="100%"
                                    disabled={!isEdit}
                                  />
                                </td>
                              </>
                            )}
                            <td
                              title={item?.billingStatus}
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[16],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[16],
                              }}
                            >
                              <TableFilterSelect
                                selectedValue={item?.otTypeId}
                                onChangeItem={(e) =>
                                  onChangeOTType(
                                    e,
                                    item.odlId || item.dlId,
                                    item,
                                  )
                                }
                                labelVal="Pay Type"
                                id="otType"
                                items={bindOTTypes()}
                                width="100%"
                                disabled={
                                  !isEdit ||
                                  item.employeeType.toLowerCase() !== "employee"
                                }
                              />
                            </td>
                            <td
                              title={item?.applyBurden}
                              style={{
                                minWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[17],
                                maxWidth:
                                  detailedViewWidths.directLabor.secondTable.filter(
                                    (val) => val.type === detailedType,
                                  )[0].widths[17],
                              }}
                            >
                              <TableFilterSelect
                                selectedValue={item?.applyBurden}
                                onChangeItem={(e) =>
                                  onChangeApplyBurden(
                                    e,
                                    item.odlId || item.dlId,
                                    item,
                                  )
                                }
                                labelVal="Apply Burden"
                                id="applyBurden"
                                items={yesNoDdl}
                                width="100%"
                                disabled={!isEdit || !!item.isIwo}
                              />
                            </td>
                            {item.monthExpenseDetail
                              .filter((val) => val.id || val.isDummy)
                              .map((monthItem, j) => (
                                <>
                                  {!monthItem.isDummy ? (
                                    <>
                                      <td
                                        key={`cost-rate-${monthItem.id}`}
                                        style={{
                                          minWidth:
                                            detailedViewWidths.directLabor.secondTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],
                                          maxWidth:
                                            detailedViewWidths.directLabor.secondTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[0],

                                          borderLeft: "1px solid #ccc",
                                          paddingLeft: "4px",
                                        }}
                                        title={
                                          costRateType === "U"
                                            ? monthItem.costRateUnloaded
                                            : monthItem.costRateLoaded
                                        }
                                      >
                                        {isEdit &&
                                        monthItem.type !== "Actual" &&
                                        costRateType === "U" &&
                                        item.employeeType.toLowerCase() ===
                                          "employee" ? (
                                          <input
                                            type="text"
                                            style={{
                                              width: "70px",
                                              border: "1px solid #ccc",
                                              borderRadius: "3px",
                                              padding: "2px",
                                            }}
                                            value={monthItem.costRateUnloaded}
                                            onChange={(e) =>
                                              onChangeCostRateMonthly(
                                                e,
                                                item,
                                                monthItem,
                                              )
                                            }
                                          />
                                        ) : (
                                          convertValuesFM(
                                            costRateType === "U"
                                              ? monthItem.costRateUnloaded
                                              : monthItem.costRateLoaded,
                                            "",
                                          )
                                        )}
                                      </td>
                                      <td
                                        key={`hours-${monthItem.id}`}
                                        style={{
                                          minWidth:
                                            detailedViewWidths.directLabor.secondTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[1],
                                          maxWidth:
                                            detailedViewWidths.directLabor.secondTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[1],
                                        }}
                                        className={
                                          monthItem.exceedsHours &&
                                          hourType === "H"
                                            ? classes.exceedsHours
                                            : ""
                                        }
                                        title={
                                          hourType === "H"
                                            ? roundTwoDecimals(monthItem.hours)
                                            : roundTwoDecimals(
                                                Number(monthItem.otHours),
                                              )
                                        }
                                      >
                                        {isEdit &&
                                        monthItem.type !== "Actual" ? (
                                          hourType === "H" ? (
                                            <input
                                              type="text"
                                              style={{
                                                width: "70px",
                                                border: "1px solid #ccc",
                                                borderRadius: "3px",
                                                padding: "2px",
                                              }}
                                              id={`hours-${monthItem.dlId}-${monthItem.monthYear}`}
                                              value={monthItem.hours}
                                              onChange={(e) =>
                                                onChangeTotalHours(
                                                  e,
                                                  item.dlId,
                                                  monthItem.id,
                                                )
                                              }
                                            />
                                          ) : (
                                            <input
                                              type="text"
                                              style={{
                                                width: "70px",
                                                border: "1px solid #ccc",
                                                borderRadius: "3px",
                                                padding: "2px",
                                              }}
                                              id={`otHours-${monthItem.dlId}-${monthItem.monthYear}`}
                                              value={
                                                monthItem.otHours
                                                  ? monthItem.otHours
                                                  : 0
                                              }
                                              onChange={(e) =>
                                                onChangeTotalOtHours(
                                                  e,
                                                  item.dlId,
                                                  monthItem.id,
                                                )
                                              }
                                            />
                                          )
                                        ) : (
                                          convertValuesFM(
                                            hourType === "H"
                                              ? monthItem.hours
                                              : monthItem.otHours,
                                            "",
                                          )
                                        )}
                                      </td>
                                      <td
                                        key={`burden-cost-${monthItem.id}`}
                                        title={monthItem.burdenCost}
                                        style={{
                                          minWidth:
                                            detailedViewWidths.directLabor.secondTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[2],
                                          maxWidth:
                                            detailedViewWidths.directLabor.secondTable.filter(
                                              (val) =>
                                                val.type === detailedType,
                                            )[0].widths[2],
                                        }}
                                      >
                                        {`${convertValuesFM(
                                          monthItem.burdenCost,
                                        )}`}
                                      </td>
                                      {detailedType !== "FFP" && (
                                        <td
                                          key={`revenue-${monthItem.id}`}
                                          style={{
                                            minWidth:
                                              detailedViewWidths.directLabor.secondTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[3],
                                            maxWidth:
                                              detailedViewWidths.directLabor.secondTable.filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0].widths[3],
                                          }}
                                          title={monthItem.revenue}
                                        >{`${convertValuesFM(
                                          monthItem.revenue,
                                        )}`}</td>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <td
                                        style={{
                                          borderLeft: "1px solid #ccc",
                                          paddingLeft: "4px",
                                          minWidth:
                                            detailedViewWidths.directLabor.thirdTable
                                              .filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0]
                                              .widths.reduce(
                                                (tot, val) => tot + val,
                                              ),
                                          maxWidth:
                                            detailedViewWidths.directLabor.thirdTable
                                              .filter(
                                                (val) =>
                                                  val.type === detailedType,
                                              )[0]
                                              .widths.reduce(
                                                (tot, val) => tot + val,
                                              ),
                                        }}
                                        colSpan={detailedType !== "FFP" ? 4 : 3}
                                      ></td>
                                    </>
                                  )}
                                </>
                              ))}
                          </tr>
                        );
                      })}

                      <tr className="adjustmentRow">
                        {/* <td colSpan={detailedType === "TM" ? 13 : 10} /> */}
                        <td
                          colSpan={
                            detailedType === "TM"
                              ? 18
                              : detailedType === "Cost Plus"
                                ? 14
                                : 13
                          }
                        />

                        {directLaborCostBind.adjustment
                          .filter(
                            (val) =>
                              (val.id || val.isDummy) &&
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                                0,
                          )
                          .map((item, i) => (
                            <>
                              <td
                                style={{
                                  borderLeft: "1px solid #ccc",
                                  minWidth:
                                    detailedViewWidths.directLabor.secondTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                  maxWidth:
                                    detailedViewWidths.directLabor.secondTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[0],
                                }}
                              />
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.directLabor.secondTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                  maxWidth:
                                    detailedViewWidths.directLabor.secondTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[1],
                                }}
                              />
                              <td
                                style={{
                                  minWidth:
                                    detailedViewWidths.directLabor.secondTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[2],
                                  maxWidth:
                                    detailedViewWidths.directLabor.secondTable.filter(
                                      (val) => val.type === detailedType,
                                    )[0].widths[2],
                                }}
                                title={item.burdenCost}
                                key={`burden-cost-${item.id}`}
                              >
                                {isEdit && item.type !== "Actual" ? (
                                  <input
                                    type="text"
                                    style={{
                                      width: "70px",
                                      border: "1px solid #ccc",
                                      borderRadius: "3px",
                                      padding: "2px",
                                    }}
                                    defaultValue={item.burdenCost}
                                    onChange={(e) =>
                                      onChangeDirectLaborAdjustment(
                                        e,
                                        item.id,
                                        "burdenCost",
                                      )
                                    }
                                  />
                                ) : (
                                  convertValuesFM(item.burdenCost)
                                )}
                              </td>
                              {detailedType !== "FFP" && (
                                <td
                                  title={item.revenue}
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[3],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[3],
                                  }}
                                  key={`revenue-${item.id}`}
                                >
                                  {isEdit && item.type !== "Actual" ? (
                                    <input
                                      type="text"
                                      style={{
                                        width: "70px",
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                        padding: "2px",
                                      }}
                                      defaultValue={item.revenue}
                                      onChange={(e) =>
                                        onChangeDirectLaborAdjustment(
                                          e,
                                          item.id,
                                          "revenue",
                                        )
                                      }
                                    />
                                  ) : (
                                    convertValuesFM(item.revenue)
                                  )}
                                </td>
                              )}
                            </>
                          ))}
                      </tr>
                      <tr className="totalDataRow">
                        {/* <td colSpan={detailedType === "TM" ? 13 : 10} /> */}
                        <td
                          colSpan={
                            detailedType === "TM"
                              ? 18
                              : detailedType === "Cost Plus"
                                ? 14
                                : 13
                          }
                        />

                        {directLaborCostBind.totalDirectLaborCost
                          .filter(
                            (val) =>
                              excludedItemsForMonthly.indexOf(val.monthYear) <
                              0,
                          )
                          .map((item, i) => {
                            const calculatedBurdenCost =
                              calculateTotalDirectLabor(
                                directLaborCostBind,
                                "burdenCost",
                                item.monthYear,
                              );
                            const calculatedHours = calculateTotalDirectLabor(
                              directLaborCostBind,
                              "hours",
                              item.monthYear,
                            );
                            const calculatedOtHours = calculateTotalDirectLabor(
                              directLaborCostBind,
                              "otHours",
                              item.monthYear,
                            );
                            let calculatedRevenueCost = 0;
                            if (detailedType !== "FFP")
                              calculatedRevenueCost = calculateTotalDirectLabor(
                                directLaborCostBind,
                                "revenue",
                                item.monthYear,
                              );
                            return (
                              <>
                                <td
                                  style={{
                                    borderLeft: "1px solid #ccc",
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    paddingLeft: "4px",
                                  }}
                                ></td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={
                                    hourType === "H"
                                      ? calculatedHours
                                      : calculatedOtHours
                                  }
                                >
                                  {convertValuesFM(
                                    hourType === "H"
                                      ? calculatedHours
                                      : calculatedOtHours,
                                    "",
                                  )}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                    maxWidth:
                                      detailedViewWidths.directLabor.secondTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[2],
                                  }}
                                  title={calculatedBurdenCost}
                                >{`${convertValuesFM(
                                  calculatedBurdenCost,
                                )}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[3],
                                      maxWidth:
                                        detailedViewWidths.directLabor.secondTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[3],
                                    }}
                                    title={calculatedRevenueCost}
                                  >{`${convertValuesFM(
                                    calculatedRevenueCost,
                                  )}`}</td>
                                )}
                              </>
                            );
                          })}
                      </tr>
                    </tbody>
                  </table>
                </Box>
                <Box
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                  }}
                >
                  <table
                    className="thirdTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        <th
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth: detailedViewWidths.directLabor.fourtTable
                              .filter((val) => val.type === detailedType)[0]
                              .widths.reduce((tot, val) => tot + val),
                            maxWidth: detailedViewWidths.directLabor.fourtTable
                              .filter((val) => val.type === detailedType)[0]
                              .widths.reduce((tot, val) => tot + val),
                          }}
                          colSpan={detailedType === "FFP" ? 2 : 3}
                        >
                          ITD from 2025
                        </th>
                        <th
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth: detailedViewWidths.directLabor.fourtTable
                              .filter((val) => val.type === detailedType)[0]
                              .widths.reduce((tot, val) => tot + val),
                            maxWidth: detailedViewWidths.directLabor.fourtTable
                              .filter((val) => val.type === detailedType)[0]
                              .widths.reduce((tot, val) => tot + val),
                          }}
                          colSpan={detailedType === "FFP" ? 2 : 3}
                        >
                          Remaining Forecast
                        </th>
                        <th
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth: detailedViewWidths.directLabor.fourtTable
                              .filter((val) => val.type === detailedType)[0]
                              .widths.reduce((tot, val) => tot + val),
                            maxWidth: detailedViewWidths.directLabor.fourtTable
                              .filter((val) => val.type === detailedType)[0]
                              .widths.reduce((tot, val) => tot + val),
                          }}
                          colSpan={detailedType === "FFP" ? 2 : 3}
                        >
                          Total
                        </th>
                      </tr>
                      <tr>
                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                          className="actualHeaderCost "
                        >
                          Total Hours
                        </th>
                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                            maxWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                          }}
                          className="actualHeaderCost "
                        >
                          Total Burden Cost
                        </th>
                        {detailedType !== "FFP" && (
                          <th
                            style={{
                              minWidth:
                                detailedViewWidths.directLabor.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                              maxWidth:
                                detailedViewWidths.directLabor.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                            }}
                            className="actualHeaderCost"
                          >
                            Total Revenue
                          </th>
                        )}

                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                          className="forecastHeaderCost "
                        >
                          Total Hours
                        </th>
                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                            maxWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                          }}
                          className="forecastHeaderCost "
                        >
                          Total Burden Cost
                        </th>
                        {detailedType !== "FFP" && (
                          <th
                            style={{
                              minWidth:
                                detailedViewWidths.directLabor.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                              maxWidth:
                                detailedViewWidths.directLabor.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                            }}
                            className="forecastHeaderCost"
                          >
                            Total Revenue
                          </th>
                        )}

                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                            maxWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[0],
                          }}
                          className="forecastHeaderCost "
                        >
                          Total Hours
                        </th>
                        <th
                          style={{
                            minWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                            maxWidth:
                              detailedViewWidths.directLabor.fourtTable.filter(
                                (val) => val.type === detailedType,
                              )[0].widths[1],
                          }}
                          className="forecastHeaderCost "
                        >
                          Total Burden Cost
                        </th>
                        {detailedType !== "FFP" && (
                          <th
                            style={{
                              minWidth:
                                detailedViewWidths.directLabor.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                              maxWidth:
                                detailedViewWidths.directLabor.fourtTable.filter(
                                  (val) => val.type === detailedType,
                                )[0].widths[2],
                            }}
                            className="forecastHeaderCost"
                          >
                            Total Revenue
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDirectLabor.map((item) => (
                        <tr>
                          {item.monthExpenseDetail
                            .filter((val) => val.monthYear === "ITD")
                            .map((bindItem, i) => {
                              const otherActualsItem =
                                item.monthExpenseDetail.filter(
                                  (value) =>
                                    value.monthYear === "Other Year Actual",
                                )[0];
                              let otherYearHours = 0;
                              let otherYearCost = 0;
                              let otherYearRevenue = 0;
                              if (otherActualsItem) {
                                otherYearHours =
                                  otherActualsItem.hours +
                                  Number(otherActualsItem.otHours);
                                otherYearCost = otherActualsItem.burdenCost;
                                otherYearRevenue = otherActualsItem.revenue;
                              }
                              return (
                                <>
                                  <td
                                    style={{
                                      paddingLeft: "4px",
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={roundTwoDecimals(
                                      bindItem.hours +
                                        Number(bindItem.otHours) +
                                        otherYearHours,
                                    )}
                                  >
                                    {convertValuesFM(
                                      bindItem.hours +
                                        Number(bindItem.otHours) +
                                        otherYearHours,
                                      "",
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={bindItem.burdenCost + otherYearCost}
                                  >{`${convertValuesFM(
                                    bindItem.burdenCost + otherYearCost,
                                  )}`}</td>
                                  {detailedType !== "FFP" && (
                                    <td
                                      style={{
                                        minWidth:
                                          detailedViewWidths.directLabor.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                        maxWidth:
                                          detailedViewWidths.directLabor.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                      }}
                                      title={
                                        bindItem.revenue + otherYearRevenue
                                      }
                                    >{`${convertValuesFM(
                                      bindItem.revenue + otherYearRevenue,
                                    )}`}</td>
                                  )}
                                </>
                              );
                            })}
                          {item.monthExpenseDetail
                            .filter(
                              (val) => val.monthYear === "Remaining Forecast",
                            )
                            .map((bindItem, i) => {
                              const calculatedHoursVal =
                                calculateRemainingForecastDirectLabor(
                                  directLaborCostBind,
                                  "hours",
                                  item.dlId,
                                ) +
                                calculateRemainingForecastDirectLabor(
                                  directLaborCostBind,
                                  "otHours",
                                  item.dlId,
                                );
                              const calculatedBurdenCostVal =
                                calculateRemainingForecastDirectLabor(
                                  directLaborCostBind,
                                  "burdenCost",
                                  item.dlId,
                                );
                              let calculatedRevenueVal = 0;
                              if (detailedType !== "FFP")
                                calculatedRevenueVal =
                                  calculateRemainingForecastDirectLabor(
                                    directLaborCostBind,
                                    "revenue",
                                    item.dlId,
                                  );
                              return (
                                <>
                                  <td
                                    style={{
                                      borderLeft: "1px solid #ccc",
                                      paddingLeft: "4px",
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={roundTwoDecimals(calculatedHoursVal)}
                                  >
                                    {convertValuesFM(calculatedHoursVal, "")}
                                  </td>
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={calculatedBurdenCostVal}
                                  >{`${convertValuesFM(
                                    calculatedBurdenCostVal,
                                  )}`}</td>
                                  {detailedType !== "FFP" && (
                                    <td
                                      title={calculatedRevenueVal}
                                    >{`${convertValuesFM(
                                      calculatedRevenueVal,
                                    )}`}</td>
                                  )}
                                </>
                              );
                            })}
                          {item.monthExpenseDetail
                            .filter((val) => val.monthYear === "Total")
                            .map((bindItem, i) => {
                              const totalHoursVal =
                                calculateItemTotalDirectLabor(
                                  directLaborCostBind,
                                  "hours",
                                  item.dlId,
                                ) +
                                calculateItemTotalDirectLabor(
                                  directLaborCostBind,
                                  "otHours",
                                  item.dlId,
                                );
                              const totalBurdenCostVal =
                                calculateItemTotalDirectLabor(
                                  directLaborCostBind,
                                  "burdenCost",
                                  item.dlId,
                                );
                              let totalRevenueVal = 0;
                              if (detailedType !== "FFP")
                                totalRevenueVal = calculateItemTotalDirectLabor(
                                  directLaborCostBind,
                                  "revenue",
                                  item.dlId,
                                );
                              return (
                                <>
                                  <td
                                    style={{
                                      borderLeft: "1px solid #ccc",
                                      paddingLeft: "4px",
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[0],
                                    }}
                                    title={roundTwoDecimals(totalHoursVal)}
                                  >
                                    {convertValuesFM(totalHoursVal, "")}
                                  </td>
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[1],
                                    }}
                                    title={totalBurdenCostVal}
                                  >{`${convertValuesFM(
                                    totalBurdenCostVal,
                                  )}`}</td>
                                  {detailedType !== "FFP" && (
                                    <td
                                      style={{
                                        minWidth:
                                          detailedViewWidths.directLabor.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                        maxWidth:
                                          detailedViewWidths.directLabor.fourtTable.filter(
                                            (val) => val.type === detailedType,
                                          )[0].widths[2],
                                      }}
                                      title={totalRevenueVal}
                                    >{`${convertValuesFM(
                                      totalRevenueVal,
                                    )}`}</td>
                                  )}
                                </>
                              );
                            })}
                        </tr>
                      ))}
                      <tr className="adjustmentRow">
                        {directLaborCostBind.adjustment
                          .filter((val) => val.monthYear === "ITD")
                          .map((item, i) => {
                            const otherActualsItem =
                              directLaborCostBind.adjustment.filter(
                                (value) =>
                                  value.monthYear === "Other Year Actual",
                              )[0];
                            let otherYearCost = 0;
                            let otherYearRevenue = 0;
                            if (otherActualsItem) {
                              otherYearCost = otherActualsItem.burdenCost;
                              otherYearRevenue = otherActualsItem.revenue;
                            }
                            return (
                              <>
                                <td
                                  style={{
                                    paddingLeft: "4px",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={item.burdenCost + otherYearCost}
                                >{`${convertValuesFM(
                                  item.burdenCost + otherYearCost,
                                )}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={item.revenue + otherYearRevenue}
                                  >{`${convertValuesFM(
                                    item.revenue + otherYearRevenue,
                                  )}`}</td>
                                )}
                              </>
                            );
                          })}
                        {directLaborCostBind.adjustment
                          .filter(
                            (val) => val.monthYear === "Remaining Forecast",
                          )
                          .map((item, i) => {
                            const totaBurdenCost =
                              calculateRemainingForecastDirectLaborAdjustment(
                                directLaborCostBind,
                                "burdenCost",
                              );
                            let totaRevenue = 0;
                            if (detailedType !== "FFP")
                              totaRevenue =
                                calculateRemainingForecastDirectLaborAdjustment(
                                  directLaborCostBind,
                                  "revenue",
                                );
                            return (
                              <>
                                <td
                                  style={{
                                    borderLeft: "1px solid #ccc",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totaBurdenCost}
                                >{`${convertValuesFM(totaBurdenCost)}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={totaRevenue}
                                  >{`${convertValuesFM(totaRevenue)}`}</td>
                                )}
                              </>
                            );
                          })}
                        {directLaborCostBind.adjustment
                          .filter((val) => val.monthYear === "Total")
                          .map((item, i) => {
                            const totaBurdenCost =
                              calculateItemTotalDirectLaborAdjustment(
                                directLaborCostBind,
                                "burdenCost",
                              );
                            let totaRevenue = 0;
                            if (detailedType !== "FFP")
                              totaRevenue =
                                calculateItemTotalDirectLaborAdjustment(
                                  directLaborCostBind,
                                  "revenue",
                                );
                            return (
                              <>
                                <td
                                  style={{
                                    borderLeft: "1px solid #ccc",
                                  }}
                                />
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totaBurdenCost}
                                >{`${convertValuesFM(totaBurdenCost)}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={totaRevenue}
                                  >{`${convertValuesFM(totaRevenue)}`}</td>
                                )}
                              </>
                            );
                          })}
                      </tr>
                      <tr className="totalDataRow">
                        {directLaborCostBind.totalDirectLaborCost
                          .filter((val) => val.monthYear === "ITD")
                          .map((item, i) => {
                            const otherActualsItem =
                              directLaborCostBind.totalDirectLaborCost.filter(
                                (value) =>
                                  value.monthYear === "Other Year Actual",
                              )[0];
                            let otherYearCost = 0;
                            let otherYearRevenue = 0;
                            if (otherActualsItem) {
                              otherYearCost = otherActualsItem.burdenCost;
                              otherYearRevenue = otherActualsItem.revenue;
                            }
                            return (
                              <>
                                <td
                                  style={{
                                    paddingLeft: "4px",
                                    minWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                  }}
                                  title={calculateTotalHours(
                                    directLaborCostBind,
                                    "actual",
                                  )}
                                >
                                  {convertValuesFM(
                                    calculateTotalHours(
                                      directLaborCostBind,
                                      "actual",
                                    ),
                                    "",
                                  )}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={item.burdenCost + otherYearCost}
                                >{`${convertValuesFM(
                                  item.burdenCost + otherYearCost,
                                )}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={item.revenue + otherYearRevenue}
                                  >{`${convertValuesFM(
                                    item.revenue + otherYearRevenue,
                                  )}`}</td>
                                )}
                              </>
                            );
                          })}
                        {directLaborCostBind.totalDirectLaborCost
                          .filter(
                            (val) => val.monthYear === "Remaining Forecast",
                          )
                          .map((item, i) => {
                            const totaBurdenCost =
                              calculateRemainingForecastDirectLaborTotal(
                                directLaborCostBind,
                                "burdenCost",
                              );
                            let totaRevenue = 0;
                            if (detailedType !== "FFP")
                              totaRevenue =
                                calculateRemainingForecastDirectLaborTotal(
                                  directLaborCostBind,
                                  "revenue",
                                );
                            return (
                              <>
                                <td
                                  style={{
                                    paddingLeft: "4px",
                                    minWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                  }}
                                  title={calculateTotalHours(
                                    directLaborCostBind,
                                    "forecast",
                                  )}
                                >
                                  {convertValuesFM(
                                    calculateTotalHours(
                                      directLaborCostBind,
                                      "forecast",
                                    ),
                                    "",
                                  )}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totaBurdenCost}
                                >{`${convertValuesFM(totaBurdenCost)}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={totaRevenue}
                                  >{`${convertValuesFM(totaRevenue)}`}</td>
                                )}
                              </>
                            );
                          })}
                        {directLaborCostBind.totalDirectLaborCost
                          .filter((val) => val.monthYear === "Total")
                          .map((item, i) => {
                            const totaBurdenCost =
                              calculateItemTotalDirectLaborTotal(
                                directLaborCostBind,
                                "burdenCost",
                              );
                            let totaRevenue = 0;
                            if (detailedType !== "FFP")
                              totaRevenue = calculateItemTotalDirectLaborTotal(
                                directLaborCostBind,
                                "revenue",
                              );
                            const totalHoursVal =
                              calculateTotalHours(
                                directLaborCostBind,
                                "actual",
                              ) +
                              calculateTotalHours(
                                directLaborCostBind,
                                "forecast",
                              );
                            return (
                              <>
                                <td
                                  style={{
                                    paddingLeft: "4px",
                                    minWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    maxWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[0],
                                    borderLeft: "1px solid #ccc",
                                  }}
                                  title={totalHoursVal}
                                >
                                  {convertValuesFM(totalHoursVal, "")}
                                </td>
                                <td
                                  style={{
                                    minWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                    maxWidth:
                                      detailedViewWidths.directLabor.fourtTable.filter(
                                        (val) => val.type === detailedType,
                                      )[0].widths[1],
                                  }}
                                  title={totaBurdenCost}
                                >{`${convertValuesFM(totaBurdenCost)}`}</td>
                                {detailedType !== "FFP" && (
                                  <td
                                    style={{
                                      minWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                      maxWidth:
                                        detailedViewWidths.directLabor.fourtTable.filter(
                                          (val) => val.type === detailedType,
                                        )[0].widths[2],
                                    }}
                                    title={totaRevenue}
                                  >{`${convertValuesFM(totaRevenue)}`}</td>
                                )}
                              </>
                            );
                          })}
                      </tr>
                    </tbody>
                  </table>
                </Box>
              </Box>
            </Box>
          </Box>
          <PaginationData
            data={directLaborCostBind.getDirectLaborDetailList}
            setFilteredData={setFilteredDirectLabor}
            search={search}
            searchLcat={searchLcat}
            sortDirection={directLaborSort.direction}
            sortKey={directLaborSort.key}
            alwaysShow
          />
        </Box>
      );
    } else {
      return (
        <div
          style={{
            textAlign: "center",
            fontWeight: 600,
            background: "#fff",
            padding: "24px 0",
          }}
        >
          {!isEdit &&
          getVersionStatus.toLowerCase() === "open" &&
          localStorage.getItem("accessType") === "RW" ? (
            <span
              style={{
                cursor: "pointer",
                color: "#09659c",
                fontWeight: 600,
              }}
              onClick={() => handleAddNewDirectLabor()}
            >
              + Add New Resource
            </span>
          ) : (
            `No Data`
          )}
        </div>
      );
    }
  };

  return (
    <div>
      {detailedViewRatesData && detailedViewRatesData.status === 200 && (
        <Grid container spacing={2} style={{ marginTop: "16px" }}>
          <Grid item lg={8}>
            {/* <Box
              display="flex"
              flexDirection="row"
              style={{ marginTop: "8px" }}
            >
              {detailedType === "Cost Plus" && (
                <>
                  {" "}
                  <Box className={classes.headDataLabel}>Fee - Labor</Box>
                  {isEditFee ? (
                    <Box className={classes.headDataTextBox}>
                      <input
                        type="text"
                        style={{
                          width: "90px",
                          padding: "4px",
                          border: "1px solid #6e6d6d",
                          borderRadius: "5px",
                          height: "32px",
                        }}
                        value={feeLabor}
                        onChange={(e) => onChangeFeeLabor(e)}
                      />
                    </Box>
                  ) : (
                    <Box className={classes.headDataValue}>{feeLabor}%</Box>
                  )}
                </>
              )}

              <Box className={classes.headDataLabel}>Fee - Non Labor</Box>
              {isEditFee ? (
                <Box className={classes.headDataTextBox}>
                  <input
                    type="text"
                    style={{
                      width: "90px",
                      padding: "4px",
                      border: "1px solid #6e6d6d",
                      borderRadius: "5px",
                      height: "32px",
                    }}
                    value={nonLaborPer}
                    onChange={(e) => onChangeFeeNonLabor(e)}
                  />
                </Box>
              ) : (
                <Box className={classes.headDataValue}>{nonLaborPer}%</Box>
              )}
              <Box className={classes.headDataLabel}>Fee - Sub Con</Box>
              {isEditFee ? (
                <Box className={classes.headDataTextBox}>
                  <input
                    type="text"
                    style={{
                      width: "90px",
                      padding: "4px",
                      border: "1px solid #6e6d6d",
                      borderRadius: "5px",
                      height: "32px",
                    }}
                    value={feeSubcon}
                    onChange={(e) => onChangeFeeSubCon(e)}
                  />
                </Box>
              ) : (
                <Box className={classes.headDataValue}>{feeSubcon}%</Box>
              )}
              {detailedType !== "TM" && (
                <Box style={{ paddingTop: "6px" }}>
                  {!isEditFee ? (
                    <>
                      <div
                        className={classes.editBtn}
                        onClick={handleClickEditFee}
                        style={{ marginTop: "-2px" }}
                      >
                        <EditIcon className={classes.editIcon} />
                        <span className={classes.editText}>Edit</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <span
                        className={classes.saveBtn}
                        onClick={onSaveClickFee}
                      >
                        <span className={classes.editText}>Save</span>
                      </span>
                      <span
                        className={classes.cancelBtn}
                        onClick={onCancelClickFee}
                      >
                        <span className={classes.editText}>Cancel</span>
                      </span>
                    </>
                  )}
                </Box>
              )}
            </Box>*/}
            <span
              style={{
                fontWeight: 600,
                color: "#09659c",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={handleClickViewRates}
            >
              View Rates
            </span>
            <input
              placeholder="Search by CLIN"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                marginLeft: "12px",
                height: "32px",
                padding: "4px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "250px",
              }}
            />
            <input
              placeholder="Search by LCAT"
              value={searchLcat}
              onChange={(e) => setSearchLcat(e.target.value)}
              style={{
                marginLeft: "12px",
                height: "32px",
                padding: "4px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "250px",
              }}
            />
          </Grid>
          <Grid item lg={4}>
            <Box
              display="flex"
              flexDirection="row"
              style={{
                float: "right",
                border: "1px solid #6e6d6d",
                borderRadius: "5px",
                height: "48px",
              }}
            >
              {/* <Box
                style={{
                  width: "120px",
                  fontWeight: 600,
                  textAlign: "center",
                  alignContent: "center",
                  borderRight: "1px solid #6e6d6d",
                }}
              >
                <CustomSelect
                  selectedValue={year}
                  onChangeItem={onChangeYear}
                  labelVal="Year"
                  id="Year"
                  items={bindYears()}
                  width="100px"
                  borderColor="#000"
                />
              </Box> */}
              <Box
                style={{
                  width: "200px",
                  fontWeight: 600,
                  textAlign: "center",
                  alignContent: "center",
                  borderRight: "1px solid #6e6d6d",
                }}
              >
                {detailedViewRatesData.data.year} Forecasted Rates
              </Box>
              {/*<Box
                style={{
                  width: "100px",
                  fontWeight: 600,
                  textAlign: "center",
                  alignContent: "center",
                  borderRight: "1px solid #6e6d6d",
                }}
              >
                2025 Rates
              </Box>*/}
              <Box className={classes.metaData}>
                <div>Fringe</div>
                <div>{detailedViewRatesData.data.fringe}%</div>
              </Box>
              <Box className={classes.metaData}>
                <div>OH</div>
                <div>{detailedViewRatesData.data.oh}%</div>
              </Box>
              <Box className={classes.metaData}>
                <div>SM&H</div>
                <div>{detailedViewRatesData.data.smAndH}%</div>
              </Box>
              <Box className={classes.metaData}>
                <div>G&A</div>
                <div>{gaRate}%</div>
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}

      {((marginBind &&
        marginBind.total &&
        marginBind.total.length > 0 &&
        marginBind.netProfit &&
        marginBind.netProfit.length > 0) ||
        (revenueBind &&
          revenueBind.revenueDetailList &&
          revenueBind.revenueDetailList.length > 0) ||
        (directLaborCostBind &&
          directLaborCostBind.getDirectLaborDetailList &&
          directLaborCostBind.getDirectLaborDetailList.length > 0) ||
        (otherDirectCostBind &&
          otherDirectCostBind.otherDirectLabourDetailList &&
          otherDirectCostBind.otherDirectLabourDetailList.length > 0)) &&
        detailedViewRatesData &&
        (detailedViewRatesData.status === 200 ||
          detailedViewRatesData.status === 400) && (
          <>
            <Grid container style={{ marginTop: "16px" }}>
              <Grid item lg={6}>
                <div className={classes.tableTitle}>Revenue</div>
              </Grid>
              <Grid item lg={6}>
                <Box
                  display="flex"
                  flexDirection="row"
                  style={{
                    float: "right",
                  }}
                >
                  <Box className={classes.statusLabel}>High</Box>
                  <Box className={classes.highStatus}></Box>
                  <Box className={classes.statusLabel}>Medium</Box>
                  <Box className={classes.mediumStatus}></Box>
                  <Box className={classes.statusLabel}>Low</Box>
                  <Box className={classes.lowStatus}></Box>
                  <Box>
                    {getVersionStatus.toLowerCase() === "open" &&
                      localStorage.getItem("accessType") === "RW" && (
                        <>
                          {!isEdit ? (
                            <>
                              <div
                                className={classes.editBtn}
                                onClick={handleClickEdit}
                                style={{ marginTop: "-6px" }}
                              >
                                <EditIcon className={classes.editIcon} />
                                <span className={classes.editText}>Edit</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <span
                                className={classes.saveBtn}
                                onClick={() => onSaveClick(false)}
                              >
                                <span className={classes.editText}>Save</span>
                              </span>
                              <span
                                className={classes.cancelBtn}
                                onClick={onCancelClick}
                              >
                                <span className={classes.editText}>Cancel</span>
                              </span>
                            </>
                          )}
                        </>
                      )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
            {bindRevenueTable()}
            <Grid container spacing={2} style={{ marginTop: "0" }}>
              <Grid item lg={6}>
                <div
                  className={classes.tableTitle}
                  style={{ marginTop: "16px" }}
                >
                  Direct Labor
                </div>
              </Grid>
              <Grid item lg={6}>
                <Select
                  showSearch
                  mode="single"
                  style={{
                    width: "150px",
                    zIndex: 9,
                    float: "right",
                    marginTop: "12px",
                    marginLeft: "4px",
                  }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  options={hourTypes}
                  onChange={(val) => setHourType(val)}
                  value={hourType}
                />
                <Select
                  showSearch
                  mode="single"
                  style={{
                    width: "180px",
                    zIndex: 9,
                    float: "right",
                    marginTop: "12px",
                  }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  options={costRateTypes}
                  onChange={(val) => setCostRateType(val)}
                  value={costRateType}
                />
                <div
                  style={{
                    float: "right",
                    fontWeight: 600,
                    margin: "18px 6px 0 0",
                  }}
                >
                  Show:
                </div>
              </Grid>
            </Grid>
            {bindDirectLaborTable()}
            <Grid container spacing={2} style={{ marginTop: "16px" }}>
              <Grid item lg={6}>
                <div className={classes.tableTitle}>Other Direct Costs</div>
              </Grid>
              <Grid item lg={6}></Grid>
            </Grid>

            {bindOtherDirectCostsTable()}
            <div className={classes.tableTitle} style={{ marginTop: "16px" }}>
              Margin
            </div>
            {bindMarginTable()}
          </>
        )}
      {isDialogOpen && (
        <ConfirmationDialog
          cancelClick={cancelConfirmClick}
          okClick={okConfirmClick}
          confirmText="Do you want to delete this item?"
          closeDialog={() => setIsDialogOpen(false)}
        />
      )}
      {isDialogOpenODC && (
        <ConfirmationDialog
          cancelClick={cancelConfirmClickODC}
          okClick={okConfirmClickODC}
          confirmText="Do you want to delete this item?"
          closeDialog={() => setIsDialogOpenODC(false)}
        />
      )}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
    </div>
  );
};

export default CostPlus;
